import { Model } from 'app/model/backendmodel';
import { FormatDatasetV2 } from 'app/model/dataset/dataset.v2';
import { HdfsStoreReadSettings } from './copysource/store-read-settings/hdfs-store-read-settings';
import { BlobTypeStoreReadSettings } from 'app/model/pipeline/copysource/store-read-settings/blob-type-store-read-settings';
import {
    fileFilterIsNull,
    getRuntimeSelfHostedIR,
    getWildcardValue,
    isWildCardPathMode,
    modifiedTimeIsNull,
    prefixPathIsNull,
    validateActivitySupportability,
    validateCompressionForDelimitedText,
    validateCopySource,
    validateDelimiterForDelimitedText,
    validateEntityParameters,
    validateIR,
    validatePathInStagingAndLoggingSettings,
    validateSourceDataset
} from 'app/shared/utils/activity-validation.util';
import { Column } from 'app/model/dataset/column';
import { NamedArray } from 'app/model/base/namedarray';
import { IViolation, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { Activity } from './activity';

import { Dataset } from 'app/model/dataset/dataset';
import { CopySource } from './copysource/copysource';
import { CopySink } from './copysink/copysink';
import { StagingSettings } from 'app/model/pipeline/staging-settings';
import { ParameterValue } from 'app/model/base/parameter-value';
import { FaultTolerenceSettings } from 'app/model/pipeline/fault-tolerence-setting';
import { Owned } from 'app/model/base/named';
import { FileTypeDataset, isDatasetWithoutFileFormat } from 'app/model/dataset/file-type.dataset';
import { SelfHostedIntegrationRuntime } from 'app/model/integrationRuntime/selfhosted.integrationRuntime';
import {
    isNotCompatibleColumnType,
    checkTypeConversionCompatibility,
    ColumnPhysicalType
} from 'app/shared/utils/column-type.util';
import { Office365Dataset } from '../dataset/office365.dataset';
import { fileFormats, rowDelimiters, charValueConst } from 'app/shared/components/fileformat/fileformat.constants';
import { UserPropertiesService } from 'app/services/activity-user-properties.service';
import { ModelUtilties } from 'app/model/services/model-utilities';
import { concatStyleExpression, isLogicAppExpression } from 'app/shared/utils/expression.util';
import { isDatabricksFamilyDataset, getDatabricksFamilyDisplayName } from 'app/shared/utils/databricks-dataset.util';
import {
    AvroDataset,
    AzureAuthTypes,
    AzureBlobFSLinkedService,
    AzureBlobStorageLinkedService,
    AzureBlobStorageLocation,
    azureStorageAuthTypes,
    AzureStorageLinkedService,
    Collection,
    compressionCodecType,
    DelimitedTextDataset,
    DeltaDataset,
    HierarchicalNode,
    IModel,
    IValidationContext,
    JsonDataset,
    LakehouseLinkedService,
    LinkedService,
    ModelConstants,
    ParquetDataset,
    UserProperty,
    snowflakeSupportedDelimitedSourceEncodingName,
    snowflakeSupportedSinkEncodingName,
    TabularTypeDataset,
    validateLinkedServicePermission,
    Encoding,
    snowflakeSupportedJSONSourceEncodingName,
    AdapterContext,
    azureBlobFSAuthTypes,
    SalesforceV2Dataset,
    SnowflakeTableDataset,
    SnowflakeSource,
    SnowflakeV2Source,
    SnowflakeV2Sink,
    ImportExportSettings,
    artifactDmtsCredentialAuthTypes,
    LakehouseTableDataset,
    EventStreamDataset
} from 'shell-models-lib';
import { LinkedServiceRegistryService } from 'app/registries/linked-service/linked-service-registry.service';
import { AzureDataLakeStoreLinkedService } from '../linkedservice/azure-data-lake-store.linkedservice';
import { DatasetRegistryService } from 'app/registries/dataset/dataset-registry.service';
import {
    stringIsNullOrEmpty,
    format,
    parseJsonPath,
    stringsAreEqualCaseInsensitive,
    sanitizeAndFormatString,
    formatListWithConjunction
} from 'app/shared/utils/string.util';
import { SqlSink } from './copysink/sql.copysink';
import { ValueAdapter } from '../adapters/value.adapter';
import { SqlDWSink } from './copysink/sqldw.copysink';
import { TextFormat } from '../dataset/text-format';
import { compressionOptionValues } from 'app/shared/components/compression-setting/compression-options';
import { AuthenticationType } from 'app/interfaces/IAuthenticationType';
import { AzureBlobDataset } from '../dataset/azure-blob.dataset';
import { AzureDataLakeStoreFileDataset } from '../dataset/azure-data-lake-store.dataset';
import { AzureBlobFSDataset } from '../dataset/azure-blob-fs.dataset';
import { AmazonRedshiftCopySource } from './copysource/amazon-redshift.copysource';
import { ColumnMappingPair } from './mappingpair';
import { GlobalVariables } from 'app/services/globals';
import { isDeltaCloneCopy } from 'app/authoring/copy-job/wizard/copy-job-delta.util';
import {
    isBinaryTypeDataset,
    datasetIsFile,
    isFileTypeDataset,
    isAEPDataset,
    datasetWithZipDeflateCompression,
    datasetWithTarGZipCompression,
    datasetWithTarCompression
} from 'app/shared/utils/dataset-validation.util';
import { Constants } from 'app/shared/shared-constants';
import { FormatTypeCopySource } from './copysource/format-type.copysource';
import {
    validateIRVersion,
    trinoSHIRVersion,
    oracleV2PrecisionAndScaleVersion
} from 'app/shared/utils/version.check.util';
import { tableOptionValues, FilePathMode, partitionOptionConst } from 'app/registries/consts/metadata-consts';
import { BinaryDataset } from '../dataset/binary.dataset';
import { valueAndExpressionValueBothEmpty, extractParametersFromResource } from 'app/shared/utils/parameter.util';
import { AmazonS3Location } from '../dataset/location/amazon-s3.location';
import { OracleCloudStorageLocation } from '../dataset/location/oracle-cloud-storage.location';
import { copyMethodOptionValues } from 'app/shared/components/copy-method-setting/copy-method-setting.const';
import { OrcDataset } from '../dataset/orc.dataset';
import { DelimitedTextCopySource } from './copysource/delimitedtext.source';
import { arrayIsNullOrEmpty, mergeSourceSinkToDataset } from 'app/registries/utls/util';
import { AmazonS3LinkedService } from '../linkedservice/amazon-s3.linkedservice';
import { TypeConversionSettings } from './type-conversion-settings';
import { ExcelDataset } from '../dataset/excel.dataset';
import { SqlTypeCopySource } from './copysource/sql-type.copysource';
import { SqlDWCopySource } from './copysource/sqldw.copysource';
import { SqlCopySource } from './copysource/sql.copysource';
import { DelimitedTextFormatReadSettings } from './copysource/format-read-settings/delimited-text-format-read-settings';
import { hasTableNameOrTable } from '../dataset/tabular-type-utils';
import {
    dataConsistencySourceLinkedServiceTypes,
    dataConsistencySinkLinkedServiceTypes,
    skipForbiddenFilesSourceLinkedServiceTypes,
    skipFilesWithInvalidNamesSinkLinkedServiceTypes,
    skipFilesWithInvalidNamesSourceLinkedServiceTypes,
    adfModelTypeMap
} from 'app/registries/consts/adf-model-type-map-const';
import { copyBehaviorOptionValues } from 'app/shared/constants/copy-behavior.const';
import { AUTHENTICATION_TYPE_TEXTS } from 'app/shared/constants/texts.const';
import { BinaryCopySource } from './copysource/binary.source';
import { HttpServerLinkedService } from '../linkedservice/http-server.linkedservice';
import { JsonFormatWriteSettings } from './copysink/format-write-settings/json-format-write-settings';
import { QueryApiFactoryService } from 'app/apis/query-api.factory.service';
import { TabularCopySource } from './copysource/tabular-type.copysource';
import { LoggingSettings } from './logging-settings';
import { FormatTypeCopySink } from './copysink/format-type.copysink';
import { ParquetFormatWriteSettings } from './copysink/format-write-settings/parquet-format-write-settings';
import { DelimitedTextFormatWriteSettings } from './copysink/format-write-settings/delimited-text-format-write-settings';
import { AvroFormatWriteSettings } from './copysink/format-write-settings/avro-format-write-settings';
import { OrcFormatWriteSettings } from './copysink/format-write-settings/orc-format-write-settings';
import { AzureBlobReadSettings } from './copysource/store-read-settings/azure-blob-read-settings';
import { S3StoreReadSettings } from './copysource/store-read-settings/s3-store-read-settings';
import { FileServerStoreReadSettings } from './copysource/store-read-settings/file-server-store-read-settings';
import { FormatWriteSettings } from './copysink/format-write-settings/format-write-settings';
import { StoreWriteSettings } from './copysink/store-write-settings/store-write-settings';
import { LoggingLocation } from './logging-location';
import { ConnectionRoleType, isTableNameRequired, supportEditPhysicalType } from 'app/shared/utils/dataset-utils';
import { writeBehaviorOptionValues } from 'app/shared/constants/write-behavior.const';
import { SapOdpCopySource } from 'app/model/pipeline/copysource/sap-odp.copysource';
import { SapOdpDataset } from 'app/model/dataset/sap-odp.dataset';
import { SapOdpLinkedService } from 'app/model/linkedservice/sap-odp.linkedservice';
import { DeltaFormatWriteSettings } from './copysink/format-write-settings/delta-format-write-settings';
import { LakehouseLocation } from '../dataset/location/lakehouse.location';
import { TrinoCopySource } from './copysource/trino.copysource';
import { intersection } from 'lodash';
import { LakehouseTableCopySource } from './copysource/lakehouse-table.copysource';
import { LakehouseTableCopySink, supportedSourceDatasetsForTimestampNtz } from './copysink/lakehouse-table.copysink';
import { dataWarehouseAllowedSourceAuthTypes } from 'app/registries/consts/sql-const';
import { getServiceInstance } from 'app/multi-contexts/modules/root/root.application';
import { IResourceContext } from 'app/multi-contexts/resource-context.typings';
import { ExposureControlService } from 'app/services/exposure-control/base-exposure-control.service';
import { Office365CopySource } from './copysource/office365.copysource';
import { ColumnFlattenSettings } from './column-flatten-settings';
import { DataWarehouseCopySink } from './copysink/data-warehouse.copysink';
import { AmazonS3CompatibleLocation } from '../dataset/location/amazon-s3-compatible.location';
import { GoogleCloudStorageLocation } from '../dataset/location/google-cloud-storage.location';
import {
    validateDelimitedTextDatasetForTeradata,
    validateParquetDatasetForTeradata,
    validateSourceAuthTypesForTeradata,
    validateSourceSettingsForTeradata
} from 'app/shared/utils/copy-validation/teradata-validation.util';
import {
    getConnectionAsSinkDirectCopyErrorMessage,
    getConnectionAsSourceDirectCopyErrorMessage,
    getDirectCopyErrorMessage,
    getCopyCommandErrorMessage,
    formatSQLDWMessage,
    getSnowflakeCopyMethodValidationMessage
} from 'app/shared/utils/activity-validation-message.util';
import { TeradataDataset } from '../dataset/teradata.dataset';
import { TeradataLinkedService } from '../linkedservice/teradata.linkedservice';
import { driverVersions } from 'app/registries/consts/tabular-consts';
import { OracleCopySource } from './copysource/oracle.copysource';
import { getLogicalTypeByPhysicalType } from 'app/shared/utils/column-mapping.util';

@Metamodel.model({
    name: ModelConstants.copyActivity,
    display: [
        format(stringResources.ModelName_ActivityTemplate, stringResources.Copy),
        format(stringResources.ModelName_ActivitiesTemplate, stringResources.Copy)
    ],
    referable: true,
    validator: CopyActivity.validateIRInModel
})
export class CopyActivity extends Activity {
    public static readonly ENABLE_STAGING: IAttribute;
    public static readonly ENABLE_TYPE_CONVERSION: IAttribute;
    public static readonly ENABLE_LOGGING: IAttribute;
    public static readonly ENABLE_DATA_CONSISTENCY: IAttribute;
    public static readonly CLOUD_DATAMOVEMENT_UNITS: IAttribute;
    public static readonly PARALLEL_COPIES: IAttribute;
    public static readonly ADAPTIVE_PERFORMANCE_TUNING: IAttribute;
    public static readonly MAPPING: IAttribute;
    public static readonly MAPPING_V2: IAttribute;
    public static readonly COLLECTION_REFERENCE: IAttribute;
    public static readonly MAP_COMPLEX_VALUES_TOSTRING: IAttribute;
    public static readonly PRESERVE: IAttribute;
    public static readonly FAULT_TOLERENCE: IAttribute;
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: !__IS_FABRIC_DPE__ ? stringResources.SourceDataset : stringResources.SourceConnection,
        constraint: {
            required: true,
            validator: CopyActivity.validateSourceDataset
        },
        reference: (context) => !context?.inlineDataset,
        type: Dataset.MODEL
    })
    public sourceDataset?: Dataset;

    @Metamodel.attribute({
        display: !__IS_FABRIC_DPE__ ? stringResources.SinkDataset : stringResources.DestinationConnection,
        constraint: {
            required: true,
            validator: CopyActivity.validateSinkDataset
        },
        reference: (context) => !context?.inlineDataset,
        type: Dataset.MODEL
    })
    public sinkDataset?: Dataset;

    @Metamodel.attribute({
        constraint: {
            validator: CopyActivity.validateMapping
        },
        association: 'MAPPING',
        templatable: true,
        display: stringResources.ColumnMapping
    })
    public mapping: Map<string, string> = new Map<string, string>();

    @Metamodel.attribute({
        constraint: {
            validator: CopyActivity.validateMappingV2
        },
        association: 'MAPPING_V2',
        templatable: true,
        display: stringResources.ColumnMapping,
        accepts: ['Object'],
        defaultValue: []
    })
    public mappingV2: ColumnMappingPair[] = [];

    public cacheSourceSchema: NamedArray<Column> = NamedArray.create(this);
    public cacheSinkSchema: NamedArray<Column> = NamedArray.create(this);
    public cacheSourceHierarchicalSchema: HierarchicalNode;
    public cacheSinkHierarchicalSchema: HierarchicalNode;
    public sinkSchemaNotExists: boolean = false;
    public hasExistingMapping: boolean = false;

    @Metamodel.attribute({
        association: 'COLLECTION_REFERENCE',
        templatable: true,
        display: stringResources.SchemaMapping_CollectionReference
    })
    public collectionReference?: string;

    // Use "source" instead of "copySource" to align with other activities which has source, for example, LookupActivity
    @Metamodel.attribute({
        display: stringResources.SourceActivity_SourceTab_SourceType,
        constraint: {
            required: true,
            validator: CopyActivity.validateCopySource
        },
        reference: false,
        type: CopySource.MODEL
    })
    public source?: CopySource;

    @Metamodel.attribute({
        display: !__IS_FABRIC_DPE__ ? stringResources.SinkType : stringResources.DestinationType,
        reference: false,
        type: CopySink.MODEL,
        constraint: {
            required: true,
            validator: CopyActivity.validateCopySink
        }
    })
    public copySink?: CopySink;

    @Metamodel.attribute({
        templatable: true,
        association: 'ENABLE_STAGING',
        display: stringResources.StagingSetting_EnableLabel
    })
    public enableStaging?: boolean = false;

    @Metamodel.attribute({
        display: stringResources.StagingSetting_MainGroupLabel,
        type: StagingSettings.MODEL,
        constraint: {
            validator: CopyActivity.validateStagingSetting
        }
    })
    public stagingSettings: StagingSettings = Owned.create(StagingSettings.MODEL, this);

    /** activity data originally loaded from BE, for back-compat usage */
    public originalData?: {
        sinkLinkedServiceType?: string;
        stagingLinkedServiceType?: string;
    } = {};

    @Metamodel.attribute({
        association: 'ENABLE_TYPE_CONVERSION',
        display: stringResources.TypeConversion_Enable_Label
    })
    public enableTypeConversion?: boolean = true;

    @Metamodel.attribute({
        display: stringResources.TypeConversionSettings_MainGroup_Label,
        type: TypeConversionSettings.MODEL
    })
    public typeConversionSettings: TypeConversionSettings = Owned.create(TypeConversionSettings.MODEL, this);

    @Metamodel.attribute({
        display: stringResources.ColumnMapping_Flatten_Settings,
        type: ColumnFlattenSettings.MODEL
    })
    public columnFlattenSettings: ColumnFlattenSettings = __IS_FABRIC_DPE__
        ? Owned.create(ColumnFlattenSettings.MODEL, this)
        : undefined;

    @Metamodel.attribute({
        templatable: true,
        association: 'CLOUD_DATAMOVEMENT_UNITS',
        display: stringResources.DataIntegrationUnitLabel
    })
    public cloudDataMovementUnits?: number;

    @Metamodel.attribute({
        templatable: true,
        association: 'PRESERVE',
        display: stringResources.ModelName_PreserveRules,
        accepts: ['Array'],
        constraint: {
            validator: CopyActivity.validatePreserveRules
        }
    })
    public preserve?: string[];

    @Metamodel.attribute({
        templatable: true,
        association: 'PARALLEL_COPIES',
        display: stringResources.Parallel_Setting_Label
    })
    public parallelCopies?: number;

    @Metamodel.attribute({
        templatable: true,
        association: 'ADAPTIVE_PERFORMANCE_TUNING',
        display: stringResources.AdaptivePerformanceTuning
    })
    public adaptivePerformanceTuning?: boolean;

    @Metamodel.attribute({
        display: stringResources.DataFlowPanelFaultToleranceSettingsLabel,
        type: FaultTolerenceSettings.MODEL,
        association: 'FAULT_TOLERENCE',
        constraint: {
            validator: CopyActivity.validateFaultToleranceSettings
        }
    })
    public faultTolerenceSettings: FaultTolerenceSettings = Owned.create(FaultTolerenceSettings.MODEL, this);

    @Metamodel.attribute({
        association: 'ENABLE_LOGGING',
        display: stringResources.DeleteLoggingSetting_EnableLabel
    })
    public enableLogging?: boolean = false;

    public enableOdbcDiagnosticLog?: boolean = false;

    public isNewLoggingModel: boolean = true;

    @Metamodel.attribute({
        display: stringResources.LoggingSettingsLabel,
        type: LoggingSettings.MODEL
    })
    public loggingSettings: LoggingSettings = Owned.create(LoggingSettings.MODEL, this);

    @Metamodel.attribute({
        display: stringResources.LoggingSettingsLabel,
        type: LoggingLocation.MODEL,
        constraint: {
            validator: CopyActivity.validateLoggingLocationAsync
        }
    })
    public loggingLocation: LoggingLocation = Owned.create(LoggingLocation.MODEL, this);

    @Metamodel.attribute({
        templatable: true,
        association: 'ENABLE_DATA_CONSISTENCY',
        display: stringResources.Data_Consistency_Enable_Label,
        constraint: {
            validator: CopyActivity.validateDataConsistencyAsync
        }
    })
    public enableDataConsistency?: boolean;

    /**
     * Parameter value for referenced source dataset.
     */
    @Metamodel.attribute({
        collection: Collection.Array,
        constraint: {
            required: false,
            validator: CopyActivity.validateSourceDatasetParameters
        }
    })
    public sourceDatasetParameters: ParameterValue[] = [];

    /**
     * Parameter value for referenced sink dataset.
     */
    @Metamodel.attribute({
        collection: Collection.Array,
        constraint: {
            required: false,
            validator: CopyActivity.validateSinkDatasetParameters
        }
    })
    public sinkDatasetParameters: ParameterValue[] = [];

    @Metamodel.attribute({
        display: stringResources.Workspace
    })
    public useFabricBuiltInStaging: boolean = __IS_FABRIC_DPE__;

    public mapComplexValuesToString: boolean;
    public enableAdvancedParquetSinkType: boolean = false;

    // This flag is used to identify whether to use hierarchical mapping for odata/c4c/ecc to json v2/cosmosdb sql api v2
    public useHierarchicalMappingForOdataC4cEcc: boolean = true;

    private static _sourceDatasetLabel = __IS_FABRIC_DPE__
        ? stringResources.Source_Label
        : stringResources.SourceDataset;
    private static _sinkDatasetLabel = __IS_FABRIC_DPE__
        ? stringResources.DestinationLabel
        : stringResources.SinkDataset;

    private static _sinkLabel = __IS_FABRIC_DPE__ ? stringResources.DestinationLabel : stringResources.Sink;

    constructor(name?: string, description?: string) {
        super(name, description);
        this.activityType = 'ExecutionActivity';
    }

    /** Extra handling for Trident Data Warehouse besides normal validations */
    public static validateStagingSettingForTDW(
        copy: CopyActivity,
        services: { dsSvc: DatasetRegistryService }
    ): IViolation[] | undefined {
        if (
            !copy.copySink ||
            Metamodel.modelOf(copy.copySink).name !== CopyActivity.getWarehouseModelType().copySinkType
        ) {
            return undefined;
        }

        const messages = [];

        // when copy to TDW, staging connector should have the same restriction on auth type as source
        if (!copy.useFabricBuiltInStaging) {
            const authenticationMethod = (
                copy.stagingSettings.storageLinkedService as AzureBlobStorageLinkedService | AzureBlobFSLinkedService
            ).authenticationMethod;

            const sinkMetadata = copy.sinkDataset
                ? services.dsSvc.getDatasetConfiguration(Metamodel.modelOf(copy.sinkDataset).name)
                : undefined;
            const isAuthTypeValid =
                !authenticationMethod || sinkMetadata?.allowedSourceAuthTypes.includes(authenticationMethod);
            if (!isAuthTypeValid) {
                const allowedSourceAuthTypesTexts = formatListWithConjunction(
                    sinkMetadata?.allowedSourceAuthTypes.map((t) => AUTHENTICATION_TYPE_TEXTS[t])
                );
                messages.push({
                    context: copy.stagingSettings.storageLinkedService,
                    message: () =>
                        format(
                            stringResources.StagingSetting_ErrorMessage_ShouldBe_Template,
                            __IS_FABRIC_DPE__
                                ? stringResources.StagingSetting_ConnectionLabel
                                : stringResources.StagingSetting_LinkedServiceLabel,
                            allowedSourceAuthTypesTexts
                        )
                });
            }
        }

        return messages.length ? messages : undefined;
    }

    public static async validateMappingV2(
        activity: CopyActivity,
        value?: ColumnMappingPair[],
        violation?: IViolation,
        context?: IValidationContext
    ): Promise<IViolation[] | undefined> {
        // dataset is required for mapping
        if (activity.sourceDataset == null || activity.sinkDataset == null) {
            return undefined;
        }
        if (isDeltaCloneCopy(activity)) {
            return undefined;
        }
        if (activity.mappingV2?.length > 0 && (activity.sourceDataset?.isV2 || activity.sinkDataset?.isV2)) {
            if (
                (activity.sourceDataset && activity.sourceDataset instanceof BinaryDataset) ||
                (activity.sinkDataset && activity.sinkDataset instanceof BinaryDataset)
            ) {
                return undefined;
            }
            if (activity.sourceDataset instanceof Office365Dataset && !__IS_FABRIC_DPE__) {
                return [
                    {
                        context: activity.mappingV2,
                        message: () => stringResources.Office365NotSupportSchemaMappingError,
                        messageType: 'unsupported'
                    }
                ];
            }

            const datasetRegistry = await getServiceInstance<DatasetRegistryService>(
                context.contextData,
                'DatasetRegistryService'
            );

            const sourceDatasetConfig = datasetRegistry.getDatasetConfiguration(
                Metamodel.modelOf(activity.sourceDataset).name
            );
            const sourceHierarchical = sourceDatasetConfig.datasetKind === 'hierarchical';
            const sinkDatasetConfig = datasetRegistry.getDatasetConfiguration(
                Metamodel.modelOf(activity.sinkDataset).name
            );
            const sinkHierarchical = sinkDatasetConfig.datasetKind === 'hierarchical';
            const sinkMapWithIndex =
                (activity.sinkDataset instanceof DelimitedTextDataset ||
                    activity.sinkDataset instanceof ExcelDataset) &&
                !activity.sinkDataset.firstRowAsHeader;
            const typeConversionChecked =
                supportTypeConversion(activity, false, datasetRegistry) && activity.enableTypeConversion;
            const allowDataTruncation =
                typeConversionChecked &&
                (!!TypeConversionSettings.ALLOW_DATA_TRUNCATION.templateValue(activity.typeConversionSettings) ||
                    activity.typeConversionSettings.allowDataTruncation);

            const enabledParquetSinkTypeEdit =
                activity.enableAdvancedParquetSinkType && activity.sinkDataset instanceof ParquetDataset;

            for (const mapping of activity.mappingV2) {
                if (
                    mapping.sink.parquetPorperties != null &&
                    !(activity.sinkDataset instanceof ParquetDataset)
                ) {
                    return [
                        {
                            context: activity.mappingV2,
                            message: () =>
                                stringResources.ColumnMapping_AdvancedParquetSinkTypeSettings_SinkNotSupport_ErrorMessage,
                            messageType: 'unsupported'
                        }
                    ];
                }

                if (
                    GlobalVariables.timestampNtz && __IS_FABRIC_DPE__ &&
                    activity.copySink instanceof LakehouseTableCopySink &&
                    mapping.sink.physicalType === ColumnPhysicalType.Timestamp_ntz &&
                    isLakehouseTimestampNtzSupported(activity) === false
                ) {
                    return [
                        {
                            context: activity.mappingV2,
                            message: () =>
                                stringResources.MappingV2_LakehouseTimestampNtzNotSupport_ErrorMessage,
                            messageType: 'unsupported'
                        }
                    ];
                }
            }

            for (const mapping of activity.mappingV2) {
                const sourceType = mapping.source.columnType;
                const sinkType = mapping.sink.columnType;
                const sourceScale = mapping.source.scale;
                const sinkScale = mapping.sink.scale;

                if (
                    enabledParquetSinkTypeEdit &&
                    (activity.sourceDataset instanceof SnowflakeTableDataset ||
                        isDatabricksFamilyDataset(activity.sourceDataset)
                    ) &&
                    activity.enableStaging === false &&
                    mapping.sink.parquetPorperties != null
                ) {
                    return [
                        {
                            context: activity.mappingV2,
                            message: () =>
                                stringResources.ColumnMapping_AdvancedParquetSinkTypeSettings_NotSupport_ErrorMessage,
                            messageType: 'unsupported'
                        }
                    ];
                }

                const editPhysicalType = supportEditPhysicalType(sinkDatasetConfig, activity.sinkDataset);
                if (editPhysicalType && mapping.sink.physicalType) {
                    const sourceColumnType = mapping.source.logicalType ||
                        getLogicalTypeByPhysicalType(sourceDatasetConfig, mapping.source.physicalType, sinkDatasetConfig.type);
                    const supportedSinkPhysicalTypes = sinkDatasetConfig?.supportedSinkPhysicalTypesFromLogicalSource?.[sourceColumnType?.toLowerCase()];
                    if (supportedSinkPhysicalTypes) {
                        if (!supportedSinkPhysicalTypes?.includes(mapping.sink.physicalType.toLowerCase())) {
                            return [
                                {
                                    context: activity.mappingV2,
                                    message: () => stringResources.ColumnMapping_IncompatibleType_Validation_ErrorMessage,
                                    messageType: 'invalid'
                                }
                            ];
                        } else {
                            // valid mapping based on customized config, skipping rest of validation for this mapping
                            continue;
                        }
                    }
                }

                if (sourceType && sinkType) {
                    if (
                        (!typeConversionChecked && isNotCompatibleColumnType(sourceType, sinkType)) ||
                        (typeConversionChecked &&
                            (checkTypeConversionCompatibility(sourceType, sinkType, sourceScale, sinkScale) === 'IN' ||
                                (checkTypeConversionCompatibility(sourceType, sinkType, sourceScale, sinkScale) ===
                                    'ST' &&
                                    !allowDataTruncation)))
                    ) {
                        return [
                            {
                                context: activity.mappingV2,
                                message: () => stringResources.ColumnMapping_IncompatibleType_Validation_ErrorMessage,
                                messageType: 'invalid'
                            }
                        ];
                    }
                }

                if (enabledParquetSinkTypeEdit) {
                    const supportedSourceLogicalTypes = Object.keys(sinkDatasetConfig?.LogicalToAdvancedTypeMapping);
                    const sourceLogicalType = mapping.source.logicalType || mapping.source.columnType;
                    if (!supportedSourceLogicalTypes?.includes(sourceLogicalType.toLowerCase())) {
                        return [
                            {
                                context: activity.mappingV2,
                                message: () => stringResources.ColumnMapping_Unsupported_Validation_ErrorMessage,
                                messageType: 'unsupported'
                            }
                        ];
                    }

                    if (
                        stringIsNullOrEmpty(mapping.sink.parquetPorperties?.physicalType) &&
                        stringIsNullOrEmpty(mapping.sink.logicalType) &&
                        stringIsNullOrEmpty(mapping.sink.physicalType)
                    ) {
                        return [
                            {
                                context: activity.mappingV2,
                                message: () =>
                                    format(
                                        stringResources.MappingV2_SinkColumnTypeIsEmptyMessage,
                                        CopyActivity._sinkLabel.toLocaleLowerCase()
                                    )
                            }
                        ];
                    }
                }

                const unsupportedSourcePhysicalTypes =
                    sinkDatasetConfig?.conversionNotSupportedPhysicalTypes?.[sourceDatasetConfig?.type];
                if (
                    mapping.source.physicalType &&
                    unsupportedSourcePhysicalTypes?.includes(mapping.source.physicalType.toLowerCase())
                ) {
                    return [
                        {
                            context: activity.mappingV2,
                            message: () => stringResources.ColumnMapping_Unsupported_Validation_ErrorMessage,
                            messageType: 'unsupported'
                        }
                    ];
                }

                if (
                    stringIsNullOrEmpty(mapping.source.name) &&
                    mapping.source.index == null &&
                    stringIsNullOrEmpty(mapping.source.path)
                ) {
                    return [
                        {
                            context: activity.mappingV2,
                            message: () => stringResources.MappingV2_SourceColumnIsEmptyMessage
                        }
                    ];
                }
                if (
                    stringIsNullOrEmpty(mapping.sink.name) &&
                    !sinkMapWithIndex &&
                    stringIsNullOrEmpty(mapping.sink.path)
                ) {
                    return [
                        {
                            context: activity.mappingV2,
                            message: () =>
                                format(
                                    stringResources.MappingV2_SinkColumnIsEmptyMessage,
                                    CopyActivity._sinkLabel.toLocaleLowerCase()
                                )
                        }
                    ];
                }

                if (sinkHierarchical && !stringIsNullOrEmpty(mapping.sink.path)) {
                    const pathItems = parseJsonPath(mapping.sink.path) || [];
                    if (pathItems.filter((item) => typeof item === 'number').length > 0) {
                        return [
                            {
                                context: activity.mappingV2,
                                message: () =>
                                    sanitizeAndFormatString(
                                        stringResources.ColumnMapping_ColumnArrayNotSupport_Validation_ErrorMessage,
                                        mapping.sink.path
                                    ),
                                messageType: 'unsupported'
                            }
                        ];
                    }
                    continue;
                }

                const isSql = activity.copySink instanceof SqlSink || activity.copySink instanceof SqlDWSink;

                if (
                    (editPhysicalType &&
                        ((activity.copySink instanceof LakehouseTableCopySink &&
                            (activity.copySink.tableActionOption === 'Overwrite' ||
                                activity.copySink.tableActionOption === 'OverwriteSchema' ||
                                activity.sinkSchemaNotExists)) ||
                            (isSql &&
                                (activity.copySink as SqlSink).tableOption === tableOptionValues.autoCreate &&
                                activity.sinkSchemaNotExists) ||
                            sinkDatasetConfig?.type === adfModelTypeMap.iceberg.datasetType)) ||
                    enabledParquetSinkTypeEdit
                ) {
                    if (
                        !activity.hasExistingMapping &&
                        stringIsNullOrEmpty(mapping.sink.physicalType) &&
                        !enabledParquetSinkTypeEdit
                    ) {
                        return [
                            {
                                context: activity.mappingV2,
                                message: () =>
                                    format(
                                        stringResources.MappingV2_SinkColumnTypeIsEmptyMessage,
                                        CopyActivity._sinkLabel.toLocaleLowerCase()
                                    )
                            }
                        ];
                    }

                    let precision;
                    let scale;
                    //To do: fix validation check for ADF
                    if (__IS_FABRIC_DPE__ ? mapping.sink.precision != null : mapping.sink.precision) {
                        precision = Number(mapping.sink.precision);

                        let precisionConfig;
                        if (enabledParquetSinkTypeEdit) {
                            precisionConfig =
                                sinkDatasetConfig?.LogicalToAdvancedTypeMapping?.[
                                    mapping.source?.columnType?.toLowerCase()
                                ]?.propertyConfig?.precision?.[mapping.sink?.parquetPorperties?.physicalType];
                        } else {
                            precisionConfig = sinkDatasetConfig.precisionMap?.[mapping.sink.physicalType];
                        }

                        const maxPrecisionValue = precisionConfig?.maxValue;
                        const minPrecisionValue = precisionConfig?.minValue;

                        if (
                            ((__IS_FABRIC_DPE__ ? maxPrecisionValue != null : maxPrecisionValue) && precision > maxPrecisionValue) ||
                            ((__IS_FABRIC_DPE__ ? minPrecisionValue != null : minPrecisionValue) && precision < minPrecisionValue)
                        ) {
                            return [
                                {
                                    context: activity.mapping,
                                    message: () => stringResources.ColumnTypeWithPrecisionRequiresUserEdit,
                                    messageType: 'invalid'
                                }
                            ];
                        }
                    }

                    if (__IS_FABRIC_DPE__ ? mapping.sink.scale != null : mapping.sink.scale) {
                        scale = Number(mapping.sink.scale);

                        if (enabledParquetSinkTypeEdit && mapping.sink.parquetPorperties?.logicalType === 'DECIMAL' && scale < 0) {
                            return [
                                {
                                    context: activity.mapping,
                                    message: () => stringResources.ColumnTypeWithScaleRequiresUserEdit,
                                    messageType: 'invalid'
                                }
                            ];
                        }
                        if (
                            (mapping.sink.physicalType === ColumnPhysicalType.Decimal ||
                                (isSql && mapping.sink.columnType === ColumnPhysicalType.Numeric) ||
                                (enabledParquetSinkTypeEdit &&
                                    mapping.sink.parquetPorperties?.logicalType === 'DECIMAL')) &&
                            (__IS_FABRIC_DPE__ ? precision != null : precision) &&
                            precision < scale
                        ) {
                            return [
                                {
                                    context: activity.mapping,
                                    message: () => stringResources.ColumnTypeWithPrecisionAndScaleErrorMessage,
                                    messageType: 'invalid'
                                }
                            ];
                        } else {
                            const scaleConfig = sinkDatasetConfig.scaleMap?.[mapping.sink.physicalType];
                            if (scaleConfig && (scale > scaleConfig.maxValue || scale < scaleConfig.minValue)) {
                                return [
                                    {
                                        context: activity.mapping,
                                        message: () => stringResources.ColumnTypeWithScaleRequiresUserEdit,
                                        messageType: 'invalid'
                                    }
                                ];
                            }
                        }
                    }

                    if (mapping.sink.size != null) {
                        const columnsize = mapping.sink.size;
                        const lengthConfig = sinkDatasetConfig.binaryLengthMap?.[mapping.sink.physicalType];
                        if (lengthConfig) {
                            const minLengthValue = lengthConfig.minValue;
                            const maxLengthValue = lengthConfig.maxValue;
                            const isMaxValueSupported = lengthConfig.supportMaxValue;
                            if (!isMaxValueSupported && columnsize.toLowerCase() === 'max') {
                                return [
                                    {
                                        context: activity.mapping,
                                        message: () =>
                                            format(
                                                stringResources.ColumnTypeWithLengthEdit_MaxValue_NotSupport_ErrorMessage,
                                                mapping.sink.physicalType
                                            ),
                                        messageType: 'unsupported'
                                    }
                                ];
                            }

                            if (
                                (!/^\d+$/.test(columnsize) && columnsize.toLowerCase() !== 'max') ||
                                (columnsize.toLowerCase() !== 'max' &&
                                    (parseInt(columnsize, 10) > maxLengthValue ||
                                        parseInt(columnsize, 10) < minLengthValue))
                            ) {
                                return [
                                    {
                                        context: activity.mapping,
                                        message: () => stringResources.ColumnTypeWithLengthRequiresUserEdit,
                                        messageType: 'invalid'
                                    }
                                ];
                            }
                        }
                    }
                }

                if (!activity.enableAdvancedParquetSinkType && (sourceHierarchical || sinkHierarchical)) {
                    return undefined;
                }
            }

            // check dup columns in mapping, no need to check sink side
            const sourceColumnNamesSet = new Set<string>();
            const sinkColumnNamesSet = new Set<string>();
            const sinkByOrder =
                (activity.sinkDataset instanceof DelimitedTextDataset ||
                    activity.sinkDataset instanceof ExcelDataset) &&
                !activity.sinkDataset.firstRowAsHeader;
            for (const val of activity.mappingV2) {
                const sourceIdentifier = val.source.toIdentifier();
                if (sourceColumnNamesSet.has(sourceIdentifier)) {
                    return [
                        {
                            context: activity.mappingV2,
                            message: () =>
                                sanitizeAndFormatString(
                                    stringResources.ColumnMapping_SourceColumnDuplicated_Validation_ErrorMessage,
                                    sourceIdentifier
                                ),
                            messageType: 'duplicated'
                        }
                    ];
                }
                if (!sinkByOrder && sinkColumnNamesSet.has(val.sink.toIdentifier())) {
                    return [
                        {
                            context: activity.mappingV2,
                            message: () =>
                                sanitizeAndFormatString(
                                    stringResources.ColumnMapping_SourceColumnDuplicated_Validation_ErrorMessage,
                                    val.sink.name
                                ),
                            messageType: 'duplicated'
                        }
                    ];
                }
                sourceColumnNamesSet.add(sourceIdentifier);
                sinkColumnNamesSet.add(val.sink.toIdentifier());
            }

            return undefined;
        }
        return undefined;
    }

    private static async validateIRInModel(
        activity: CopyActivity,
        context: IValidationContext
    ): Promise<IViolation[] | undefined> {
        return validateIR(
            {
                sourceLs: activity.sourceDataset?.linkedService,
                sourceDMTSCredentialLs: activity.sourceDataset?.dmtsCredentialForArtifact,
                sinkLs: activity.sinkDataset?.linkedService,
                sinkDMTSCredentialLs: activity.sinkDataset?.dmtsCredentialForArtifact,
                stagingLs:
                    activity.enableStaging && (!__IS_FABRIC_DPE__ || !activity.useFabricBuiltInStaging)
                        ? activity.stagingSettings?.storageLinkedService
                        : undefined
            },
            context,
            activity
        );
    }

    private static async validateMapping(
        activity: CopyActivity,
        value?: Map<string, string>,
        violation?: IViolation,
        context?: IValidationContext
    ): Promise<IViolation[] | undefined> {
        if (activity.sourceDataset?.isV2 || activity.sinkDataset?.isV2) {
            return undefined;
        }
        if (activity.mapping?.size > 0) {
            // ignore this when columns is expression
            if (activity.sourceDataset instanceof Office365Dataset && !__IS_FABRIC_DPE__) {
                return [
                    {
                        context: activity.mapping,
                        message: () => stringResources.Office365NotSupportSchemaMappingError,
                        messageType: 'unsupported'
                    }
                ];
            }

            if (
                activity.sourceDataset?.columns &&
                Dataset.COLUMNS.templateValue(activity.sourceDataset) == null &&
                activity.sinkDataset?.columns &&
                Dataset.COLUMNS.templateValue(activity.sinkDataset) == null
            ) {
                const datasetRegistry = await getServiceInstance<DatasetRegistryService>(
                    context.contextData,
                    'DatasetRegistryService'
                );

                const sourceDatasetConfig = datasetRegistry.getDatasetConfiguration(
                    Metamodel.modelOf(activity.sourceDataset).name
                );
                const sourceHierarchical = sourceDatasetConfig.datasetKind === 'hierarchical';
                const sinkDatasetConfig = datasetRegistry.getDatasetConfiguration(
                    Metamodel.modelOf(activity.sinkDataset).name
                );
                const sinkHierarchical = sinkDatasetConfig.datasetKind === 'hierarchical';

                if (sourceHierarchical || sinkHierarchical) {
                    return undefined;
                }

                const sourceColumns = activity.sourceDataset.columns;
                const sinkColumns = activity.sinkDataset.columns;

                // check dup columns in mapping, no need to check sink side
                const sourceColumnNamesSet = new Set<string>();
                for (const val of activity.mapping.values()) {
                    if (sourceColumnNamesSet.has(val)) {
                        return [
                            {
                                context: activity.mapping,
                                message: () =>
                                    sanitizeAndFormatString(
                                        stringResources.ColumnMapping_SourceColumnDuplicated_Validation_ErrorMessage,
                                        val
                                    ),
                                messageType: 'duplicated'
                            }
                        ];
                    } else {
                        sourceColumnNamesSet.add(val);
                    }
                }

                for (const key of activity.mapping.keys()) {
                    const val = activity.mapping.get(key);
                    const filteredSourceColumn = sourceColumns.filter((col) => col.name === val);
                    const filteredSinkColumn = sinkColumns.filter((col) => col.name === key);
                    const sourceType = filteredSourceColumn.length > 0 ? filteredSourceColumn[0].columnType : undefined;
                    const sinkType = filteredSinkColumn.length > 0 ? filteredSinkColumn[0].columnType : undefined;
                    if (sourceType && sinkType && isNotCompatibleColumnType(sourceType, sinkType)) {
                        return [
                            {
                                context: activity.mapping,
                                message: () => stringResources.ColumnMapping_IncompatibleType_Validation_ErrorMessage,
                                messageType: 'invalid'
                            }
                        ];
                    }

                    // val in mapping must be included in source columns
                    if (sourceColumns.filter((col) => col.name === val).length === 0 && !activity.sourceDataset.isV2) {
                        return [
                            {
                                context: activity.mapping,
                                message: () =>
                                    stringResources.ColumnMapping_ColumnNotFoundInSourceSchema_Validation_ErrorMessage,
                                messageType: 'invalid'
                            }
                        ];
                    }
                }
                return undefined;
            }
            return undefined;
        }
        return undefined;
    }

    private static validatePreserveRules(copyActivity: CopyActivity): IViolation[] | undefined {
        if (
            copyActivity?.preserve != null &&
            Array.isArray(copyActivity.preserve) &&
            copyActivity.preserve.length > 0
        ) {
            // if source dataset is binary copy or sink dataset is binary copy, then it is binary copy.
            if (
                copyActivity.sourceDataset != null &&
                !copyActivity.sourceDataset.isV2 &&
                !isDatasetWithoutFileFormat(copyActivity.sourceDataset) &&
                copyActivity.sinkDataset != null &&
                !copyActivity.sinkDataset.isV2 &&
                !isDatasetWithoutFileFormat(copyActivity.sinkDataset)
            ) {
                return [
                    {
                        context: copyActivity.preserve,
                        message: () => stringResources.PreserveRulesValidationBinaryCopyMessage,
                        messageType: 'invalid'
                    }
                ];
            }

            if (copyActivity.enableStaging) {
                return [
                    {
                        context: copyActivity.preserve,
                        message: () => stringResources.PreserveRulesValidationStagingMessage,
                        messageType: 'invalid'
                    }
                ];
            }
        }
        return undefined;
    }

    private static validateSourceDatasetParameters(copyActivity: CopyActivity): IViolation[] | undefined {
        if (copyActivity?.sourceDataset != null) {
            return validateEntityParameters(
                copyActivity.sourceDataset,
                copyActivity.sourceDatasetParameters || [],
                copyActivity
            );
        }
        return undefined;
    }

    private static validateSinkDatasetParameters(copyActivity: CopyActivity): IViolation[] | undefined {
        if (copyActivity?.sinkDataset != null) {
            return validateEntityParameters(
                copyActivity.sinkDataset,
                copyActivity.sinkDatasetParameters || [],
                copyActivity
            );
        }
        return undefined;
    }

    private static async validateSinkDataset(
        activity: CopyActivity,
        sinkDataset: Dataset,
        violation: IViolation,
        context: IValidationContext
    ): Promise<IViolation[] | undefined> {
        let violations: IViolation[] = [];
        const sourceDataset = activity.sourceDataset;
        if (sinkDataset == null) {
            return undefined;
        }
        const dsSvc = await getServiceInstance<DatasetRegistryService>(context.contextData, 'DatasetRegistryService');
        const sinkMetadata = dsSvc.getDatasetConfiguration(Metamodel.modelOf(sinkDataset).name);
        const sinkIsFileType = sinkMetadata.datasetKind === 'file';
        if (sourceDataset && sinkDataset) {
            const sourceIsFileType =
                dsSvc.getDatasetConfiguration(Metamodel.modelOf(sourceDataset).name).datasetKind === 'file';
            // if source dataset is binary copy or sink dataset is binary copy, then it is binary copy. We don't need validate both side
            // office 365 source only supports Blob/ADLS gen1/ADLS gen2 dataset as sink and json format without schema mapping
            // remember to add validation both here and in copywizard
            if (sourceDataset instanceof Office365Dataset) {
                const outputColumns = activity.source
                    ? ValueAdapter.toResource(activity.source, Office365CopySource.OUTPUT_COLUMNS)
                    : null;
                const isOldM365 = !__IS_FABRIC_DPE__ || outputColumns;
                if (sinkDataset instanceof FormatDatasetV2) {
                    if (__IS_FABRIC_DPE__ && !outputColumns && sinkDataset instanceof BinaryDataset) {
                        violations.push({
                            message: () => stringResources.Office365OnlyAllowCopytoNonBinary,
                            messageType: 'unsupported'
                        });
                    }
                    if (isOldM365 && !(sinkDataset instanceof BinaryDataset)) {
                        violations.push({
                            message: () => stringResources.Office365OnlyAllowCopytoBinary,
                            messageType: 'unsupported'
                        });
                    }
                    if (sinkDataset.location && !sinkDataset.location.isFolder() && isOldM365) {
                        violations.push({
                            message: () => stringResources.Office365OnlyAllowCopytoFolder,
                            messageType: 'unsupported'
                        });
                    }
                }
                if (sinkDataset instanceof FileTypeDataset) {
                    if (
                        !isDatasetWithoutFileFormat(sinkDataset) &&
                        sinkDataset.format.type !== fileFormats.jsonFormat
                    ) {
                        violations.push({
                            message: () => stringResources.Office365OnlyAllowJsonFormatError,
                            messageType: 'unsupported'
                        });
                    }
                    if (sinkDataset.fileName && isOldM365) {
                        violations.push({
                            messageType: 'unsupported',
                            message: () => stringResources.Office365OnlyAllowCopytoFolder
                        });
                    }
                }
            }

            if (sourceDataset instanceof BinaryDataset && !isBinaryTypeDataset(sinkDataset)) {
                violations.push({
                    context: activity,
                    messageType: 'invalid',
                    message: () =>
                        __IS_FABRIC_DPE__
                            ? stringResources.Binary_Copy_BinaryToNonBinary_ErrorMessage_Trident
                            : stringResources.Binary_Copy_BinaryToNonBinary_ErrorMessage,
                    redirectTo: __IS_FABRIC_DPE__
                        ? {
                            entity: activity.sinkDataset,
                            attribute: FileTypeDataset.FILE_FORMAT
                        }
                        : undefined
                });
            } else if (
                sinkDataset instanceof BinaryDataset &&
                !isBinaryTypeDataset(sourceDataset) &&
                !(sourceDataset instanceof Office365Dataset)
            ) {
                violations.push({
                    context: activity,
                    messageType: 'invalid',
                    message: () =>
                        __IS_FABRIC_DPE__
                            ? stringResources.Binary_Copy_NonBinaryToBinary_ErrorMessage_Trident
                            : stringResources.Binary_Copy_NonBinaryToBinary_ErrorMessage,
                    redirectTo: __IS_FABRIC_DPE__
                        ? {
                            entity: activity.sourceDataset,
                            attribute: FileTypeDataset.FILE_FORMAT
                        }
                        : undefined
                });
            } else if (!(sourceDataset instanceof BinaryDataset) && !(sinkDataset instanceof BinaryDataset)) {
                // binary copy is not allowed between file and tabular dataset (except office365 as source)
                if (
                    (isBinaryTypeDataset(sourceDataset) && !sinkIsFileType) ||
                    (isBinaryTypeDataset(sinkDataset) &&
                        !sourceIsFileType &&
                        !(sourceDataset instanceof Office365Dataset))
                ) {
                    violations.push({
                        context: activity,
                        messageType: 'unsupported',
                        message: () => stringResources.Binary_Copy_FileTabular_ErrorMessage
                    });
                }
            }
            // Binary copy does not support copying from folder to file, except sink dataset specifies ZipDeflate, TarGZip or tar
            if (
                (isBinaryTypeDataset(sourceDataset) || isBinaryTypeDataset(sinkDataset)) &&
                isFileTypeDataset(sourceDataset, { dsSvc }) &&
                !datasetIsFile(sourceDataset) &&
                isFileTypeDataset(sinkDataset, { dsSvc }) &&
                datasetIsFile(sinkDataset) &&
                !datasetWithZipDeflateCompression(sinkDataset) &&
                !datasetWithTarGZipCompression(sinkDataset) &&
                !datasetWithTarCompression(sinkDataset)
            ) {
                violations.push(
                    !isAEPDataset(sourceDataset)
                        ? {
                            context: activity,
                            messageType: 'unsupported',
                            message: () => stringResources.Binary_Copy_FolderCopyToFileError
                        }
                        : {
                            context: activity,
                            messageType: 'invalid',
                            message: () => stringResources.AEP_CopyToFile_ErrorMessage // customize error message for aep source
                        }
                );
            }
            // if source only supports azure IR, sink cannot reference to a self hosted IR
            const sourceLinkedservice = sourceDataset.linkedService;
            const sinkLinkedservice = sinkDataset.linkedService;
            if (sourceLinkedservice && sinkLinkedservice) {
                const lsRegistry = await getServiceInstance<LinkedServiceRegistryService>(
                    context.contextData,
                    'LinkedServiceRegistryService'
                );

                const sourceType = Metamodel.modelOf(sourceDataset).name;
                const sinkType = Metamodel.modelOf(sinkDataset).name;
                const sourceConfig = lsRegistry.getLinkedServiceConfiguration(
                    Metamodel.modelOf(sourceLinkedservice).name
                );
                if (
                    sourceConfig &&
                    sourceConfig.onlyAzureIR &&
                    sinkLinkedservice.integrationRuntime &&
                    sinkLinkedservice.integrationRuntime instanceof SelfHostedIntegrationRuntime
                ) {
                    violations.push({
                        messageType: 'unsupported',
                        message: () => format(stringResources.CopySelfhostedIR_ErrorMessage, sourceType, sinkType)
                    });
                }
            }

            // validate snowflake sink dataset
            violations.push(...(await CopyActivity.validateSnowflakeSinkDataset(activity, context)));

            // validate Teradata sink dataset
            violations.push(...(await CopyActivity.validateTeradataSinkDataset(activity, context)));

            // validate Azure Databricks Delta Lake sink dataset
            violations.push(...(await CopyActivity.validateAzureDatabricksDeltaLakeSinkDataset(activity, { dsSvc })));
        }
        if (sinkDataset instanceof FileTypeDataset && sinkDataset.folderPath) {
            const pathRegex = sinkMetadata.pathRegex;
            if (
                pathRegex != null &&
                !isLogicAppExpression(sinkDataset.folderPath) &&
                !pathRegex.pattern.test(sinkDataset.folderPath)
            ) {
                violations.push({
                    message: () => pathRegex.message
                });
            }
        }
        if (sinkDataset?.linkedService) {
            const linkedServiceType = Metamodel.modelOf(sinkDataset.linkedService).name;
            const linkedServiceRegistry = await getServiceInstance<LinkedServiceRegistryService>(
                context.contextData,
                'LinkedServiceRegistryService'
            );

            const metadata = linkedServiceRegistry.getLinkedServiceConfiguration(linkedServiceType);
            if (metadata && metadata.notSupportCopySink) {
                violations.push({
                    messageType: 'unsupported',
                    message: () => stringResources.LinkedService_NotSupportSink_ErrorMessage
                });
            }
            if (
                sinkDataset.linkedService instanceof AzureBlobStorageLinkedService &&
                sinkDataset.linkedService.authenticationMethod === azureStorageAuthTypes.Anonymous
            ) {
                return [
                    {
                        messageType: 'unsupported',
                        message: () =>
                            format(
                                stringResources.Anonymous_BlobStorage_ErrorTemplate,
                                Metamodel.modelOf(activity).attribute('sinkDataset').display.toLocaleLowerCase()
                            )
                    }
                ];
            }
        }

        if (activity.sinkDataset != null && activity.sinkDataset instanceof FileTypeDataset) {
            if (activity.sinkDataset.wildcardPath != null) {
                violations.push({
                    context: activity,
                    messageType: 'unsupported',
                    message: () => stringResources.Dateset_CannotUseWildcardPathForSink,
                    redirectTo: {
                        entity: activity.sinkDataset,
                        attribute: FileTypeDataset.FOLDER_PATH
                    }
                });
            }
        }

        // validate location
        if (activity.sinkDataset instanceof FormatDatasetV2) {
            const loc = activity.sinkDataset.location;
            const s3Locations = [AmazonS3Location, AmazonS3CompatibleLocation, GoogleCloudStorageLocation];
            if (
                loc instanceof AzureBlobStorageLocation &&
                valueAndExpressionValueBothEmpty(loc, AzureBlobStorageLocation.CONTAINER)
            ) {
                violations.push({
                    messageType: 'missing',
                    message: () => format(stringResources.RequiredTemplate, AzureBlobStorageLocation.CONTAINER.display),
                    redirectTo: {
                        entity: activity.sinkDataset,
                        attribute: AzureBlobStorageLocation.CONTAINER
                    }
                });
            } else if (
                loc instanceof LakehouseLocation &&
                // for Trident, source of truth for "rootFolder" is on dataset
                ((__IS_FABRIC_DPE__ && activity.sinkDataset.rootFolder === 'Tables') ||
                    // for ADF, source of truth for "rootFolder" is on linkedService
                    (!__IS_FABRIC_DPE__ &&
                        (activity.sinkDataset.linkedService as LakehouseLinkedService).rootFolder === 'Tables'))
            ) {
                if (valueAndExpressionValueBothEmpty(loc, LakehouseLocation.FOLDER_PATH)) {
                    violations.push({
                        messageType: 'missing',
                        // Folder path display is set to "Folder path" (Files), so hardcoding "Tables" here
                        message: () => format(stringResources.RequiredTemplate, stringResources.Table_name_Label),
                        redirectTo: {
                            entity: activity.sinkDataset,
                            attribute: LakehouseLocation.FOLDER_PATH
                        }
                    });
                } else if (loc.folderPath && !Constants.lakehouseTableNameValidation.test(loc.folderPath)) {
                    violations.push({
                        messageType: 'invalid',
                        message: () => stringResources.Validator_Lakehouse_TableName,
                        redirectTo: {
                            entity: activity.sinkDataset,
                            attribute: LakehouseLocation.FOLDER_PATH
                        }
                    });
                }
            } else if (
                s3Locations.some(
                    (location) => loc instanceof location && valueAndExpressionValueBothEmpty(loc, location.CONTAINER)
                )
            ) {
                violations.push({
                    messageType: 'missing',
                    message: () => format(stringResources.RequiredTemplate, stringResources.ModelName_BucketName),
                    redirectTo: {
                        entity: activity.sinkDataset,
                        attribute: Metamodel.modelOf(loc).attribute('container')
                    }
                });
            }
        }

        // validate delimited text sink dataset
        if (sinkDataset instanceof DelimitedTextDataset) {
            // in copy, lookup and get metadata activity, rowDelimiter and columnDelimiter cannot be empty string or multi-char string
            // bypass sink dataset row delimiter and compression validation when source is snowflake or Azure Databricks Delta Lake
            const isSnowFlakeSource = sourceDataset instanceof SnowflakeTableDataset;
            const isDatabricksSource = isDatabricksFamilyDataset(sourceDataset);
            violations.push(
                ...(await validateDelimiterForDelimitedText(
                    sinkDataset,
                    activity,
                    isSnowFlakeSource || isDatabricksSource
                ))
            );
            if (!isSnowFlakeSource && !isDatabricksSource) {
                violations.push(...(validateCompressionForDelimitedText(sinkDataset, activity) || []));
            }
        }

        if (sinkDataset instanceof SalesforceV2Dataset && sinkDataset.sourceOption === 'reportId') {
            violations.push({
                messageType: 'unsupported',
                message: () => stringResources.SalesforceV2_OnlyObjectError,
                redirectTo: {
                    entity: sinkDataset,
                    attribute: SalesforceV2Dataset.SOURCE_OPTION
                }
            });
        }

        // validate dynamic datasets
        const activitySupportabilityViolations = await validateActivitySupportability(
            activity,
            sinkDataset,
            true,
            context
        );
        if (activitySupportabilityViolations != null && activitySupportabilityViolations.length > 0) {
            violations = violations.concat(activitySupportabilityViolations);
        }

        return violations;
    }

    private static async validateSourceDataset(
        activity: CopyActivity,
        sourceDataset: Dataset,
        violation: IViolation,
        context: IValidationContext
    ): Promise<IViolation[] | undefined> {
        let violations: IViolation[] = [];
        const sinkDataset = activity.sinkDataset;
        // validate source dataset format
        const dsSvc = await getServiceInstance<DatasetRegistryService>(context.contextData, 'DatasetRegistryService');
        const isDirectPolybase =
            CopyActivity.checkIfEnabledPolybase(activity) && !CopyActivity.checkIfEnabledStaging(activity, { dsSvc });
        const isCopyCommand = CopyActivity.checkIfEnabledCopyCommand(activity);
        const isSnowFlakeSink = sinkDataset instanceof SnowflakeTableDataset;
        const isSnowFlakeSource = sourceDataset instanceof SnowflakeTableDataset;
        const isDatabricksSource = isDatabricksFamilyDataset(sourceDataset);
        const isDatabricksSink = isDatabricksFamilyDataset(sinkDataset);

        // should bypass delimiter and conpression check for direct polybase and copy command
        const datasetViolations = await validateSourceDataset(
            activity,
            sourceDataset,
            isDirectPolybase ||
            isCopyCommand ||
            isSnowFlakeSink ||
            isSnowFlakeSource ||
            isDatabricksSource ||
            isDatabricksSink,
            isDirectPolybase,
            isDirectPolybase ||
            isCopyCommand ||
            isSnowFlakeSink ||
            isSnowFlakeSource ||
            isDatabricksSource ||
            isDatabricksSink,
            context
        );

        if (datasetViolations != null) {
            violations = violations.concat(datasetViolations);
        }

        // validate location
        if (sourceDataset instanceof FormatDatasetV2) {
            const loc = sourceDataset.location;
            const otherS3Locations = [
                AmazonS3CompatibleLocation,
                GoogleCloudStorageLocation,
                OracleCloudStorageLocation
            ];
            if (
                (loc instanceof AzureBlobStorageLocation &&
                    valueAndExpressionValueBothEmpty(loc, AzureBlobStorageLocation.CONTAINER)) ||
                (loc instanceof AmazonS3Location && valueAndExpressionValueBothEmpty(loc, AmazonS3Location.CONTAINER))
            ) {
                violations.push({
                    messageType: 'missing',
                    message: () =>
                        format(
                            stringResources.RequiredTemplate,
                            loc instanceof AzureBlobStorageLocation
                                ? AzureBlobStorageLocation.CONTAINER.display
                                : AmazonS3Location.CONTAINER.display
                        ),
                    redirectTo: {
                        entity: sourceDataset,
                        attribute: Metamodel.modelOf(loc).attribute('container')
                    }
                });
            }
            if (
                __IS_FABRIC_DPE__ &&
                otherS3Locations.some(
                    (location) => loc instanceof location && valueAndExpressionValueBothEmpty(loc, location.CONTAINER)
                )
            ) {
                violations.push({
                    messageType: 'missing',
                    message: () => format(stringResources.RequiredTemplate, stringResources.ModelName_BucketName),
                    redirectTo: {
                        entity: sourceDataset,
                        attribute: Metamodel.modelOf(loc).attribute('container')
                    }
                });
            }
        }

        // validate snowflake source dataset
        violations.push(...(await CopyActivity.validateSnowflakeSourceDataset(activity, context)));

        // validate Oracle source dataset
        violations.push(...(await CopyActivity.validateOracleSourceDataset(activity, context)));

        // validate Azure Databricks Delta Lake source dataset
        violations.push(...(await CopyActivity.validateAzureDatabricksDeltaLakeSourceDataset(activity, { dsSvc })));

        if (
            sourceDataset instanceof SapOdpDataset &&
            sourceDataset.linkedService instanceof SapOdpLinkedService &&
            !sourceDataset.linkedService.fullyByJsonEditor &&
            activity.source instanceof SapOdpCopySource &&
            (activity.source.extractionMode === 'Delta' || activity.source.extractionMode === 'Recovery') &&
            stringIsNullOrEmpty(sourceDataset.linkedService.subscriberName)
        ) {
            // `subscriberName` is mandatory when `extractionMode` is `Delta` or `Recovery`
            violations.push({
                message: () =>
                    format(
                        stringResources.RequiredTemplateWhen,
                        stringResources.ModelName_SubscriberName,
                        stringResources.Extraction_Mode,
                        (activity.source as SapOdpCopySource).extractionMode
                    ),
                redirectTo: {
                    entity: sourceDataset.linkedService
                }
            });
        }

        return violations;
    }

    private static async validateCopySource(
        activity: CopyActivity,
        value: CopySource,
        violation: IViolation,
        context: IValidationContext
    ): Promise<IViolation[] | undefined> {
        // validate distcp for HDFS
        if (
            activity.source instanceof FormatTypeCopySource &&
            activity.source.storeSettings instanceof HdfsStoreReadSettings
        ) {
            const storeSettings = activity.source.storeSettings;
            if (
                activity.sinkDataset != null &&
                activity.sourceDataset != null &&
                storeSettings.distCpSetting?.useDistCp
            ) {
                if (Metamodel.modelOf(activity.sourceDataset).name !== Metamodel.modelOf(activity.sinkDataset).name) {
                    return [
                        {
                            context: activity,
                            messageType: 'unsupported',
                            message: () => stringResources.DistCpFormatValidation
                        }
                    ];
                }
            }
        }
        const sinkEnabledCopyCommand = CopyActivity.checkIfEnabledCopyCommand(activity);
        const dsSvc = await getServiceInstance<DatasetRegistryService>(context.contextData, 'DatasetRegistryService');

        // validate partition discovery
        if (
            activity.source instanceof FormatTypeCopySource &&
            activity.source.storeSettings instanceof BlobTypeStoreReadSettings &&
            activity.source.storeSettings.enablePartitionDiscovery === true
        ) {
            if (
                CopyActivity.checkIfEnabledPolybase(activity) &&
                !CopyActivity.checkIfEnabledStaging(activity, { dsSvc })
            ) {
                return [
                    {
                        context: activity.source.storeSettings,
                        messageType: 'unsupported',
                        message: () => stringResources.PartitionDiscovery_In_Compatible_With_Direct_Polybase
                    }
                ];
            }
        }

        // validate additional columns
        if (activity.source && !arrayIsNullOrEmpty(activity.source.additionalColumns)) {
            if (activity.sinkDataset && !activity.sinkDataset.isV2) {
                return [
                    {
                        context: activity,
                        messageType: 'unsupported',
                        message: () =>
                            sanitizeAndFormatString(
                                stringResources.AdditionalColumns_Not_Support_Sink,
                                activity.sinkDataset.name
                            )
                    }
                ];
            }
            const nameSet = new Set<string>();
            for (const column of activity.source.additionalColumns) {
                if (!column.name) {
                    return [
                        {
                            context: activity,
                            message: () => stringResources.AdditionalColumns_Not_Allow_EmptyName
                        }
                    ];
                }
                if (nameSet.has(column.name)) {
                    return [
                        {
                            context: activity,
                            messageType: 'invalid',
                            message: () => stringResources.AdditionalColumns_Not_Allow_DuplicateName
                        }
                    ];
                }
                nameSet.add(column.name);
            }

            if (activity.copySink instanceof SqlDWSink) {
                // validate source dataset format
                const isDirectPolybase =
                    CopyActivity.checkIfEnabledPolybase(activity) &&
                    !CopyActivity.checkIfEnabledStaging(activity, { dsSvc });
                if (isDirectPolybase) {
                    return [
                        {
                            context: activity,
                            messageType: 'unsupported',
                            message: () =>
                                stringResources.AdditionalColumns_Not_Allow_Polybase +
                                format(
                                    stringResources.CopyCommand_CopyMethod_CopyCommandPleaseFixTemplate,
                                    stringResources.CopySource_AdditionalColumns
                                ),
                            redirectTo: {
                                attribute: CopyActivity.ENABLE_STAGING
                            }
                        }
                    ];
                }
                if (sinkEnabledCopyCommand && !CopyActivity.checkIfEnabledStaging(activity, { dsSvc })) {
                    return [
                        {
                            context: activity,
                            messageType: 'unsupported',
                            message: () =>
                                stringResources.AdditionalColumns_Not_Allow_CopyCommand +
                                format(
                                    stringResources.CopyCommand_CopyMethod_CopyCommandPleaseFixTemplate,
                                    stringResources.CopySource_AdditionalColumns
                                ),
                            redirectTo: {
                                attribute: CopyActivity.ENABLE_STAGING
                            }
                        }
                    ];
                }
            }

            if (
                activity.source instanceof FormatTypeCopySource &&
                activity.source.storeSettings instanceof HdfsStoreReadSettings &&
                activity.source.storeSettings.distCpSetting != null &&
                activity.source.storeSettings.distCpSetting.useDistCp
            ) {
                return [
                    {
                        context: activity,
                        messageType: 'unsupported',
                        message: () => stringResources.AdditionalColumns_Not_Allow_DistCp
                    }
                ];
            }

            if (activity.source instanceof AmazonRedshiftCopySource && activity.source.enableRedshiftUnloadSettings) {
                return [
                    {
                        context: activity,
                        messageType: 'unsupported',
                        message: () => stringResources.AdditionalColumns_Not_Allow_RedshiftUnload
                    }
                ];
            }
        }

        // validate copy source stored procedure and partition options
        if (
            (activity.source instanceof SqlCopySource || activity.source instanceof SqlDWCopySource) &&
            activity.source.mode === 'storedProcedure' &&
            !stringIsNullOrEmpty(activity.source.readerStoredProcedureName) &&
            !stringIsNullOrEmpty(activity.source.partitionOption) &&
            activity.source.partitionOption !== partitionOptionConst.none
        ) {
            return [
                {
                    context: activity,
                    messageType: 'unsupported',
                    message: () => stringResources.PartitionValidation_StoredProcedure_ErrorMessage,
                    redirectTo: {
                        attribute: SqlTypeCopySource.READER_STORED_PROCEDURE_NAME
                    }
                }
            ];
        }

        const enableTrino = (
            await getServiceInstance<ExposureControlService>(context.contextData, 'ExposureControlService')
        ).enableTrino;
        if (enableTrino && activity.source instanceof TrinoCopySource) {
            const ir = CopyActivity._getRuntimeSelfhostedIR(activity);
            if (!(await validateIRVersion(ir, trinoSHIRVersion, 10, context))) {
                return [
                    {
                        context: activity.mapping,
                        messageType: 'unsupported',
                        message: () =>
                            sanitizeAndFormatString(
                                stringResources.Error_IRLowVersionForV2DatasetPrefix,
                                ir.version,
                                ir.name,
                                trinoSHIRVersion
                            ) +
                            stringResources.Error_IRUpgradeLink +
                            stringResources.Error_IRLowVersionSuffix,
                        doNotAutomaticallyCorrect: true
                    }
                ];
            }
        }

        // if sink enabled copy command, by pass wildcard validation
        return await validateCopySource(
            activity,
            activity.source,
            activity.sourceDataset,
            activity.sinkDataset,
            context
        );
    }

    private static async validateCopySink(
        activity: CopyActivity,
        value?: CopySink,
        violation?: IViolation,
        context?: IValidationContext
    ): Promise<IViolation[] | undefined> {
        const violations: IViolation[] = [];
        const datasetRegistry = await getServiceInstance<DatasetRegistryService>(
            context.contextData,
            'DatasetRegistryService'
        );

        if (activity.copySink != null && activity.sinkDataset != null) {
            const sinkModel = Metamodel.modelOf(activity.copySink);
            const datasetConfig = datasetRegistry.getDatasetConfiguration(Metamodel.modelOf(activity.sinkDataset).name);
            // if tableName is required, it will be validated in dataset.
            if (
                (datasetConfig.datasetKind === 'table' || datasetConfig.datasetKind === 'hierarchical') &&
                !isTableNameRequired(datasetConfig, activity.sinkDataset) &&
                !datasetConfig.disableTableName &&
                !(activity.sinkDataset instanceof EventStreamDataset)
            ) {
                if (activity.sinkDataset instanceof FormatDatasetV2) {
                    // don't do validation for JSON
                } else if (
                    (activity.copySink instanceof SqlSink && activity.copySink.mode === 'table') ||
                    !(activity.copySink instanceof SqlSink)
                ) {
                    if (!hasTableNameOrTable(activity.sinkDataset as TabularTypeDataset)) {
                        violations.push({
                            context: activity,
                            messageType: 'missing',
                            message: () =>
                                format(
                                    stringResources.PropertyRequired_InActivity_Template,
                                    __IS_FABRIC_DPE__
                                        ? `${stringResources.DestinationLabel} ${(datasetConfig.tableNameDisplay || stringResources.ModelName_Table).toLowerCase()}`
                                        : datasetConfig.tableNameDisplay || stringResources.ModelName_Table,
                                    format(stringResources.ModelName_ActivityTemplate, stringResources.Copy)
                                ),
                            redirectTo: {
                                entity: activity.sinkDataset,
                                attribute: !datasetConfig.splitTablePath
                                    ? TabularTypeDataset.TABLE_NAME
                                    : TabularTypeDataset.TABLE
                            }
                        });
                    }
                }
            }

            // validate sql sink stored procedure
            if (activity.copySink instanceof SqlSink) {
                const writeBehavior = ValueAdapter.toResource(activity.copySink, SqlSink.WRITE_BEHAVIOR);
                if (
                    writeBehavior === writeBehaviorOptionValues.storedProcedure &&
                    !stringIsNullOrEmpty(activity.copySink.sqlWriterStoredProcedureName)
                ) {
                    const results: IViolation[] = [];
                    if (
                        stringIsNullOrEmpty(activity.copySink.sqlWriterTableType) &&
                        !SqlSink.WRITER_TABLE_TYPE.templateValue(activity.copySink)
                    ) {
                        results.push({
                            message: () => stringResources.Dataset_WriterStoredProcedure_MissingTableType,
                            redirectTo: {
                                entity: activity.copySink,
                                attribute: SqlSink.WRITER_TABLE_TYPE
                            }
                        });
                    }
                    if (activity.sinkDataset != null && activity.sinkDataset instanceof TabularTypeDataset) {
                        if (
                            valueAndExpressionValueBothEmpty(activity.sinkDataset, TabularTypeDataset.TABLE_NAME) &&
                            valueAndExpressionValueBothEmpty(
                                activity.copySink,
                                SqlSink.WRITER_TABLE_TYPE_PARAMETER_NAME
                            )
                        ) {
                            results.push({
                                message: () =>
                                    stringResources.Dataset_WriterStoredProcedure_MissingTableTypeParameterName,
                                redirectTo: {
                                    entity: activity.copySink,
                                    attribute: SqlSink.WRITER_TABLE_TYPE_PARAMETER_NAME
                                }
                            });
                        }
                    }
                    // auto table creation is not supported when stored procedure is set in sink
                    if (activity.copySink.tableOption === tableOptionValues.autoCreate) {
                        results.push({
                            messageType: 'unsupported',
                            message: () => stringResources.Dataset_Sink_AutoTableCreationWith_SP,
                            redirectTo: {
                                attribute: sinkModel.attribute('tableOption')
                            }
                        });
                    }
                    if (results.length > 0) {
                        return results;
                    }
                }
            }

            if (activity.copySink instanceof SqlSink || activity.copySink instanceof SqlDWSink) {
                // validate tableOption for SqlDW sink, SQL sink and SQL server sink
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (activity.copySink.tableOption === tableOptionValues.autoCreate) {
                    // validate v2 sink dataset
                    if (activity.sinkDataset != null && !activity.sinkDataset.isV2) {
                        violations.push({
                            context: activity,
                            messageType: 'invalid',
                            message: () =>
                                sanitizeAndFormatString(
                                    stringResources.Dataset_WriterTableOptionDatasetV2ValidationErrorTemplate,
                                    stringResources.Sink.toLocaleLowerCase(),
                                    activity.sinkDataset.name
                                ),
                            redirectTo: {
                                attribute: sinkModel.attribute('tableOption')
                            }
                        });
                    }
                    // validate source dataset type
                    if (activity.sourceDataset != null) {
                        const sourceModel = Metamodel.modelOf(activity.sourceDataset);
                        const sourceDatasetConfig = datasetRegistry.getDatasetConfiguration(sourceModel.name);
                        // source is restricted to v2 filetype and tabulartype ds
                        if (
                            (sourceDatasetConfig.datasetKind === 'table' ||
                                sourceDatasetConfig.datasetKind === 'file') &&
                            !activity.sourceDataset.isV2
                        ) {
                            violations.push({
                                context: activity,
                                messageType: 'invalid',
                                message: () =>
                                    sanitizeAndFormatString(
                                        stringResources.Dataset_WriterTableOptionDatasetV2ValidationErrorTemplate,
                                        stringResources.Source_Label.toLocaleLowerCase(),
                                        activity.sourceDataset.name
                                    ),
                                redirectTo: {
                                    attribute: sinkModel.attribute('tableOption')
                                }
                            });
                        }
                    }
                }

                if (
                    ((activity.copySink instanceof SqlSink && activity.copySink.writeBehavior === 'upsert') ||
                        (activity.copySink instanceof SqlDWSink && activity.copySink.copyMethod === 'Upsert')) &&
                    CopyActivity.checkIfEnabledFaultToleranceSettings(activity)
                ) {
                    violations.push({
                        context: activity,
                        messageType: 'unsupported',
                        message: () =>
                            format(
                                stringResources.FaultToleranceWarningInSettingsForSqlUpsert,
                                datasetConfig.displayName.toLocaleLowerCase()
                            ),
                        redirectTo: {
                            attribute: CopyActivity.FAULT_TOLERENCE
                        }
                    });
                }
            }

            if (activity.copySink instanceof FormatTypeCopySink && activity.copySink.storeSettings) {
                violations.push(
                    ...(await CopyActivity.validateCopyBehavior(activity, {
                        dsSvc: datasetRegistry
                    }))
                );
                violations.push(
                    ...(await CopyActivity.validateMaxRowsPerfile(activity, {
                        dsSvc: datasetRegistry
                    }))
                );
            }

            if (activity.copySink instanceof LakehouseTableCopySink && GlobalVariables.timestampNtz && __IS_FABRIC_DPE__) {
                if (
                    activity.copySink.enableTimestampNtz === true &&
                    (activity.sourceDataset == null || !supportedSourceDatasetsForTimestampNtz.includes(Metamodel.modelOf(activity.sourceDataset)?.name))
                ) {
                    violations.push({
                        context: activity,
                        messageType: 'invalid',
                        message: () => stringResources.Dataset_enableTimestampNtzValidationErrorTemplate,
                        redirectTo: {
                            attribute: sinkModel.attribute('enableTimestampNtz')
                        }
                    });
                }
            }

            violations.push(
                ...(await CopyActivity.validateCopyCommandForDWSINK(activity, {
                    dsSvc: datasetRegistry
                }))
            );
        }
        return violations;
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static async validateMaxRowsPerfile(
        activity: CopyActivity,
        services: { dsSvc: DatasetRegistryService }
    ): Promise<IViolation[]> {
        const violations: IViolation[] = [];
        /*
        1. If maxRowsPerFile is not null
            a. sink file name cannot be specified
            b. amazon Redshift source unload, Snowflake source export command are not supported.
        2. If fileNamePrefix is not null
            a. only applies to non-file to file copy without source partition option settings. sql/oracle/saphana/netezza parallel read settings
        */
        if (
            activity.copySink instanceof FormatTypeCopySink &&
            activity.sinkDataset instanceof FormatDatasetV2 &&
            (activity.copySink.formatSettings instanceof ParquetFormatWriteSettings ||
                activity.copySink.formatSettings instanceof DelimitedTextFormatWriteSettings ||
                activity.copySink.formatSettings instanceof DeltaFormatWriteSettings ||
                activity.copySink.formatSettings instanceof OrcFormatWriteSettings ||
                activity.copySink.formatSettings instanceof AvroFormatWriteSettings)
        ) {
            if (activity.copySink.formatSettings.maxRowsPerFile != null) {
                const sinkDataset = activity.sinkDataset;
                if (sinkDataset.location && !sinkDataset.location.isFolder(false)) {
                    violations.push({
                        messageType: 'invalid',
                        message: () =>
                            format(
                                stringResources.ModelName_MaxRows_ValidationError,
                                `${stringResources.SinkDataset} ${stringResources.FileNameLabel}`.toLocaleLowerCase()
                            ),
                        redirectTo: {
                            attribute: FormatWriteSettings.MAXROWS_PER_FILE
                        }
                    });
                }
                if (
                    activity.source instanceof AmazonRedshiftCopySource &&
                    activity.source.enableRedshiftUnloadSettings
                ) {
                    violations.push({
                        messageType: 'invalid',
                        message: () =>
                            format(
                                stringResources.ModelName_MaxRows_ValidationError,
                                stringResources.AmazonRedshift_DisplayText +
                                ` ${stringResources.UnloadSetting_MainGroupLabel}`.toLocaleLowerCase()
                            ),
                        redirectTo: {
                            attribute: FormatWriteSettings.MAXROWS_PER_FILE,
                            entity: activity.copySink
                        }
                    });
                } else if (activity.source instanceof SnowflakeSource) {
                    violations.push({
                        messageType: 'invalid',
                        message: () =>
                            format(
                                stringResources.ModelName_MaxRows_ValidationError,
                                stringResources.Snowflake_DisplayText +
                                ` ${stringResources.Source_Label}`.toLocaleLowerCase()
                            ),
                        redirectTo: {
                            attribute: FormatWriteSettings.MAXROWS_PER_FILE,
                            entity: activity.copySink
                        }
                    });
                }
            }
            if (
                (activity.copySink.formatSettings.maxRowsPerFile != null ||
                    FormatWriteSettings.MAXROWS_PER_FILE.templateValue(activity.copySink.formatSettings)) &&
                activity.copySink.formatSettings.fileNamePrefix &&
                (isFileTypeDataset(activity.sourceDataset, services) ||
                    activity.sourceDataset instanceof JsonDataset ||
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    ((activity.source as any).partitionOption &&
                        !stringsAreEqualCaseInsensitive(
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            (activity.source as any).partitionOption,
                            partitionOptionConst.none
                        )))
            ) {
                violations.push({
                    messageType: 'unsupported',
                    message: () => stringResources.FileNamePrefix_ValidationError,
                    redirectTo: {
                        attribute: FormatWriteSettings.FILENAME_PREFIX,
                        entity: activity.copySink
                    }
                });
            }
            return violations;
        }
        return [];
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    private static validateStorageLinkedServiceAuthForDatabricks(
        linkedService: LinkedService,
        isDirectCopy: boolean,
        isSource: boolean,
        connectorName: string,
        redirectTo: { entity: Activity | Dataset; attribute: IAttribute }
    ): IViolation[] {
        const violations: IViolation[] = [];
        // For direct copy and staged copy auth type rules:
        // @see https://learn.microsoft.com/fabric/data-factory/connector-azure-databricks-copy-activity#prerequisites

        // Both Azure Blob Storage and Azure Blob FS support the same authentication types
        const allowedAuthTypes = [
            azureBlobFSAuthTypes.ServicePrincipalAuthentication,
            azureStorageAuthTypes.AccountKeyAuthentication,
            azureStorageAuthTypes.SasUriAuthentication
        ];

        const storageAuthRequirements: Array<{
            linkedServiceType: typeof AzureBlobFSLinkedService | typeof AzureBlobStorageLinkedService;
            displayName: string;
        }> = [
                {
                    linkedServiceType: AzureBlobFSLinkedService,
                    displayName: stringResources.AzureBlobFS_DisplayText
                },
                {
                    linkedServiceType: AzureBlobStorageLinkedService,
                    displayName: stringResources.AzureBlobStorage_DisplayText
                }
            ];

        const prepositionString = isSource ? stringResources.From.toLocaleLowerCase() : stringResources.To.toLocaleLowerCase();
        const messagePrefix = isDirectCopy
            ? format(stringResources.Connection_DirectCopy_Template, prepositionString, connectorName)
            : format(stringResources.Connection_StagedCopy_Template, prepositionString, connectorName);

        for (const requirement of storageAuthRequirements) {
            if (linkedService instanceof requirement.linkedServiceType) {
                const authMethod = (linkedService as AzureBlobFSLinkedService | AzureBlobStorageLinkedService).authenticationMethod;
                if (!linkedService.fullyByJsonEditor && authMethod && !allowedAuthTypes.includes(authMethod)) {
                    violations.push({
                        messageType: 'unsupported',
                        message: () =>
                            messagePrefix +
                            format(
                                stringResources.AzureDatabricksDeltaLake_StorageAuth_Error,
                                requirement.displayName,
                                formatListWithConjunction(
                                    (allowedAuthTypes as AzureAuthTypes[]).map((t) => AUTHENTICATION_TYPE_TEXTS[t])
                                )
                            ),
                        redirectTo: redirectTo
                    });
                }
                break;
            }
        }
        return violations;
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static async validateAzureDatabricksDeltaLakeSourceDataset(
        activity: CopyActivity,
        services: { dsSvc: DatasetRegistryService }
    ): Promise<IViolation[]> {
        const violations: IViolation[] = [];
        const sourceDataset = activity.sourceDataset;
        const sinkDataset = activity.sinkDataset;
        if (
            isDatabricksFamilyDataset(sourceDataset) &&
            sinkDataset != null &&
            sinkDataset.linkedService != null
        ) {
            const sinkLinkedService = sinkDataset.linkedService;
            const connectorDisplayName = getDatabricksFamilyDisplayName(sourceDataset);
            const ifEnabledStaging = CopyActivity.checkIfEnabledStaging(activity, services);
            if (
                ifEnabledStaging ||
                ((sinkDataset instanceof DelimitedTextDataset ||
                    sinkDataset instanceof ParquetDataset ||
                    sinkDataset instanceof DeltaDataset ||
                    sinkDataset instanceof AvroDataset) &&
                    (sinkLinkedService instanceof AzureBlobStorageLinkedService ||
                        sinkLinkedService instanceof AzureBlobFSLinkedService))
            ) {
                if (__IS_FABRIC_DPE__) {
                    const entity = ifEnabledStaging ? activity : sinkDataset;
                    const attribute = ifEnabledStaging
                        ? CopyActivity.ENABLE_STAGING
                        : Metamodel.modelOf(sinkDataset).attribute('linkedService');
                    const linkedService = ifEnabledStaging
                        ? activity.stagingSettings.storageLinkedService
                        : sinkLinkedService;

                    violations.push(
                        ...CopyActivity.validateStorageLinkedServiceAuthForDatabricks(
                            linkedService,
                            !ifEnabledStaging,
                            true,
                            connectorDisplayName,
                            {
                                entity: entity,
                                attribute: attribute
                            }
                        )
                    );
                }

                if (!ifEnabledStaging) {
                    if (sinkDataset instanceof DelimitedTextDataset) {
                        // check format here
                        const delimitedResult = CopyActivity.validateDelimitedTextDatasetForAzureDatabricksDeltaLake(
                            sinkDataset,
                            stringResources.From,
                            CopyActivity._sinkDatasetLabel,
                            connectorDisplayName
                        );
                        violations.push(...delimitedResult);
                        if (
                            activity.copySink instanceof FormatTypeCopySink &&
                            activity.copySink.formatSettings instanceof DelimitedTextFormatWriteSettings &&
                            !DelimitedTextFormatWriteSettings.FILE_EXTENSION.templateValue(
                                activity.copySink.formatSettings
                            ) &&
                            activity.copySink.formatSettings.fileExtension !== '.csv'
                        ) {
                            violations.push({
                                context: activity,
                                messageType: 'invalid',
                                message: () =>
                                    getConnectionAsSourceDirectCopyErrorMessage(
                                        format(
                                            stringResources.AzureDatabricksDeltaLake_Sink_CSV_FileExtension_Error,
                                            CopyActivity._sinkLabel.toLocaleLowerCase()
                                        ),
                                        stringResources.ModelName_FileExtension,
                                        connectorDisplayName
                                    )
                            });
                        }
                    } else if (sinkDataset instanceof ParquetDataset) {
                        // the supported compression codec is “None”, “Snappy” and “GZip”.
                        const supportedCodec = [
                            compressionCodecType.none,
                            compressionCodecType.gzip,
                            compressionCodecType.snappy
                        ];
                        if (
                            !stringIsNullOrEmpty(sinkDataset.compressionCodec) &&
                            !supportedCodec
                                .map((c) => c.toLowerCase())
                                .includes(sinkDataset.compressionCodec.toLowerCase())
                        ) {
                            violations.push({
                                messageType: 'invalid',
                                message: () =>
                                    getConnectionAsSourceDirectCopyErrorMessage(
                                        format(
                                            stringResources.CopyCommand_CopyMethod_CopyCommandSourceCompression_Error,
                                            CopyActivity._sinkDatasetLabel,
                                            formatListWithConjunction(supportedCodec)
                                        ),
                                        stringResources.ModelName_CompressionType,
                                        connectorDisplayName
                                    ),
                                redirectTo: {
                                    entity: sinkDataset,
                                    attribute: Metamodel.modelOf(sinkDataset).attribute('compressionCodec')
                                }
                            });
                        }
                    }

                    // sink must be a folder
                    if (
                        (sinkDataset as FormatDatasetV2).location == null ||
                        !(sinkDataset as FormatDatasetV2).location.isFolder()
                    ) {
                        violations.push({
                            messageType: 'invalid',
                            message: () =>
                                getConnectionAsSourceDirectCopyErrorMessage(
                                    format(
                                        stringResources.AzureDatabricksDeltaLake_Sink_Folder_Error,
                                        CopyActivity._sinkLabel.toLocaleLowerCase()
                                    ),
                                    stringResources.FilePath_Label,
                                    connectorDisplayName
                                ),
                            redirectTo: {
                                entity: sinkDataset
                            }
                        });
                    }
                }
            } else {
                // not support direct copy, please set staging ls
                violations.push({
                    messageType: 'invalid',
                    message: () =>
                        format(
                            stringResources.Connection_DirectCopy_Template,
                            stringResources.From.toLocaleLowerCase(),
                            connectorDisplayName
                        ) +
                        format(
                            stringResources.DirectCopyOnlySuppported_ErrorTemplate,
                            format(
                                stringResources.AzureDatabricksDeltaLake_DirectCopySupported,
                                CopyActivity._sinkDatasetLabel.toLocaleLowerCase()
                            )
                        ) +
                        stringResources.ForOtherScenarios,
                    redirectTo: {
                        attribute: CopyActivity.ENABLE_STAGING
                    }
                });
            }
        }
        return violations;
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static async validateAzureDatabricksDeltaLakeSinkDataset(
        activity: CopyActivity,
        services: { dsSvc: DatasetRegistryService }
    ): Promise<IViolation[]> {
        const violations: IViolation[] = [];
        const sourceDataset = activity.sourceDataset;
        const sourceLinkedservice = sourceDataset.linkedService;
        const sinkDataset = activity.sinkDataset;

        if (isDatabricksFamilyDataset(sinkDataset) && sourceLinkedservice != null) {
            const connectorDisplayName = getDatabricksFamilyDisplayName(sinkDataset);
            const ifEnabledStaging = CopyActivity.checkIfEnabledStaging(activity, services);
            if (
                ifEnabledStaging ||
                ((sourceDataset instanceof DelimitedTextDataset ||
                    sourceDataset instanceof ParquetDataset ||
                    sourceDataset instanceof AvroDataset) &&
                    (sourceLinkedservice instanceof AzureStorageLinkedService ||
                        sourceLinkedservice instanceof AzureBlobFSLinkedService))
            ) {
                if (__IS_FABRIC_DPE__) {
                    const entity = ifEnabledStaging ? activity : sourceDataset;
                    const attribute = ifEnabledStaging
                        ? CopyActivity.ENABLE_STAGING
                        : Metamodel.modelOf(sourceDataset).attribute('linkedService');
                    const linkedService = ifEnabledStaging
                        ? activity.stagingSettings.storageLinkedService
                        : sourceLinkedservice;

                    violations.push(
                        ...CopyActivity.validateStorageLinkedServiceAuthForDatabricks(
                            linkedService,
                            !ifEnabledStaging,
                            false,
                            connectorDisplayName,
                            {
                                entity: entity,
                                attribute: attribute
                            }
                        )
                    );
                }

                if (!ifEnabledStaging) {
                    // validate source dataset format
                    violations.push(
                        ...(await CopyActivity.validateSourceForDirectCopyWithAzureDatabricksDeltaSink(activity))
                    );
                }
            } else {
                // not support direct copy, please set staging ls
                violations.push({
                    messageType: 'invalid',
                    message: () =>
                        format(
                            stringResources.Connection_DirectCopy_Template,
                            stringResources.To.toLocaleLowerCase(),
                            connectorDisplayName
                        ) +
                        format(
                            stringResources.DirectCopyOnlySuppported_ErrorTemplate,
                            format(
                                stringResources.AzureDatabricksDeltaLake_DirectCopySupported,
                                CopyActivity._sourceDatasetLabel.toLocaleLowerCase()
                            )
                        ) +
                        stringResources.ForOtherScenarios,
                    redirectTo: {
                        attribute: CopyActivity.ENABLE_STAGING
                    }
                });
            }
        }
        return violations;
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static isEmptystorageIntegration(activity: CopyActivity): boolean {
        // default check if both source and sink storage integration are empty
        return (
            stringIsNullOrEmpty((activity.copySink as SnowflakeV2Sink)?.importSettings?.storageIntegration) &&
            stringIsNullOrEmpty((activity.source as SnowflakeV2Source)?.exportSettings?.storageIntegration) &&
            ImportExportSettings.STORAGE_INTEGRATION.templateValue(
                (activity.source as SnowflakeV2Source)?.exportSettings
            ) == null &&
            ImportExportSettings.STORAGE_INTEGRATION.templateValue(
                (activity.copySink as SnowflakeV2Sink)?.importSettings
            ) == null
        );
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static async validateSnowflakeSourceDataset(
        activity: CopyActivity,
        context: IValidationContext,
        requireBlobAuthTypesCheck: boolean = true
    ): Promise<IViolation[]> {
        const violations: IViolation[] = [];
        const sourceDataset = activity.sourceDataset;
        const sinkDataset = activity.sinkDataset;
        const copySink = activity.copySink;
        if (sourceDataset instanceof SnowflakeTableDataset && sinkDataset?.linkedService != null && copySink != null) {
            const sinkLinkedService = sinkDataset.linkedService;
            const dsSvc = await getServiceInstance<DatasetRegistryService>(
                context.contextData,
                'DatasetRegistryService'
            );
            const ifEnabledStaging = CopyActivity.checkIfEnabledStaging(activity, { dsSvc });
            const supportedDatasetType = [DelimitedTextDataset, ParquetDataset, DeltaDataset, JsonDataset];
            if (
                ifEnabledStaging ||
                (supportedDatasetType.find((t) => sinkDataset instanceof t) &&
                    sinkLinkedService instanceof AzureBlobStorageLinkedService)
            ) {
                const lsForValidation = ifEnabledStaging
                    ? activity.useFabricBuiltInStaging
                        ? undefined
                        : activity.stagingSettings.storageLinkedService
                    : sinkLinkedService;
                const messagePrefix = ifEnabledStaging
                    ? format(stringResources.Snowflake_StagedCopy, stringResources.From.toLocaleLowerCase())
                    : format(stringResources.Snowflake_DirectCopy_Template, stringResources.From.toLocaleLowerCase());
                if (
                    ifEnabledStaging &&
                    ImportExportSettings.STORAGE_INTEGRATION.templateValue(
                        (activity.source as SnowflakeV2Source)?.exportSettings
                    ) == null &&
                    !stringIsNullOrEmpty((activity.source as SnowflakeV2Source).exportSettings?.storageIntegration)
                ) {
                    if (
                        Metamodel.modelOf(activity).name !== ModelConstants.copyJobActivity &&
                        !GlobalVariables.enableSnowflakeBuiltinStorageIntegration &&
                        activity.useFabricBuiltInStaging
                    ) {
                        // storage integration cannot be used with workspace staging at the same time
                        violations.push({
                            message: () => stringResources.StorageIntegration_BuiltIn_Validation_Message,
                            redirectTo: {
                                entity: activity,
                                attribute: CopyActivity.ENABLE_STAGING
                            }
                        });
                    } else if (
                        !activity.useFabricBuiltInStaging &&
                        activity.stagingSettings.storageLinkedService != null &&
                        StagingSettings.PATH.templateValue(activity.stagingSettings) == null &&
                        stringIsNullOrEmpty(activity.stagingSettings.path)
                    ) {
                        // Storage path is required when storage integration is enabled
                        violations.push({
                            message: () => stringResources.Snowflake_Staging_StoragePath_Validation_Message,
                            redirectTo: {
                                entity: activity,
                                attribute: StagingSettings.PATH
                            }
                        });
                    }
                }
                if (
                    requireBlobAuthTypesCheck &&
                    lsForValidation instanceof AzureBlobStorageLinkedService &&
                    lsForValidation.authenticationMethod !== azureStorageAuthTypes.SasUriAuthentication &&
                    !lsForValidation.fullyByJsonEditor
                ) {
                    const message = (isV1: boolean): string =>
                        getSnowflakeCopyMethodValidationMessage(
                            messagePrefix,
                            isV1,
                            !ifEnabledStaging ? CopyActivity._sinkLabel : ''
                        );
                    const entity = ifEnabledStaging ? activity : sinkDataset;
                    const attribute = ifEnabledStaging
                        ? CopyActivity.ENABLE_STAGING
                        : Metamodel.modelOf(sinkDataset).attribute('linkedService');
                    if (this.isEmptystorageIntegration(activity)) {
                        const isV1 = !(activity.source instanceof SnowflakeV2Source);
                        violations.push({
                            messageType: 'unsupported',
                            message: () => message(isV1),
                            redirectTo: {
                                entity,
                                attribute
                            }
                        });
                    }
                    if (!ifEnabledStaging &&
                        __IS_FABRIC_DPE__ && !GlobalVariables.bypassSnowflakeStagingUserAuth &&
                        lsForValidation.authenticationMethod === azureStorageAuthTypes.UserAuth) {
                        violations.push({
                            messageType: 'unsupported',
                            message: () =>
                                format(
                                    stringResources.StagingSetting_ErrorMessage_ShouldNotBe_Template,
                                    stringResources.DestinationConnection,
                                    AUTHENTICATION_TYPE_TEXTS[azureStorageAuthTypes.UserAuth]
                                ),
                            redirectTo: {
                                entity,
                                attribute
                            }
                        });
                    }
                }
                if (!ifEnabledStaging) {
                    // compression codec
                    if (
                        sinkDataset instanceof ParquetDataset ||
                        sinkDataset instanceof JsonDataset
                    ) {
                        const supportedCodec =
                            sinkDataset instanceof JsonDataset
                                ? [
                                    compressionCodecType.none,
                                    compressionCodecType.gzip,
                                    compressionCodecType.deflate,
                                    compressionCodecType.bzip2
                                ]
                                : [compressionCodecType.none, compressionCodecType.snappy, compressionCodecType.lzo];
                        if (
                            !stringIsNullOrEmpty(sinkDataset.compressionCodec) &&
                            !supportedCodec
                                .map((c) => c.toLowerCase())
                                .includes(sinkDataset.compressionCodec.toLowerCase())
                        ) {
                            violations.push({
                                messageType: 'invalid',
                                message: () =>
                                    getConnectionAsSourceDirectCopyErrorMessage(
                                        format(
                                            stringResources.CopyCommand_CopyMethod_CopyCommandSourceCompression_Error,
                                            CopyActivity._sinkDatasetLabel,
                                            formatListWithConjunction(supportedCodec)
                                        ),
                                        stringResources.ModelName_CompressionType,
                                        stringResources.Snowflake_DisplayText
                                    ),
                                redirectTo: {
                                    entity: sinkDataset,
                                    attribute: Metamodel.modelOf(sinkDataset).attribute('compressionCodec')
                                }
                            });
                        }
                    }

                    if (sinkDataset instanceof DelimitedTextDataset || sinkDataset instanceof JsonDataset) {
                        // encodingName UTF-8
                        if (
                            !stringIsNullOrEmpty(sinkDataset.encodingName) &&
                            !snowflakeSupportedSinkEncodingName.includes(sinkDataset.encodingName.toUpperCase())
                        ) {
                            violations.push({
                                messageType: 'invalid',
                                message: () =>
                                    getConnectionAsSourceDirectCopyErrorMessage(
                                        format(
                                            stringResources.CopyCommand_CopyMethod_CopyCommandEncodingName_Error,
                                            CopyActivity._sinkDatasetLabel,
                                            formatListWithConjunction(snowflakeSupportedSinkEncodingName)
                                        ),
                                        stringResources.ModelName_Encoding,
                                        stringResources.Snowflake_DisplayText
                                    ),
                                redirectTo: {
                                    entity: sinkDataset,
                                    attribute: Metamodel.modelOf(sinkDataset).attribute('encodingName')
                                }
                            });
                        }

                        if (sinkDataset instanceof DelimitedTextDataset) {
                            violations.push(
                                ...CopyActivity.validateDelimitedTextDatasetForSnowflake(
                                    sinkDataset,
                                    stringResources.From,
                                    CopyActivity._sinkDatasetLabel
                                )
                            );
                        } else if (sinkDataset instanceof JsonDataset) {
                            // filePattern setOfObjects
                            // not support mapping
                            if (!arrayIsNullOrEmpty(activity.mappingV2)) {
                                violations.push({
                                    messageType: 'invalid',
                                    message: () =>
                                        getConnectionAsSourceDirectCopyErrorMessage(
                                            stringResources.Snowflake_DirectCopy_CopyMapping_Error,
                                            stringResources.CopyWizard_Dataset_ColumnMapping_PageHeader,
                                            stringResources.Snowflake_DisplayText
                                        ),
                                    redirectTo: {
                                        attribute: CopyActivity.ENABLE_STAGING
                                    }
                                });
                            }

                            if (
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                (copySink as any).formatSettings instanceof JsonFormatWriteSettings &&
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                !stringIsNullOrEmpty((copySink as any).formatSettings.filePattern) &&
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                (copySink as any).formatSettings.filePattern !== 'setOfObjects'
                            ) {
                                violations.push({
                                    messageType: 'invalid',
                                    message: () =>
                                        getConnectionAsSourceDirectCopyErrorMessage(
                                            stringResources.CopyCommand_CopyMethod_CopyCommandJSONFilePattern_Error,
                                            stringResources.Dataset_FileFormat_FilePatternLabel,
                                            stringResources.Snowflake_DisplayText
                                        ),
                                    redirectTo: {
                                        entity: copySink,
                                        attribute: JsonFormatWriteSettings.PATTERN
                                    }
                                });
                            }
                            // early throw static violations
                            if (!arrayIsNullOrEmpty(violations)) {
                                return violations;
                            }
                            if (context && !context.isRetryStage) {
                                // validate schema in snowflake dataset
                                const schemaViolations = await CopyActivity.validateSnowflakeSchema(
                                    activity.sourceDataset,
                                    activity.source as TabularCopySource,
                                    context
                                );
                                if (!arrayIsNullOrEmpty(schemaViolations)) {
                                    return schemaViolations;
                                }
                            }
                        }
                    }
                }
            } else if (!(activity.copySink instanceof SqlDWSink)) {
                // not support direct copy, please set staging ls
                // SqlDWSink will be validated later
                violations.push({
                    messageType: 'unsupported',
                    message: () =>
                        format(
                            stringResources.Snowflake_DirectCopy_Template,
                            stringResources.From.toLocaleLowerCase()
                        ) +
                        format(
                            stringResources.DirectCopyOnlySuppported_ErrorTemplate,
                            stringResources.Snowflake_DirectCopySupported_Sink
                        ) +
                        stringResources.ForOtherScenarios,
                    redirectTo: {
                        attribute: CopyActivity.ENABLE_STAGING
                    }
                });
            }
            if (activity.copySink instanceof SqlDWSink) {
                if (!ifEnabledStaging || CopyActivity.checkIfEnabledPolybase(activity)) {
                    // copy command /bulk insert + staged
                    violations.push({
                        messageType: 'unsupported',
                        message: () =>
                            formatSQLDWMessage(
                                activity.copySink,
                                stringResources.Snowflake_SQLDW_ErrorMessage_Template
                            ),
                        redirectTo: {
                            attribute: CopyActivity.ENABLE_STAGING
                        }
                    });
                }
            }
        }
        return violations;
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static async validateSnowflakeSinkDataset(
        activity: CopyActivity,
        context: IValidationContext,
        requireBlobAuthTypesCheck: boolean = true
    ): Promise<IViolation[]> {
        const violations: IViolation[] = [];
        const sourceDataset = activity.sourceDataset;
        const sourceLinkedservice = sourceDataset?.linkedService;
        const sinkDataset = activity.sinkDataset;

        if (sinkDataset instanceof SnowflakeTableDataset && sourceLinkedservice != null) {
            const dsSvc = await getServiceInstance<DatasetRegistryService>(
                context.contextData,
                'DatasetRegistryService'
            );
            const ifEnabledStaging = CopyActivity.checkIfEnabledStaging(activity, { dsSvc });
            if (
                ifEnabledStaging ||
                ((sourceDataset instanceof DelimitedTextDataset ||
                    sourceDataset instanceof ParquetDataset ||
                    sourceDataset instanceof JsonDataset) &&
                    (sourceLinkedservice instanceof AzureStorageLinkedService ||
                        sourceLinkedservice instanceof AmazonS3LinkedService))
            ) {
                // Sample dataet is using anonymous auth. Snowflake doesn't support direct copy for it.
                if (!ifEnabledStaging && sourceDataset.isSampleDataset) {
                    violations.push({
                        messageType: 'unsupported',
                        message: () => stringResources.DirectCopyToSnowflakeFromSampleDatasetError,
                        redirectTo: {
                            attribute: CopyActivity.ENABLE_STAGING
                        }
                    });
                    return violations;
                }
                // support direct/staged copy
                // validate sourcels auth type
                const lsForValidation = ifEnabledStaging
                    ? activity.useFabricBuiltInStaging
                        ? undefined
                        : activity.stagingSettings.storageLinkedService
                    : sourceLinkedservice;
                const messagePrefix = ifEnabledStaging
                    ? format(stringResources.Snowflake_StagedCopy, stringResources.To.toLocaleLowerCase())
                    : format(stringResources.Snowflake_DirectCopy_Template, stringResources.To.toLocaleLowerCase());
                if (
                    ifEnabledStaging &&
                    ImportExportSettings.STORAGE_INTEGRATION.templateValue(
                        (activity.copySink as SnowflakeV2Sink)?.importSettings
                    ) == null &&
                    !stringIsNullOrEmpty((activity.copySink as SnowflakeV2Sink).importSettings?.storageIntegration)
                ) {
                    if (
                        Metamodel.modelOf(activity).name !== ModelConstants.copyJobActivity &&
                        !GlobalVariables.enableSnowflakeBuiltinStorageIntegration &&
                        activity.useFabricBuiltInStaging
                    ) {
                        // storage integration cannot be used with workspace staging at the same time
                        violations.push({
                            message: () => stringResources.StorageIntegration_BuiltIn_Validation_Message,
                            redirectTo: {
                                entity: activity,
                                attribute: CopyActivity.ENABLE_STAGING
                            }
                        });
                    } else if (
                        !activity.useFabricBuiltInStaging &&
                        activity.stagingSettings.storageLinkedService != null &&
                        StagingSettings.PATH.templateValue(activity.stagingSettings) == null &&
                        stringIsNullOrEmpty(activity.stagingSettings.path)
                    ) {
                        // Storage path is required when storage integration is enabled
                        violations.push({
                            message: () => stringResources.Snowflake_Staging_StoragePath_Validation_Message,
                            redirectTo: {
                                entity: activity,
                                attribute: StagingSettings.PATH
                            }
                        });
                    }
                }
                if (
                    requireBlobAuthTypesCheck &&
                    lsForValidation instanceof AzureBlobStorageLinkedService &&
                    lsForValidation.authenticationMethod !== azureStorageAuthTypes.SasUriAuthentication &&
                    !lsForValidation.fullyByJsonEditor
                ) {
                    const message = (isV1: boolean): string =>
                        getSnowflakeCopyMethodValidationMessage(
                            messagePrefix,
                            isV1,
                            !ifEnabledStaging ? stringResources.Source_Label : ''
                        );
                    const entity = ifEnabledStaging ? activity : sourceDataset;
                    const attribute = ifEnabledStaging
                        ? CopyActivity.ENABLE_STAGING
                        : Metamodel.modelOf(sourceDataset).attribute('linkedService');
                    if (this.isEmptystorageIntegration(activity)) {
                        const isV1 = !(activity.copySink instanceof SnowflakeV2Sink);
                        violations.push({
                            messageType: 'unsupported',
                            message: () => message(isV1),
                            redirectTo: {
                                entity,
                                attribute
                            }
                        });
                    }
                    if (!ifEnabledStaging &&
                        __IS_FABRIC_DPE__ && !GlobalVariables.bypassSnowflakeStagingUserAuth &&
                        lsForValidation.authenticationMethod === azureStorageAuthTypes.UserAuth) {
                        violations.push({
                            messageType: 'unsupported',
                            message: () =>
                                format(
                                    stringResources.StagingSetting_ErrorMessage_ShouldNotBe_Template,
                                    stringResources.SourceConnection,
                                    AUTHENTICATION_TYPE_TEXTS[azureStorageAuthTypes.UserAuth]
                                ),
                            redirectTo: {
                                entity,
                                attribute
                            }
                        });
                    }
                }
                if (!ifEnabledStaging) {
                    // validate source dataset format
                    let sourceDatasetViolations = await CopyActivity.validateSourceForDirectCopyWithSnowflakeSink(
                        activity,
                        context
                    );
                    if (sourceDataset.isSampleDataset && sourceDatasetViolations.length > 1) {
                        sourceDatasetViolations = sourceDatasetViolations.slice(0, 1); // only keep the first one for sample dataset
                    }
                    violations.push(...sourceDatasetViolations);
                }
            } else {
                // not support direct copy, please set staging ls
                violations.push({
                    messageType: 'unsupported',
                    message: () =>
                        format(stringResources.Snowflake_DirectCopy_Template, stringResources.To.toLocaleLowerCase()) +
                        format(
                            stringResources.DirectCopyOnlySuppported_ErrorTemplate,
                            stringResources.Snowflake_DirectCopySupported_Source
                        ) +
                        stringResources.ForOtherScenarios,
                    redirectTo: {
                        attribute: CopyActivity.ENABLE_STAGING
                    }
                });
            }
        }
        return violations;
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static async validateOracleSourceDataset(
        activity: CopyActivity,
        context: IValidationContext
    ): Promise<IViolation[]> {
        const violations: IViolation[] = [];
        const sourceDataset = activity.sourceDataset;
        const oracleSource = activity.source as OracleCopySource;

        if (!(activity.source instanceof OracleCopySource)) {
            return violations;
        }

        if (oracleSource.numberPrecision != null || oracleSource.numberScale != null) {
            // SHIR Version check
            const ir = CopyActivity._getRuntimeSelfhostedIR(activity);
            const lsLabel =
                Metamodel.modelOf(activity.sourceDataset).name === adfModelTypeMap.oracle.datasetType
                    ? stringResources.Oracle_DisplayText
                    : stringResources.AmazonRdsForOracle_DisplayText;
            if (!(await validateIRVersion(ir, oracleV2PrecisionAndScaleVersion, 10, context))) {
                violations.push({
                    message: () =>
                        sanitizeAndFormatString(
                            stringResources.Error_IRLowVersionValidationMessage,
                            ir.version,
                            ir.name,
                            oracleV2PrecisionAndScaleVersion,
                            lsLabel + ' ' + stringResources.Oracle_NumberSettings
                        ) +
                        stringResources.Error_IRUpgradeLink +
                        stringResources.Error_IRLowVersionSuffix,
                    redirectTo: {
                        entity: sourceDataset,
                        attribute: Metamodel.modelOf(sourceDataset).attribute('linkedService')
                    },
                    doNotAutomaticallyCorrect: true
                });
            }
        }
        return violations;
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static async validateTeradataSinkDataset(
        activity: CopyActivity,
        context: IValidationContext
    ): Promise<IViolation[]> {
        const violations: IViolation[] = [];
        const sourceDataset = activity.sourceDataset;
        const sourceLinkedservice = sourceDataset?.linkedService;
        const sinkDataset = activity.sinkDataset;

        if (!(sinkDataset instanceof TeradataDataset)) {
            return violations;
        }

        if ((sinkDataset.linkedService as TeradataLinkedService).version !== driverVersions.v2) {
            violations.push({
                message: () => stringResources.TeradataSinkReferenceOldLinkedServiceErrorMessage
            });
            return violations;
        }

        if (sourceLinkedservice != null) {
            const dsSvc = await getServiceInstance<DatasetRegistryService>(
                context.contextData,
                'DatasetRegistryService'
            );
            const ifEnabledStaging = CopyActivity.checkIfEnabledStaging(activity, { dsSvc });
            if (
                ifEnabledStaging ||
                ((sourceDataset instanceof DelimitedTextDataset || sourceDataset instanceof ParquetDataset) &&
                    (sourceLinkedservice instanceof AzureBlobStorageLinkedService ||
                        sourceLinkedservice instanceof AzureBlobFSLinkedService))
            ) {
                // support direct/staged copy
                // validate source ls auth type
                const sourceAuthTypesResult = validateSourceAuthTypesForTeradata(
                    activity,
                    sourceDataset,
                    sourceLinkedservice,
                    ifEnabledStaging
                );
                violations.push(...sourceAuthTypesResult);
                if (!ifEnabledStaging) {
                    // validate source dataset format
                    const sourceDatasetViolations =
                        await CopyActivity._validateSourceForDirectCopyWithTeradate(activity);

                    violations.push(...sourceDatasetViolations);
                }
            } else {
                // not support direct copy, please set staging ls
                violations.push({
                    messageType: 'unsupported',
                    message: () =>
                        format(
                            stringResources.Connection_DirectCopy_Template,
                            stringResources.To.toLocaleLowerCase(),
                            stringResources.Teradata_DisplayText
                        ) +
                        format(
                            stringResources.DirectCopyOnlySuppported_ErrorTemplate,
                            stringResources.Teradata_DirectCopySupported_Source
                        ) +
                        stringResources.ForOtherScenarios,
                    redirectTo: {
                        attribute: CopyActivity.ENABLE_STAGING
                    }
                });
            }
        }
        return violations;
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static async validateSnowflakeSchema(
        dataset: SnowflakeTableDataset,
        copySource: TabularCopySource,
        context: IValidationContext
    ): Promise<IViolation[]> {
        try {
            const resource = (await ModelUtilties.toResource(
                AdapterContext.defaultContextOf(context.contextData),
                dataset
            )) as Model.DatasetResource;
            const copySourceResource =
                copySource != null
                    ? await ModelUtilties.toResource(AdapterContext.defaultContextOf(context.contextData), copySource)
                    : {};
            mergeSourceSinkToDataset(resource, copySourceResource);
            const parametersNeedAdhocValues = extractParametersFromResource(resource);
            // call query API only when there's no parameter in resources
            if (!parametersNeedAdhocValues || parametersNeedAdhocValues.length === 0) {
                const apiService = await getServiceInstance<QueryApiFactoryService>(
                    context.contextData,
                    'QueryApiFactoryService'
                );

                const columns = (await apiService.getMadridQueryApi().getSchemaAsync(dataset.linkedService, resource))
                    .tabularSchema;
                // only validate columns is not emtpty, and with reuqired nativedata type
                if (
                    columns &&
                    columns.length > 0 &&
                    !(
                        columns.length === 1 &&
                        columns[0].nativeDataType &&
                        ['variant', 'object', 'array'].indexOf(columns[0].nativeDataType.toLowerCase()) > -1
                    )
                ) {
                    return [
                        {
                            messageType: 'invalid',
                            message: () => stringResources.Snowflake_JSON_Schema_Error,
                            context: dataset,
                            doNotAutomaticallyCorrect: true
                        }
                    ];
                }
            }
        } catch (error) {
            // swallow error
        }
        return [];
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static async validateCopyCommandForDWSINK(
        activity: CopyActivity,
        services: { dsSvc: DatasetRegistryService }
    ): Promise<IViolation[]> {
        const violations: IViolation[] = [];
        if (activity.copySink instanceof SqlDWSink) {
            const sourceDataset = activity.sourceDataset;
            const sinkDataset = activity.sinkDataset;
            const isSCD2 = Metamodel.modelOf(activity).name === ModelConstants.copyJobActivity
                && activity.copySink.copyMethod === copyMethodOptionValues.SCD2;
            if ((CopyActivity.checkIfEnabledCopyCommand(activity) || isSCD2) && sourceDataset != null && sinkDataset != null) {
                const stagingEnabled = CopyActivity.checkIfEnabledStaging(activity, services);
                // only support v2 dataset, regardless staging is enabled or not
                if (!sourceDataset.isV2) {
                    return [
                        {
                            messageType: 'unsupported',
                            message: () =>
                                formatSQLDWMessage(
                                    activity.copySink,
                                    stringResources.CopyCommand_CopyMethod_CopyCommandSource_Error_Template_v1
                                ),
                            redirectTo: {
                                attribute: Metamodel.modelOf(activity).attribute('sourceDataset')
                            },
                            doNotAutomaticallyCorrect: true
                        }
                    ];
                }
                if (!stagingEnabled) {
                    // keep all existing validations
                    if (
                        sourceDataset instanceof DelimitedTextDataset ||
                        sourceDataset instanceof ParquetDataset ||
                        sourceDataset instanceof OrcDataset
                    ) {
                        if (
                            activity.sourceDataset instanceof ParquetDataset &&
                            activity.copySink instanceof DataWarehouseCopySink &&
                            activity.faultTolerenceSettings?.enableSkipIncompatibleRow
                        ) {
                            // not support direct copy, please set staging ls
                            violations.push({
                                messageType: 'unsupported',
                                message: () => stringResources.DataWarehouse_DirectCopy_Template,
                                redirectTo: {
                                    attribute: CopyActivity.ENABLE_STAGING
                                }
                            });
                        }
                        violations.push(
                            ...(await CopyActivity._checkSourceLinkedserviceForCopyCommand(activity, false))
                        );
                        if (sourceDataset.isSampleDataset && violations.length > 0) {
                            return violations; // For sample dataset, we should stop as long as we hit the first error because the message is the same.
                        }
                        let sourceDatasetViolations = await CopyActivity._checkSourceDatasetForCopyCommand(activity);
                        if (sourceDataset.isSampleDataset && sourceDatasetViolations.length > 1) {
                            sourceDatasetViolations = sourceDatasetViolations.slice(0, 1); // only keep the first one for sample dataset
                        }
                        violations.push(...sourceDatasetViolations);
                    } else if (!(sourceDataset instanceof SnowflakeTableDataset)) {
                        return [
                            {
                                messageType: 'unsupported',
                                message: () =>
                                    formatSQLDWMessage(
                                        activity.copySink,
                                        stringResources.CopyCommand_CopyMethod_CopyCommandSource_Error_Template
                                    ),
                                redirectTo: {
                                    attribute: CopyActivity.ENABLE_STAGING
                                },
                                doNotAutomaticallyCorrect: true
                            }
                        ];
                    }
                } else {
                    // faulty tolerance linked service can only be blob and blob fs, if blob, MSI auth is not supported
                    violations.push(...(await CopyActivity.validateFaultToleranceForCopyCommand(activity)));
                }
            }
        }
        return violations;
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static validateFaultToleranceSettings(copy: CopyActivity): IViolation[] | undefined {
        // If enableStaging is checked but staging linked service is not selected
        if (
            copy.faultTolerenceSettings &&
            copy.faultTolerenceSettings.incompatibleRowLoggingLinkedService instanceof AzureStorageLinkedService &&
            !stringIsNullOrEmpty(copy.faultTolerenceSettings.incompatibleRowLoggingfolderPath) &&
            !Constants.blobContainerNameValidation.test(copy.faultTolerenceSettings.incompatibleRowLoggingfolderPath)
        ) {
            return [
                {
                    messageType: 'invalid',
                    message: () => stringResources.CopyWizard_Dataset_Blob_Sink_ContainerValidationError
                }
            ];
        }
        if (copy.faultTolerenceSettings?.useNewFaultTolerance) {
            if (
                (copy.faultTolerenceSettings.enableSkipMissingFile ||
                    FaultTolerenceSettings.ENABLE_SKIP_MISSING_FILE.templateValue(copy.faultTolerenceSettings)) &&
                !supportSkipMissingFile(copy.sourceDataset, copy.sinkDataset, copy.source)
            ) {
                return [
                    {
                        context: copy,
                        messageType: 'unsupported',
                        message: () => sanitizeAndFormatString(stringResources.SkipMissingFileNotSupported, copy.name)
                    }
                ];
            }
            if (
                (copy.faultTolerenceSettings.enableSkipForbiddenFile ||
                    FaultTolerenceSettings.ENABLE_SKIP_FORBIDDEN_FILE.templateValue(copy.faultTolerenceSettings)) &&
                !supportSkipForbiddenFile(copy.sourceDataset, copy.sinkDataset, copy.source)
            ) {
                return [
                    {
                        context: copy,
                        messageType: 'unsupported',
                        message: () => sanitizeAndFormatString(stringResources.SkipForbiddenFileNotSupported, copy.name)
                    }
                ];
            }
        }
        return undefined;
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static async validateStagingSetting(
        copy: CopyActivity,
        _value: StagingSettings,
        _violation: IViolation,
        context: IValidationContext
    ): Promise<IViolation[] | undefined> {
        const dsSvc = await getServiceInstance<DatasetRegistryService>(context.contextData, 'DatasetRegistryService');
        // If enableStaging is checked but staging linked service is not selected
        if (copy.enableStaging || ValueAdapter.isTemplated(copy, CopyActivity.ENABLE_STAGING)) {
            const result: IViolation[] = [];
            if (
                !copy.useFabricBuiltInStaging &&
                (copy.stagingSettings == null || copy.stagingSettings.storageLinkedService == null)
            ) {
                result.push({
                    messageType: 'invalid',
                    message: () =>
                        format(
                            stringResources.StagingSetting_ErrorMessage_MissingLinkedService,
                            __IS_FABRIC_DPE__
                                ? stringResources.ConnectionLabel.toLocaleLowerCase()
                                : stringResources.LinkedServiceLowerCase
                        )
                });
            }

            if (!copy.useFabricBuiltInStaging) {
                if (
                    copy.stagingSettings.storageLinkedService instanceof AzureBlobStorageLinkedService &&
                    copy.stagingSettings.storageLinkedService.authenticationMethod === azureStorageAuthTypes.Anonymous
                ) {
                    result.push({
                        messageType: 'unsupported',
                        message: () =>
                            format(
                                stringResources.Anonymous_BlobStorage_ErrorTemplate,
                                stringResources.StagingSetting_MainGroupLabel.toLocaleLowerCase()
                            )
                    });
                } else if (copy.stagingSettings.storageLinkedService) {
                    result.push(...validateLinkedServicePermission(copy.stagingSettings.storageLinkedService, context));
                }
                result.push(...validatePathInStagingAndLoggingSettings(copy.stagingSettings));
            }

            if (!arrayIsNullOrEmpty(result)) {
                return result;
            }
        }
        const isStagingEnabled = CopyActivity.checkIfEnabledStaging(copy, { dsSvc });

        // when copy from Redshift to DW, staging and unload can only be used at the same time when polybase is enabled
        if (isStagingEnabled) {
            if (
                copy.source != null &&
                copy.source instanceof AmazonRedshiftCopySource &&
                copy.source.enableRedshiftUnloadSettings &&
                copy.copySink != null &&
                CopyActivity.copySinkAllowPolybaseDisabled(copy)
            ) {
                return [
                    {
                        messageType: 'invalid',
                        message: () =>
                            formatSQLDWMessage(
                                copy.copySink,
                                stringResources.CopyWizard_Settings_UnloadStagingEnabledValidation_Template
                            )
                    }
                ];
            }
            // blobfs staging linked service doesn't supported with discp settings, snowflake source/sink
            const gen2Violation = CopyActivity.validateGen2StagingSettings(copy);
            if (!arrayIsNullOrEmpty(gen2Violation)) {
                return gen2Violation;
            }

            const userAuthViolation = CopyActivity.validateUserAuthForSnowflakeStagingSettings(copy);
            if (!arrayIsNullOrEmpty(userAuthViolation)) {
                return userAuthViolation;
            }

            const tdwViolation = CopyActivity.validateStagingSettingForTDW(copy, { dsSvc });
            if (tdwViolation) {
                return tdwViolation;
            }
        }

        const allowPolybase: boolean = CopyActivity.checkIfEnabledPolybase(copy);
        if (isStagingEnabled || !allowPolybase) {
            if (!copy.useFabricBuiltInStaging) {
                // if staging enabled and polybase enabled, staging blob and gen2 linkedservice auth type should be account key or MSI
                let allowedStagingAuthTypes: string[] = [
                    azureStorageAuthTypes.AccountKeyAuthentication,
                    azureStorageAuthTypes.MSIAuthentication
                ];
                if (
                    copy.stagingSettings.storageLinkedService instanceof AzureBlobStorageLinkedService ||
                    copy.stagingSettings.storageLinkedService instanceof AzureStorageLinkedService
                ) {
                    allowedStagingAuthTypes = allowedStagingAuthTypes.concat(
                        GlobalVariables.enableCopyStagingBlobSPN
                            ? [azureStorageAuthTypes.ServicePrincipalAuthentication]
                            : []
                    );
                }
                if (isStagingEnabled && allowPolybase) {
                    if (
                        copy.stagingSettings.storageLinkedService instanceof AzureBlobStorageLinkedService ||
                        copy.stagingSettings.storageLinkedService instanceof AzureStorageLinkedService ||
                        copy.stagingSettings.storageLinkedService instanceof AzureBlobFSLinkedService
                    ) {
                        if (
                            !copy.stagingSettings.storageLinkedService.fullyByJsonEditor &&
                            !allowedStagingAuthTypes.includes(
                                copy.stagingSettings.storageLinkedService.authenticationMethod
                            )
                        ) {
                            return [
                                {
                                    context: copy.stagingSettings.storageLinkedService,
                                    messageType: 'invalid',
                                    message: () =>
                                        format(
                                            stringResources.StagingSetting_ErrorMessage_ShouldBe_Template,
                                            stringResources.StagingSetting_LinkedServiceLabel,
                                            formatListWithConjunction(
                                                (allowedStagingAuthTypes as AzureAuthTypes[]).map(
                                                    (t) => AUTHENTICATION_TYPE_TEXTS[t]
                                                )
                                            )
                                        )
                                }
                            ];
                        }
                    }
                }
            }
            return undefined;
        } else {
            return CopyActivity.checkIfSupportDirectPolybase(copy);
        }
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static validateStagingSettingForWizard(
        copy: CopyActivity,
        services: { dsSvc: DatasetRegistryService }
    ): IViolation[] | undefined {
        // If enableStaging is checked but staging linked service is not selected
        if (copy.enableStaging && !copy.useFabricBuiltInStaging && copy.stagingSettings?.storageLinkedService == null) {
            return [
                {
                    message: () =>
                        format(
                            stringResources.StagingSetting_ErrorMessage_MissingLinkedService,
                            __IS_FABRIC_DPE__
                                ? stringResources.ConnectionLabel.toLocaleLowerCase()
                                : stringResources.LinkedServiceLowerCase
                        )
                }
            ];
        }
        const stagingAccountSelected =
            copy.enableStaging && (copy.stagingSettings?.storageLinkedService != null || copy.useFabricBuiltInStaging);

        // when copy from Redshift to DW, staging and unload can only be used at the same time when polybase is enabled
        if (stagingAccountSelected) {
            if (
                copy.source != null &&
                copy.source instanceof AmazonRedshiftCopySource &&
                copy.source.enableRedshiftUnloadSettings &&
                copy.copySink != null &&
                CopyActivity.copySinkAllowPolybaseDisabled(copy)
            ) {
                return [
                    {
                        messageType: 'invalid',
                        message: () =>
                            formatSQLDWMessage(
                                copy.copySink,
                                stringResources.CopyWizard_Settings_UnloadStagingEnabledValidation_Template
                            )
                    }
                ];
            }
            if (
                !copy.useFabricBuiltInStaging &&
                copy.stagingSettings.storageLinkedService instanceof AzureBlobStorageLinkedService &&
                copy.stagingSettings.storageLinkedService.authenticationMethod === azureStorageAuthTypes.Anonymous
            ) {
                return [
                    {
                        messageType: 'unsupported',
                        message: () =>
                            format(
                                stringResources.Anonymous_BlobStorage_ErrorTemplate,
                                stringResources.StagingSetting_MainGroupLabel.toLocaleLowerCase()
                            )
                    }
                ];
            }
            // blobfs staging linked service doesn't supported with discp settings, snowflake source/sink
            const gen2Violation = CopyActivity.validateGen2StagingSettings(copy);
            if (!arrayIsNullOrEmpty(gen2Violation)) {
                return gen2Violation;
            }
            const userAuthViolation = CopyActivity.validateUserAuthForSnowflakeStagingSettings(copy);
            if (!arrayIsNullOrEmpty(userAuthViolation)) {
                return userAuthViolation;
            }
            const tdwViolation = CopyActivity.validateStagingSettingForTDW(copy, services);
            if (tdwViolation) {
                return tdwViolation;
            }
        }

        const allowPolybase: boolean = CopyActivity.checkIfEnabledPolybase(copy);
        return stagingAccountSelected || !allowPolybase
            ? undefined
            : CopyActivity.checkIfSupportDirectPolybase(copy, true);
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static async validateEnableStaging(
        copy: CopyActivity,
        context: IValidationContext
    ): Promise<IViolation[] | undefined> {
        let violations: IViolation[];
        const sinkDatasetType = Metamodel.modelOf(copy.sinkDataset)?.name;
        const dsSvc = await getServiceInstance<DatasetRegistryService>(context.contextData, 'DatasetRegistryService');
        switch (sinkDatasetType) {
            case adfModelTypeMap.snowflake.datasetType:
            case adfModelTypeMap.snowflakeV2.datasetType:
                violations = await this.validateSnowflakeSinkDataset(copy, context);
                break;
            case adfModelTypeMap.teradata.datasetType:
                violations = await this.validateTeradataSinkDataset(copy, context);
                break;
            case adfModelTypeMap.DataWarehouse.datasetType:
            case adfModelTypeMap.Warehouse.datasetType:
            case adfModelTypeMap.azureSqlDW.datasetType:
                violations = [
                    ...(await this.validateCopyCommandForDWSINK(copy, {
                        dsSvc
                    })),
                    ...(
                        await CopyActivity.validateCopySource(copy, copy.source, undefined, context).catch(() => [])
                    ).filter((v) => v.redirectTo?.attribute === CopyActivity.ENABLE_STAGING)
                ];
                break;
            // Add deltalake check here in case we support it in Trident as well
            case adfModelTypeMap.databricks.datasetType:
            case adfModelTypeMap.azureDatabricksDeltaLake.datasetType:
                violations = await this.validateAzureDatabricksDeltaLakeSinkDataset(copy, {
                    dsSvc
                });
                break;
            default:
        }

        violations = violations || [];
        const sourceDatasetType = Metamodel.modelOf(copy.sourceDataset)?.name;
        switch (sourceDatasetType) {
            case adfModelTypeMap.snowflake.datasetType:
            case adfModelTypeMap.snowflakeV2.datasetType:
                violations.push(...(await CopyActivity.validateSnowflakeSourceDataset(copy, context)));
                break;
            // Add deltalake check here in case we support it in Trident as well
            case adfModelTypeMap.databricks.datasetType:
            case adfModelTypeMap.azureDatabricksDeltaLake.datasetType:
                violations.push(...(await CopyActivity.validateAzureDatabricksDeltaLakeSourceDataset(copy, { dsSvc })));
                break;
            default:
        }
        return violations;
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static validateGen2StagingSettings(copy: CopyActivity): IViolation[] {
        // BlobFS staging linked service doesn't supported with discp settings, snowflake source/sink
        if (
            copy &&
            !copy.useFabricBuiltInStaging &&
            copy.stagingSettings &&
            copy.stagingSettings.storageLinkedService instanceof AzureBlobFSLinkedService
        ) {
            if (CopyActivity.checkIfEnabledDistCp(copy)) {
                return [
                    {
                        messageType: 'unsupported',
                        message: () =>
                            format(
                                stringResources.StagingSetting_BlobFSLinkedServiceNotSupportedTemplate,
                                stringResources.DistcpSetting
                            )
                    }
                ];
            } else if (copy.sinkDataset instanceof SnowflakeTableDataset) {
                return [
                    {
                        messageType: 'unsupported',
                        message: () =>
                            format(
                                stringResources.StagingSetting_BlobFSLinkedServiceNotSupportedTemplate,
                                `${stringResources.Snowflake_DisplayText
                                } ${stringResources.SinkDataset.toLocaleLowerCase()}`
                            )
                    }
                ];
            } else if (copy.sourceDataset instanceof SnowflakeTableDataset) {
                return [
                    {
                        messageType: 'unsupported',
                        message: () =>
                            format(
                                stringResources.StagingSetting_BlobFSLinkedServiceNotSupportedTemplate,
                                `${stringResources.Snowflake_DisplayText
                                } ${stringResources.Source_Label.toLocaleLowerCase()}`
                            )
                    }
                ];
            }
        }
        return [];
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static validateUserAuthForSnowflakeStagingSettings(copy: CopyActivity): IViolation[] {
        // User auth is not supported in staging settings when copying from/to Snowflake (Fabric only)
        if (
            __IS_FABRIC_DPE__ &&
            !GlobalVariables.bypassSnowflakeStagingUserAuth &&
            copy &&
            !copy.useFabricBuiltInStaging &&
            copy.stagingSettings?.storageLinkedService != null &&
            (copy.sinkDataset instanceof SnowflakeTableDataset || copy.sourceDataset instanceof SnowflakeTableDataset) &&
            copy.stagingSettings.storageLinkedService instanceof AzureBlobStorageLinkedService &&
            !copy.stagingSettings.storageLinkedService.fullyByJsonEditor &&
            copy.stagingSettings.storageLinkedService.authenticationMethod === azureStorageAuthTypes.UserAuth
        ) {
            return [
                {
                    messageType: 'unsupported',
                    message: () =>
                        format(
                            stringResources.StagingSetting_ErrorMessage_ShouldNotBe_Template,
                            stringResources.StagingSetting_ConnectionLabel,
                            AUTHENTICATION_TYPE_TEXTS[azureStorageAuthTypes.UserAuth]
                        )
                }
            ];
        }
        return [];
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static checkIfEnabledStaging(copy: CopyActivity, services: { dsSvc: DatasetRegistryService }): boolean {
        return (
            (copy.enableStaging || ValueAdapter.isTemplated(copy, CopyActivity.ENABLE_STAGING)) &&
            (copy.stagingSettings?.storageLinkedService != null || copy.useFabricBuiltInStaging)
        );
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static checkIfEnabledPolybase(copy: CopyActivity): boolean {
        let allowPolybase: boolean = false;
        if (copy.copySink instanceof SqlDWSink) {
            allowPolybase =
                copy.copySink.copyMethod === copyMethodOptionValues.PolyBase && !!copy.copySink.allowPolyBase;
        }
        return allowPolybase;
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static checkIfEnabledCopyCommand(copy: CopyActivity): boolean {
        let useCopyCommand: boolean = false;
        if (copy.copySink != null && copy.copySink instanceof SqlDWSink) {
            useCopyCommand =
                (copy.copySink.copyMethod === copyMethodOptionValues.CopyCommand && !!copy.copySink.allowCopyCommand) ||
                (__IS_FABRIC_DPE__ && copy.copySink instanceof DataWarehouseCopySink);
        }
        return useCopyCommand;
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static checkIfEnabledFaultToleranceSettings(copy: CopyActivity): boolean {
        if (copy.faultTolerenceSettings == null) {
            return false;
        }

        return (
            copy.faultTolerenceSettings.enableSkipIncompatibleRow ||
            copy.faultTolerenceSettings.enableSkipInconsistentFile ||
            copy.faultTolerenceSettings.enableSkipMissingFile ||
            copy.faultTolerenceSettings.enableSkipForbiddenFile ||
            copy.faultTolerenceSettings.enableSkipFilesWithInvalidNames
        );
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static checkIfEnabledUnload(copy: CopyActivity): boolean {
        if (copy.source instanceof AmazonRedshiftCopySource && copy.source.enableRedshiftUnloadSettings) {
            return true;
        }
        return false;
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static checkIfEnabledDistCp(copy: CopyActivity): boolean {
        if (
            copy.source != null &&
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (copy.source as any).storeSettings instanceof HdfsStoreReadSettings &&
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (copy.source as any).storeSettings.distCpSetting != null &&
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (copy.source as any).storeSettings.distCpSetting.useDistCp
        ) {
            return true;
        }
        return false;
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static async validateLoggingLocationAsync(
        activity: CopyActivity,
        value?: LoggingLocation,
        violation?: IViolation,
        context?: IValidationContext
    ): Promise<IViolation[] | undefined> {
        const result: IViolation[] = [];
        if (activity.enableLogging) {
            // If enableLogging is checked but logging linked service is not selected
            if (activity.loggingLocation == null || activity.loggingLocation.storageLinkedService == null) {
                result.push({
                    context: activity,
                    message: () =>
                        format(
                            stringResources.DeleteLoggingSetting_ErrorMessage_MissingLinkedService,
                            __IS_FABRIC_DPE__
                                ? stringResources.ConnectionLabel.toLocaleLowerCase()
                                : stringResources.LinkedServiceLowerCase
                        )
                });
            }
            if (
                activity.loggingLocation.storageLinkedService instanceof AzureBlobStorageLinkedService &&
                activity.loggingLocation.storageLinkedService.authenticationMethod === azureStorageAuthTypes.Anonymous
            ) {
                result.push({
                    messageType: 'unsupported',
                    message: () =>
                        format(
                            stringResources.Anonymous_BlobStorage_ErrorTemplate,
                            stringResources.LoggingSettingsLabel.toLocaleLowerCase()
                        )
                });
            } else if (
                CopyActivity.checkIfEnabledCopyCommand(activity) &&
                activity.copySink instanceof DataWarehouseCopySink &&
                activity.copySink.copyCommandSettings &&
                activity?.faultTolerenceSettings?.enableSkipIncompatibleRow &&
                (activity.loggingLocation.storageLinkedService instanceof AzureBlobStorageLinkedService ||
                    activity.loggingLocation.storageLinkedService instanceof AzureBlobFSLinkedService) &&
                activity.loggingLocation.storageLinkedService.authenticationMethod !==
                azureBlobFSAuthTypes.SasUriAuthentication
            ) {
                result.push({
                    context: activity,
                    messageType: 'unsupported',
                    message: () => stringResources.CopyActivity_FaultTolerance_LoggingSASRequiredDescription
                });
            } else if (activity.loggingLocation.storageLinkedService) {
                result.push(...validateLinkedServicePermission(activity.loggingLocation.storageLinkedService, context));
            }
            result.push(...validatePathInStagingAndLoggingSettings(activity.loggingLocation));
        }
        return result;
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static async validateDataConsistencyAsync(
        activity: CopyActivity,
        value?: boolean,
        violation?: IViolation,
        context?: IValidationContext
    ): Promise<IViolation[] | undefined> {
        if (activity.enableDataConsistency || CopyActivity.ENABLE_DATA_CONSISTENCY.templateValue(activity)) {
            const linkedServiceRegSvc = await getServiceInstance<LinkedServiceRegistryService>(
                context.contextData,
                'LinkedServiceRegistryService'
            );
            const datasetRegSvc = await getServiceInstance<DatasetRegistryService>(
                context.contextData,
                'DatasetRegistryService'
            );
            if (
                !supportDataConsistency(activity, false, {
                    linkedServiceRegSvc,
                    datasetRegSvc
                })
            ) {
                const errorMessage = await getDataConsistencyErrorMessage(activity, context);
                if (!!errorMessage) {
                    return [
                        {
                            context: activity,
                            message: () => errorMessage
                        }
                    ];
                }
            }
        }
        return undefined;
    }

    private static validateCopyBehavior(
        copyActivity: CopyActivity,
        services: { dsSvc: DatasetRegistryService }
    ): IViolation[] {
        if (copyActivity.copySink instanceof FormatTypeCopySink) {
            const sourceDataset = copyActivity.sourceDataset;
            const sinkDataset = copyActivity.sinkDataset;
            const storeSettings = copyActivity.copySink.storeSettings;
            if (sourceDataset == null || sinkDataset == null || storeSettings == null) {
                return [];
            }
            if (
                isBinaryTypeDataset(sourceDataset) &&
                storeSettings.copyBehavior === copyBehaviorOptionValues.mergeFiles
            ) {
                return !isAEPDataset(sourceDataset)
                    ? [
                        {
                            context: storeSettings.copyBehavior,
                            messageType: 'invalid',
                            message: () => stringResources.CopyBehavior_Cannot_Be_Mergefiles_When_Use_BinaryCopy_Error
                        }
                    ]
                    : [
                        {
                            context: storeSettings.copyBehavior,
                            messageType: 'invalid',
                            message: () => stringResources.AEP_CopyBehavior_ErrorMessage // customize error message for aep source
                        }
                    ];
            }
            if (
                sinkDataset instanceof ParquetDataset ||
                sinkDataset instanceof DeltaDataset ||
                sinkDataset instanceof DelimitedTextDataset
            ) {
                if (isFileTypeDataset(sourceDataset, services)) {
                    // If source is folder, destination is file, copy behavior must be mergefiles
                    const sourceIsFolder = !datasetIsFile(sourceDataset);
                    // we don't validate sink file name expressions here, becouse the value of an expression might be null or ""
                    const sinkIsFile = !!(
                        sinkDataset &&
                        sinkDataset.location &&
                        sinkDataset.location.getLocation().fileName
                    );

                    if (
                        !(isBinaryTypeDataset(sourceDataset) || isBinaryTypeDataset(sinkDataset)) &&
                        !datasetWithZipDeflateCompression(sinkDataset) &&
                        !datasetWithTarGZipCompression(sinkDataset) &&
                        !datasetWithTarCompression(sinkDataset) &&
                        sourceIsFolder &&
                        sinkIsFile &&
                        storeSettings.copyBehavior !== copyBehaviorOptionValues.mergeFiles
                    ) {
                        return [
                            {
                                context: storeSettings.copyBehavior,
                                messageType: 'invalid',
                                message: () => stringResources.CopyBehavior_Must_Be_Mergefiles_Error,
                                redirectTo: {
                                    attribute: StoreWriteSettings.COPY_BEHAVIOR
                                }
                            }
                        ];
                    }
                }

                // when copy from table to file, and staging is not used and unload is not used, copy behavior can't be merging files
                if (
                    !copyActivity.enableStaging &&
                    !ValueAdapter.isTemplated(copyActivity, CopyActivity.ENABLE_STAGING) &&
                    (!(copyActivity.source instanceof AmazonRedshiftCopySource) ||
                        !copyActivity.source.enableRedshiftUnloadSettings) &&
                    !(copyActivity.source instanceof LakehouseTableCopySource) &&
                    !(sourceDataset instanceof FileTypeDataset || sourceDataset instanceof FormatDatasetV2) &&
                    storeSettings.copyBehavior === copyBehaviorOptionValues.mergeFiles
                ) {
                    return [
                        {
                            context: storeSettings.copyBehavior,
                            messageType: 'invalid',
                            message: () => stringResources.CopyBehavior_Cannot_Be_Mergefiles_Error_Table,
                            redirectTo: {
                                attribute: StoreWriteSettings.COPY_BEHAVIOR
                            }
                        }
                    ];
                }
            }
            if (
                Metamodel.modelOf(storeSettings).attribute('copyBehavior').templateValue(storeSettings) == null &&
                storeSettings.copyBehavior !== copyBehaviorOptionValues.mergeFiles &&
                !(isBinaryTypeDataset(sourceDataset) || isBinaryTypeDataset(sinkDataset))
            ) {
                if (
                    copyActivity.source &&
                    copyActivity.source instanceof FormatTypeCopySource &&
                    (!(
                        copyActivity.source.storeSettings instanceof BlobTypeStoreReadSettings ||
                        copyActivity.source.storeSettings instanceof AzureBlobReadSettings ||
                        copyActivity.source.storeSettings instanceof S3StoreReadSettings
                    ) ||
                        copyActivity.source.storeSettings.filePathMode === FilePathMode.WILDCARD) &&
                    ((Metamodel.modelOf(copyActivity.source.storeSettings)?.hasAttribute('wildcardFileName') &&
                        Metamodel.modelOf(copyActivity.source.storeSettings)
                            .attribute('wildcardFileName')
                            .value(copyActivity.source.storeSettings)) ||
                        (Metamodel.modelOf(copyActivity.source.storeSettings)?.hasAttribute('wildcardFolderPath') &&
                            Metamodel.modelOf(copyActivity.source.storeSettings)
                                .attribute('wildcardFolderPath')
                                .value(copyActivity.source.storeSettings))) &&
                    !!(
                        sinkDataset &&
                        (sinkDataset as FormatDatasetV2).location &&
                        (sinkDataset as FormatDatasetV2).location.getLocation().fileName
                    ) &&
                    !datasetWithZipDeflateCompression(sinkDataset) &&
                    !datasetWithTarGZipCompression(sinkDataset) &&
                    !datasetWithTarCompression(sinkDataset)
                ) {
                    return [
                        {
                            context: storeSettings.copyBehavior,
                            messageType: 'invalid',
                            message: () => stringResources.CopyBehavior_Must_Be_Mergefiles_Error,
                            redirectTo: {
                                attribute: StoreWriteSettings.COPY_BEHAVIOR
                            }
                        }
                    ];
                }
            }
            // validate file system file filter
            if (
                Metamodel.modelOf(storeSettings).attribute('copyBehavior').templateValue(storeSettings) == null &&
                storeSettings.copyBehavior !== copyBehaviorOptionValues.mergeFiles &&
                !(isBinaryTypeDataset(sourceDataset) || isBinaryTypeDataset(sinkDataset))
            ) {
                if (
                    copyActivity.source &&
                    copyActivity.source instanceof FormatTypeCopySource &&
                    copyActivity.source.storeSettings instanceof FileServerStoreReadSettings &&
                    !fileFilterIsNull(copyActivity.source.storeSettings, true) &&
                    !!(
                        sinkDataset &&
                        (sinkDataset as FormatDatasetV2).location &&
                        (sinkDataset as FormatDatasetV2).location.getLocation().fileName
                    )
                ) {
                    return [
                        {
                            context: storeSettings.copyBehavior,
                            messageType: 'invalid',
                            message: () => stringResources.CopyBehavior_Must_Be_Mergefiles_Error,
                            redirectTo: {
                                attribute: StoreWriteSettings.COPY_BEHAVIOR
                            }
                        }
                    ];
                }
            }
        }
        return [];
    }

    private static checkIfSupportDirectPolybase(
        copy: CopyActivity,
        isFromCopyWizard: boolean = false
    ): IViolation[] | undefined {
        const violations: IViolation[] = [];
        if (copy.sourceDataset != null) {
            if (copy.sourceDataset instanceof FileTypeDataset) {
                // Binary copy from file type dataset to tabular dataset (azure sql dw) is not allowed, it's already validated in copy activity
                if (isDatasetWithoutFileFormat(copy.sourceDataset)) {
                    return undefined;
                }
            }
            // Source linked service is of type: AzureStorage/AzureBlobStorage or ADLS Gen1 or ADLS Gen2. The input dataset is of type: AzureBlob or AzureDataLakeStoreFile or AzureBlobFS.
            if (
                copy.sourceDataset instanceof AzureBlobDataset ||
                copy.sourceDataset instanceof AzureDataLakeStoreFileDataset ||
                copy.sourceDataset instanceof AzureBlobFSDataset ||
                (copy.sourceDataset instanceof FormatDatasetV2 &&
                    !(copy.sourceDataset instanceof JsonDataset) &&
                    CopyActivity.isLinkedserviceSupportDirectPolybase(copy.sourceDataset.linkedService))
            ) {
                const formatValidationMessage = CopyActivity.checkSourceDatasetFormatForDirectPolybase(
                    copy,
                    isFromCopyWizard
                );
                if (formatValidationMessage) {
                    violations.push({
                        messageType: 'invalid',
                        message: () =>
                            stringResources.StagingSetting_ErrorMessage_Format +
                            formatValidationMessage +
                            stringResources.StagingSetting_ErrorMessage_DirectPolybaseNotMet +
                            format(
                                stringResources.CopyCommand_CopyMethod_CopyCommandPleaseFixTemplate,
                                'these conditions'
                            ),
                        redirectTo: {
                            attribute: CopyActivity.ENABLE_STAGING
                        }
                    });
                }

                if (
                    copy.source instanceof FormatTypeCopySource &&
                    copy.source.storeSettings instanceof BlobTypeStoreReadSettings
                ) {
                    if (
                        !stringIsNullOrEmpty(copy.source.storeSettings.wildcardFileName) &&
                        copy.source.storeSettings.wildcardFileName !== '*' &&
                        copy.source.storeSettings.wildcardFileName !== '*.*'
                    ) {
                        violations.push({
                            messageType: 'invalid',
                            message: () =>
                                format(
                                    stringResources.DirectPolybase_ErrorMessage_StoreSettings,
                                    stringResources.ModelName_WildcardFileName.toLocaleLowerCase(),
                                    `*.* ${stringResources.Or.toLocaleLowerCase()} *`
                                ) +
                                format(
                                    stringResources.CopyCommand_CopyMethod_CopyCommandPleaseFixTemplate,
                                    stringResources.ModelName_WildcardFileName.toLocaleLowerCase()
                                ),
                            redirectTo: {
                                attribute: BlobTypeStoreReadSettings.WILDCARD_FILENAME
                            }
                        });
                    }
                    // not support blob prefix
                    if (
                        Metamodel.modelOf(copy.source.storeSettings)?.hasAttribute('prefix') &&
                        !prefixPathIsNull(copy.source.storeSettings)
                    ) {
                        violations.push({
                            messageType: 'invalid',
                            message: () =>
                                format(
                                    stringResources.DirectPolybase_ErrorMessage_StoreSettings,
                                    stringResources.Prefix.toLocaleLowerCase(),
                                    stringResources.Empty.toLocaleLowerCase()
                                ) +
                                format(
                                    stringResources.CopyCommand_CopyMethod_CopyCommandPleaseFixTemplate,
                                    stringResources.Prefix.toLocaleLowerCase()
                                ),
                            redirectTo: {
                                attribute: Metamodel.modelOf(copy.source.storeSettings).attribute('prefix')
                            }
                        });
                    }
                }

                // only check linked service authtype when fullyByJsonEditor is false
                if (copy.sourceDataset.linkedService && !copy.sourceDataset.linkedService.fullyByJsonEditor) {
                    // ADLS Gen1, must be service principal
                    if (copy.sourceDataset.linkedService instanceof AzureDataLakeStoreLinkedService) {
                        if (
                            copy.sourceDataset.linkedService.authenticationType !== AuthenticationType.ServicePrincipal
                        ) {
                            violations.push({
                                messageType: 'invalid',
                                message: () =>
                                    format(
                                        stringResources.StagingSetting_ErrorMessage_ShouldBe_Template,
                                        format(
                                            stringResources.ModelName_LinkedServiceTemplate,
                                            stringResources.Source_Label
                                        ),
                                        `${stringResources.AuthenticationType_ServicePrincipal}`
                                    ),
                                redirectTo: {
                                    attribute: CopyActivity.ENABLE_STAGING
                                }
                            });
                        }
                        // ADLS Gen2 and Blob, must be account key or MSI
                    } else if (
                        copy.sourceDataset.linkedService instanceof AzureBlobFSLinkedService ||
                        copy.sourceDataset.linkedService instanceof AzureBlobStorageLinkedService ||
                        copy.sourceDataset.linkedService instanceof AzureStorageLinkedService
                    ) {
                        const allowedSourceAuthTypes: string[] = [
                            azureStorageAuthTypes.AccountKeyAuthentication,
                            azureStorageAuthTypes.MSIAuthentication
                        ];
                        if (
                            GlobalVariables.enableCopyStagingBlobSPN &&
                            !copy.useFabricBuiltInStaging &&
                            copy.stagingSettings.storageLinkedService instanceof AzureBlobStorageLinkedService
                        ) {
                            allowedSourceAuthTypes.push(azureStorageAuthTypes.ServicePrincipalAuthentication);
                        }
                        if (!allowedSourceAuthTypes.includes(copy.sourceDataset.linkedService.authenticationMethod)) {
                            violations.push({
                                context: copy.sourceDataset.linkedService,
                                messageType: 'invalid',
                                message: () =>
                                    format(
                                        stringResources.StagingSetting_ErrorMessage_ShouldBe_Template,
                                        format(
                                            stringResources.ModelName_LinkedServiceTemplate,
                                            stringResources.Source_Label
                                        ),
                                        formatListWithConjunction(
                                            (allowedSourceAuthTypes as AzureAuthTypes[]).map(
                                                (t) => AUTHENTICATION_TYPE_TEXTS[t]
                                            )
                                        )
                                    ),
                                redirectTo: {
                                    entity: copy.sourceDataset.linkedService
                                }
                            });
                        }
                    }
                }
            } else if (copy.sourceDataset instanceof JsonDataset) {
                violations.push({
                    messageType: 'unsupported',
                    message: () =>
                        formatSQLDWMessage(
                            copy.copySink,
                            stringResources.StagingSetting_ErrorMessage_JsonType_Template
                        ),
                    redirectTo: {
                        attribute: CopyActivity.ENABLE_STAGING
                    }
                });
            } else if (!(copy.sourceDataset instanceof SnowflakeTableDataset)) {
                // if source is snowflake dataset, validation will be covered in validateSnowflakeSourceDataset
                violations.push({
                    messageType: 'unsupported',
                    message: () =>
                        formatSQLDWMessage(
                            copy.copySink,
                            stringResources.StagingSetting_ErrorMessage_SourceType_Template
                        ),
                    redirectTo: {
                        attribute: CopyActivity.ENABLE_STAGING
                    }
                });
            }
        }
        return violations;
    }

    private static isLinkedserviceSupportDirectPolybase(linkedService: LinkedService): boolean {
        return (
            linkedService != null &&
            (linkedService instanceof AzureDataLakeStoreLinkedService ||
                linkedService instanceof AzureBlobFSLinkedService ||
                linkedService instanceof AzureBlobStorageLinkedService ||
                linkedService instanceof AzureStorageLinkedService)
        );
    }

    private static checkSourceDatasetFormatForDirectPolybase(
        activity: CopyActivity,
        isFromCopyWizard: boolean = false
    ): string {
        const dataset = activity.sourceDataset;
        const messageArray: string[] = [];
        if (dataset instanceof FileTypeDataset) {
            const fileProperties = dataset.format;
            // for madrid and copy wizard filetype dataset and v2 dataset
            // the format type under type properties is OrcFormat, or TextFormat with the following configurations:
            if (
                fileProperties == null ||
                ![fileFormats.textFormat, fileFormats.orcFormat, fileFormats.parquetFormat].includes(
                    fileProperties.type
                )
            ) {
                return stringResources.DirectPolybase_ErrorMessage_BlobFormat;
            }
            if (fileProperties.type === fileFormats.textFormat) {
                // for madrid and copy wizard filetype dataset format
                if (!isFromCopyWizard) {
                    const textFormat = fileProperties.typeFormat as TextFormat;
                    // rowDelimiter must be \n.
                    if (
                        textFormat.rowDelimiter != null &&
                        textFormat.rowDelimiter !== '' &&
                        textFormat.rowDelimiter !== rowDelimiters.lineFeed
                    ) {
                        messageArray.push(stringResources.DirectPolybase_ErrorMessage_RowDelimiter);
                    }
                    // nullValue is set to empty string (""), or treatEmptyAsNull is set to true.
                    if (!textFormat.treatEmptyAsNull || textFormat.nullValue) {
                        messageArray.push(stringResources.DirectPolybase_ErrorMessage_EmptyAsNull);
                    }
                    // escapeChar, quoteChar, firstRowAsHeader, and skipLineCount are not specified
                    if (textFormat.escapeChar) {
                        messageArray.push(stringResources.DirectPolybase_ErrorMessage_EscapeChar);
                    }
                    if (textFormat.quoteChar) {
                        messageArray.push(stringResources.DirectPolybase_ErrorMessage_QuoteChar);
                    }
                    // encodingName is set to utf-8, which is default value.
                    if (textFormat.encodingName && textFormat.encodingName.toLowerCase() !== 'utf-8') {
                        messageArray.push(stringResources.DirectPolybase_ErrorMessage_Encoding);
                    }
                    // validate compression for text format
                    const compression = dataset.compression;
                    // compression can be no compression, GZip, or Deflate.
                    if (
                        compression &&
                        ![compressionOptionValues.GZip, compressionOptionValues.Deflate].includes(
                            compression.compressionType
                        )
                    ) {
                        messageArray.push(stringResources.DirectPolybase_ErrorMessage_Compression);
                    }
                } else if (isFromCopyWizard) {
                    // for copy wizard v2 resource
                    const format = fileProperties.typeFormat as TextFormat;
                    if (format.rowDelimiter != null && format.rowDelimiter !== rowDelimiters.lineFeed) {
                        // rowDelimiter must be \n or null
                        messageArray.push(stringResources.DirectPolybase_ErrorMessage_RowDelimiter);
                    }
                    if (format.columnDelimiter === '') {
                        // Column delimiter can't be empty string
                        messageArray.push(stringResources.DirectPolybase_ErrorMessage_ColumnDelimiter);
                    }
                    if (!stringIsNullOrEmpty(format.nullValue)) {
                        // nullValue must set to empty string ("") or null
                        messageArray.push(stringResources.DirectPolybase_ErrorMessage_NullValue);
                    }
                    if (format.escapeChar !== '') {
                        // escape char must be empty
                        messageArray.push(stringResources.DirectPolybase_ErrorMessage_EscapeChar);
                    }
                    if (format.quoteChar !== '') {
                        // quoteChar char must be empty
                        messageArray.push(stringResources.DirectPolybase_ErrorMessage_QuoteChar);
                    }
                    // encodingName is set to utf-8, which is default value.
                    if (!stringIsNullOrEmpty(format.encodingName) && format.encodingName.toLowerCase() !== 'utf-8') {
                        messageArray.push(stringResources.DirectPolybase_ErrorMessage_Encoding);
                    }
                    // compression can be no compression, gZip, or deflate.
                    // for copy wizard resource, compressionCodec is stored in dataset.raw
                    /* eslint-disable @typescript-eslint/no-explicit-any */
                    const rawInfo: any = dataset.raw != null ? JSON.parse(dataset.raw) : undefined;
                    if (
                        rawInfo?.properties?.typeProperties?.compressionCodec &&
                        ![compressionCodecType.gzip, compressionCodecType.deflate].includes(
                            rawInfo.properties.typeProperties.compressionCodec
                        )
                    ) {
                        messageArray.push(stringResources.DirectPolybase_ErrorMessage_CompressionForV2);
                    }
                }
            }
        } else if (dataset instanceof DelimitedTextDataset) {
            // for madrid delimited text dataset
            if (dataset.rowDelimiter != null && dataset.rowDelimiter !== rowDelimiters.lineFeed) {
                // rowDelimiter must be \n or null
                messageArray.push(stringResources.DirectPolybase_ErrorMessage_RowDelimiter);
            }
            if (dataset.columnDelimiter === '') {
                // Column delimiter can't be empty string
                messageArray.push(stringResources.DirectPolybase_ErrorMessage_ColumnDelimiter);
            }
            if (!stringIsNullOrEmpty(dataset.nullValue)) {
                // nullValue must set to empty string ("") or null
                messageArray.push(stringResources.DirectPolybase_ErrorMessage_NullValue);
            }
            if (DelimitedTextDataset.ESCAPE_CHAR.templateValue(dataset) == null && dataset.escapeChar !== '') {
                // escape char must be empty
                messageArray.push(stringResources.DirectPolybase_ErrorMessage_EscapeChar);
            }
            if (DelimitedTextDataset.QUOTE_CHAR.templateValue(dataset) == null && dataset.quoteChar !== '') {
                // quoteChar char must be empty
                messageArray.push(stringResources.DirectPolybase_ErrorMessage_QuoteChar);
            }
            // encodingName is set to utf-8, which is default value.
            if (!stringIsNullOrEmpty(dataset.encodingName) && dataset.encodingName.toLowerCase() !== 'utf-8') {
                messageArray.push(stringResources.DirectPolybase_ErrorMessage_Encoding);
            }
            // compression can be no compression, gZip, or deflate.
            if (
                dataset.compressionCodec &&
                ![compressionCodecType.gzip, compressionCodecType.deflate].includes(dataset.compressionCodec)
            ) {
                messageArray.push(stringResources.DirectPolybase_ErrorMessage_CompressionForV2);
            }
        }

        let message = '';
        if (messageArray.length > 0) {
            message = messageArray.join(', ');
        }
        return message;
    }

    private static async _checkSourceDatasetForCopyCommand(activity: CopyActivity): Promise<IViolation[]> {
        const dataset = activity.sourceDataset;
        const violations: IViolation[] = [];
        const sinkType = Metamodel.modelOf(activity.copySink).name; // could be sqldw or tridentdw
        // validate partition discovery
        if (
            activity.source instanceof FormatTypeCopySource &&
            activity.source.storeSettings instanceof BlobTypeStoreReadSettings &&
            activity.source.storeSettings.enablePartitionDiscovery === true
        ) {
            violations.push({
                context: activity.source.storeSettings,
                message: () =>
                    getCopyCommandErrorMessage(
                        activity,
                        stringResources.PartitionDiscovery_In_Compatible_With_Copy_Command,
                        stringResources.EnablePartitionDiscovery,
                        'notSupport'
                    )
            });
        }
        if (
            dataset instanceof DelimitedTextDataset ||
            dataset instanceof ParquetDataset ||
            dataset instanceof OrcDataset
        ) {
            if (
                activity.source &&
                (activity.source as FormatTypeCopySource).storeSettings instanceof BlobTypeStoreReadSettings
            ) {
                const storeSettings = (activity.source as FormatTypeCopySource)
                    .storeSettings as BlobTypeStoreReadSettings;
                // check copy source source modified time start and end
                if (!modifiedTimeIsNull(storeSettings)) {
                    violations.push({
                        messageType: 'unsupported',
                        message: () =>
                            getCopyCommandErrorMessage(
                                activity,
                                stringResources.CopyCommand_CopyMethod_CopyCommandModifiedTime_Error,
                                stringResources.CopyCommand_CopyMethod_ModifiedTime
                            ),
                        redirectTo: {
                            attribute: BlobTypeStoreReadSettings.MODIFID_DATETIME_START
                        }
                    });
                }
                // this only applys to sqldw, not trident dw.
                // For sql dw, recursive must by true
                if (
                    sinkType === adfModelTypeMap.azureSqlDW.copySinkType &&
                    storeSettings.filePathMode !== FilePathMode.LIST &&
                    !storeSettings.recursive &&
                    !BlobTypeStoreReadSettings.RECURSIVE_SETTING.templateValue(storeSettings)
                ) {
                    violations.push({
                        messageType: 'invalid',
                        message: () =>
                            getCopyCommandErrorMessage(
                                activity,
                                stringResources.CopyCommand_CopyMethod_CopyCommandRecursive_Error,
                                stringResources.Recursive
                            ),
                        redirectTo: {
                            attribute: BlobTypeStoreReadSettings.RECURSIVE_SETTING
                        }
                    });
                }

                // for trident dw, when recursive is true, wildcardFileName must be empty
                if (
                    sinkType === CopyActivity.getWarehouseModelType().copySinkType &&
                    !dataset.isSampleDataset && // bypass this validation for sample dataset
                    storeSettings.recursive &&
                    isWildCardPathMode(storeSettings)
                ) {
                    if (!stringIsNullOrEmpty(getWildcardValue(storeSettings, 'wildcardFileName'))) {
                        violations.push({
                            message: () =>
                                getCopyCommandErrorMessage(
                                    activity,
                                    stringResources.CopyCommand_CopyMethod_CopyCommandWildcardFileName_NewError,
                                    stringResources.ModelName_WildcardFileName
                                ),
                            redirectTo: {
                                attribute: BlobTypeStoreReadSettings.WILDCARD_FILENAME
                            }
                        });
                    }
                }
            }
            if (dataset instanceof DelimitedTextDataset) {
                // check compression
                if (
                    !stringIsNullOrEmpty(dataset.compressionCodec) &&
                    dataset.compressionCodec.toLowerCase() !== compressionCodecType.gzip.toLowerCase()
                ) {
                    violations.push({
                        messageType: 'invalid',
                        message: () =>
                            getCopyCommandErrorMessage(
                                activity,
                                format(
                                    stringResources.CopyCommand_CopyMethod_CopyCommandSourceCompression_Error,
                                    CopyActivity._sourceDatasetLabel,
                                    compressionCodecType.gzip
                                ),
                                stringResources.ModelName_CompressionType
                            ),
                        redirectTo: {
                            entity: dataset,
                            attribute: DelimitedTextDataset.COMPRESSION_CODEC
                        }
                    });
                }

                const supportedEncoding = [
                    Encoding.UTF_8,
                    Encoding.UTF_16,
                    Encoding.UTF_16BE,
                    Encoding.UTF_16LE,
                    'Unicode'
                ];
                if (
                    !stringIsNullOrEmpty(dataset.encodingName) &&
                    !supportedEncoding.map((e) => e.toLowerCase()).includes(dataset.encodingName.toLowerCase())
                ) {
                    violations.push({
                        messageType: 'invalid',
                        message: () =>
                            getCopyCommandErrorMessage(
                                activity,
                                format(
                                    stringResources.CopyCommand_CopyMethod_CopyCommandEncodingName_Error,
                                    CopyActivity._sourceDatasetLabel,
                                    formatListWithConjunction(supportedEncoding)
                                ),
                                stringResources.ModelName_Encoding
                            ),
                        redirectTo: {
                            entity: dataset,
                            attribute: DelimitedTextDataset.ENCODING_NAME
                        }
                    });
                }

                // The reason for this validation is that Copy command only accepts quoteChar and will use quoteChar as escape char.
                if (!__IS_FABRIC_DPE__ && dataset.escapeChar !== dataset.quoteChar) {
                    violations.push({
                        messageType: 'invalid',
                        message: () =>
                            getCopyCommandErrorMessage(
                                activity,
                                stringResources.CopyCommand_CopyMethod_CopyCommandEscapeQuoteChar_Error,
                                stringResources.CopyCommand_CopyMethod_EscapeCharQuoteChar
                            ),
                        redirectTo: {
                            entity: dataset,
                            attribute: DelimitedTextDataset.QUOTE_CHAR
                        }
                    });
                }

                if (!stringIsNullOrEmpty(dataset.nullValue)) {
                    violations.push({
                        messageType: 'unsupported',
                        message: () =>
                            getCopyCommandErrorMessage(
                                activity,
                                stringResources.CopyCommand_CopyMethod_CopyCommandNullValue_Error,
                                stringResources.NullValueFieldLabel
                            ),
                        redirectTo: {
                            entity: dataset,
                            attribute: DelimitedTextDataset.NULL_VALUE
                        }
                    });
                }
                if (
                    ((activity.source as DelimitedTextCopySource).formatSettings as DelimitedTextFormatReadSettings)
                        ?.skipLineCount > 0
                ) {
                    violations.push({
                        messageType: 'invalid',
                        message: () =>
                            getCopyCommandErrorMessage(
                                activity,
                                stringResources.CopyCommand_CopyMethod_CopyCommandSkipLineCount_Error,
                                stringResources.SkipLineCountLabel
                            ),
                        redirectTo: {
                            attribute: DelimitedTextFormatReadSettings.SKIP_LINE_COUNT
                        }
                    });
                }
                // check fault tolerance ls when source dataset is delimited text
                if (activity.faultTolerenceSettings?.incompatibleRowLoggingLinkedService) {
                    violations.push(...(await CopyActivity._checkSourceLinkedserviceForCopyCommand(activity, true)));
                }
            } else if (dataset instanceof ParquetDataset || dataset instanceof OrcDataset) {
                const supportedCodec =
                    dataset instanceof ParquetDataset
                        ? [compressionCodecType.none, compressionCodecType.snappy, compressionCodecType.gzip]
                        : [compressionCodecType.none, compressionCodecType.snappy, compressionCodecType.zlib];
                if (
                    !stringIsNullOrEmpty(dataset.compressionCodec) &&
                    !supportedCodec
                        .map((compression) => compression.toLowerCase())
                        .includes(dataset.compressionCodec.toLowerCase())
                ) {
                    violations.push({
                        messageType: 'invalid',
                        message: () =>
                            getCopyCommandErrorMessage(
                                activity,
                                format(
                                    stringResources.CopyCommand_CopyMethod_CopyCommandSourceCompression_Error,
                                    CopyActivity._sourceDatasetLabel,
                                    formatListWithConjunction(supportedCodec)
                                ),
                                stringResources.ModelName_CompressionType
                            ),
                        redirectTo: {
                            entity: dataset,
                            attribute: Metamodel.modelOf(dataset).attribute('compressionCodec')
                        }
                    });
                }
                // do not support skip and log
                if (activity.faultTolerenceSettings?.incompatibleRowLoggingLinkedService) {
                    violations.push({
                        messageType: 'invalid',
                        message: () =>
                            getCopyCommandErrorMessage(
                                activity,
                                stringResources.CopyCommand_CopyMethod_CopyCommandFaulttoleranceDataset_Error,
                                stringResources.DataFlow_SkipAndLogIncompatibleRows,
                                'notSupport'
                            ),
                        redirectTo: {
                            attribute: Metamodel.modelOf(activity.faultTolerenceSettings).attribute(
                                'incompatibleRowLoggingLinkedService'
                            )
                        }
                    });
                }

                if (dataset instanceof OrcDataset) {
                    if (sinkType === CopyActivity.getWarehouseModelType().copySinkType) {
                        violations.push({
                            messageType: 'unsupported',
                            message: () =>
                                formatSQLDWMessage(
                                    activity.copySink,
                                    stringResources.CopyCommand_CopyMethod_CopyCommandSource_Error_Template
                                ),
                            redirectTo: {
                                attribute: CopyActivity.ENABLE_STAGING
                            }
                        });
                    }
                }
            }
        }
        return violations;
    }

    private static copySinkAllowPolybaseDisabled(copy: CopyActivity): boolean {
        if (copy && copy.copySink instanceof SqlDWSink) {
            // after feature flage is on, both copyMethod and allowPolybase controls the value
            return (
                copy.copySink.copyMethod !== copyMethodOptionValues.PolyBase ||
                (!copy.copySink.allowPolyBase && !ValueAdapter.isTemplated(copy.copySink, SqlDWSink.ALLOW_POLYBASE))
            );
        }
        return false;
    }

    private static async _checkSourceLinkedserviceForCopyCommand(
        activity: CopyActivity,
        isFaultToleranceWithDelimitedTextSource?: boolean
    ): Promise<IViolation[]> {
        const sourceDataset = activity.sourceDataset;
        const linkedService = !isFaultToleranceWithDelimitedTextSource
            ? sourceDataset != null
                ? sourceDataset.linkedService
                : undefined
            : activity.faultTolerenceSettings
                ? activity.faultTolerenceSettings.incompatibleRowLoggingLinkedService
                : undefined;
        const violations: IViolation[] = [];
        if (linkedService != null) {
            if (
                !(
                    linkedService instanceof AzureBlobFSLinkedService ||
                    linkedService instanceof AzureBlobStorageLinkedService ||
                    linkedService instanceof AzureStorageLinkedService
                )
            ) {
                violations.push({
                    messageType: 'unsupported',
                    message: () =>
                        !isFaultToleranceWithDelimitedTextSource
                            ? formatSQLDWMessage(
                                activity.copySink,
                                stringResources.CopyCommand_CopyMethod_CopyCommandSource_Error_Template
                            )
                            : getCopyCommandErrorMessage(
                                activity,
                                stringResources.CopyCommand_CopyMethod_CopyCommandFaulttoleranceLinkedservice_Error,
                                '',
                                'onlySupport',
                                false
                            ),
                    redirectTo: {
                        entity: !isFaultToleranceWithDelimitedTextSource ? sourceDataset : activity,
                        attribute: !isFaultToleranceWithDelimitedTextSource
                            ? Metamodel.modelOf(sourceDataset).attribute('linkedService')
                            : Metamodel.modelOf(activity.faultTolerenceSettings).attribute(
                                'incompatibleRowLoggingLinkedService'
                            )
                    }
                });
            }
            if (
                linkedService instanceof AzureBlobStorageLinkedService ||
                linkedService instanceof AzureBlobFSLinkedService
            ) {
                let authTypes: string[] = [];
                if (linkedService instanceof AzureBlobStorageLinkedService) {
                    if (isFaultToleranceWithDelimitedTextSource) {
                        // fault tolerance setting with delimited text as source dataset MSI is not supported
                        authTypes = [
                            azureStorageAuthTypes.ServicePrincipalAuthentication,
                            azureStorageAuthTypes.AccountKeyAuthentication,
                            azureStorageAuthTypes.SasUriAuthentication
                        ];
                    } else {
                        if (sourceDataset instanceof DelimitedTextDataset) {
                            // support all auth types
                            authTypes = [
                                azureStorageAuthTypes.ServicePrincipalAuthentication,
                                azureStorageAuthTypes.MSIAuthentication,
                                azureStorageAuthTypes.AccountKeyAuthentication,
                                azureStorageAuthTypes.SasUriAuthentication,
                                azureStorageAuthTypes.Anonymous
                            ];
                        } else if (sourceDataset instanceof ParquetDataset || sourceDataset instanceof OrcDataset) {
                            // only support KEY and SAS
                            authTypes = [
                                azureStorageAuthTypes.AccountKeyAuthentication,
                                azureStorageAuthTypes.SasUriAuthentication,
                                azureStorageAuthTypes.Anonymous
                            ];
                        }
                    }
                } else {
                    authTypes = [
                        azureStorageAuthTypes.ServicePrincipalAuthentication,
                        azureStorageAuthTypes.MSIAuthentication,
                        azureStorageAuthTypes.AccountKeyAuthentication,
                        azureStorageAuthTypes.SasUriAuthentication
                    ];
                }

                if (
                    __IS_FABRIC_DPE__ &&
                    Metamodel.modelOf(activity.copySink).name === CopyActivity.getWarehouseModelType().copySinkType &&
                    (activity.sinkDataset?.dmtsCredentialForArtifact == null ||
                        (Metamodel.modelOf(activity.sinkDataset.dmtsCredentialForArtifact).hasAttribute('authenticationType') &&
                            Metamodel.modelOf(activity.sinkDataset.dmtsCredentialForArtifact).attribute('authenticationType').value(activity.sinkDataset.dmtsCredentialForArtifact) ===
                            artifactDmtsCredentialAuthTypes.userAuth))
                ) {
                    authTypes.push(azureStorageAuthTypes.UserAuth);
                }

                if (
                    !isFaultToleranceWithDelimitedTextSource &&
                    Metamodel.modelOf(activity.copySink).name === CopyActivity.getWarehouseModelType().copySinkType
                ) {
                    const allowedAuthTypes = [...dataWarehouseAllowedSourceAuthTypes];
                    authTypes = intersection(authTypes, allowedAuthTypes);
                }

                let authenticationMethod = !linkedService.fullyByJsonEditor
                    ? linkedService.authenticationMethod
                    : undefined;
                if (__IS_FABRIC_DPE__ && linkedService.fullyByJsonEditor) {
                    try {
                        const raw = JSON.parse(linkedService.raw);
                        authenticationMethod =
                            raw.properties.credentialDetails.credentialType ||
                            raw.properties.typeProperties?.authenticationType; // sample dataset;
                    } catch (ex) {
                        // noop
                    }
                }
                if (authenticationMethod && !authTypes.includes(authenticationMethod)) {
                    violations.push({
                        messageType: 'invalid',
                        message: () =>
                            getCopyCommandErrorMessage(
                                activity,
                                format(
                                    __IS_FABRIC_DPE__
                                        ? stringResources.CopyCommand_CopyMethod_CopyCommandSourceAuthType_Error_Trident
                                        : stringResources.CopyCommand_CopyMethod_CopyCommandSourceAuthType_Error,
                                    !isFaultToleranceWithDelimitedTextSource
                                        ? stringResources.Source_Label.toLocaleLowerCase()
                                        : stringResources.DataFlowPanelFaultToleranceSettingsLabel.toLocaleLowerCase(),
                                    formatListWithConjunction(
                                        (authTypes as AzureAuthTypes[]).map((t) => AUTHENTICATION_TYPE_TEXTS[t])
                                    )
                                ),
                                __IS_FABRIC_DPE__
                                    ? stringResources.SourceConnection.toLocaleLowerCase()
                                    : stringResources.SourceLinkedService.toLocaleLowerCase(),
                                'onlySupport',
                                !isFaultToleranceWithDelimitedTextSource
                            ),
                        redirectTo: {
                            entity: !isFaultToleranceWithDelimitedTextSource ? sourceDataset : activity,
                            attribute: !isFaultToleranceWithDelimitedTextSource
                                ? Metamodel.modelOf(sourceDataset).attribute('linkedService')
                                : Metamodel.modelOf(activity.faultTolerenceSettings).attribute(
                                    'incompatibleRowLoggingLinkedService'
                                )
                        }
                    });
                }
            }
        }
        return violations;
    }

    private static async validateFaultToleranceForCopyCommand(activity: CopyActivity): Promise<IViolation[]> {
        if (activity.faultTolerenceSettings?.enableSkipIncompatibleRow) {
            const loggingLsForValidation =
                activity.faultTolerenceSettings.useNewFaultTolerance &&
                    activity.enableLogging &&
                    activity.loggingLocation
                    ? activity.loggingLocation.storageLinkedService
                    : activity.faultTolerenceSettings.incompatibleRowLoggingLinkedService;
            const focusAttribute = activity.faultTolerenceSettings.useNewFaultTolerance
                ? Metamodel.modelOf(activity).attribute('loggingLocation')
                : Metamodel.modelOf(activity.faultTolerenceSettings).attribute('incompatibleRowLoggingLinkedService');
            const authTypes: string[] = [
                azureStorageAuthTypes.ServicePrincipalAuthentication,
                azureStorageAuthTypes.AccountKeyAuthentication,
                azureStorageAuthTypes.SasUriAuthentication
            ];
            if (
                loggingLsForValidation instanceof AzureBlobStorageLinkedService &&
                !loggingLsForValidation.fullyByJsonEditor &&
                !authTypes.includes(loggingLsForValidation.authenticationMethod)
            ) {
                return [
                    {
                        messageType: 'invalid',
                        message: () =>
                            getCopyCommandErrorMessage(
                                activity,
                                format(
                                    stringResources.CopyCommand_CopyMethod_CopyCommandSourceAuthType_Error,
                                    stringResources.DataFlowPanelFaultToleranceSettingsLabel.toLocaleLowerCase(),
                                    formatListWithConjunction(
                                        (authTypes as AzureAuthTypes[]).map((t) => AUTHENTICATION_TYPE_TEXTS[t])
                                    )
                                ),
                                '',
                                'onlySupport',
                                false
                            ),
                        redirectTo: {
                            attribute: focusAttribute
                        },
                        doNotAutomaticallyCorrect: true
                    }
                ];
            }
        }

        return [];
    }

    private static validateDelimitedTextDatasetForSnowflake(
        dataset: DelimitedTextDataset,
        directionLabel: string,
        datasetLabel: string
    ): IViolation[] {
        const violations: IViolation[] = [];
        const supportedCodec = [
            compressionCodecType.none,
            compressionCodecType.gzip,
            compressionCodecType.deflate,
            compressionCodecType.bzip2
        ];
        if (
            !stringIsNullOrEmpty(dataset.compressionCodec) &&
            !supportedCodec.map((c) => c.toLowerCase()).includes(dataset.compressionCodec.toLowerCase())
        ) {
            violations.push({
                messageType: 'invalid',
                message: () =>
                    getDirectCopyErrorMessage(
                        directionLabel,
                        format(
                            stringResources.CopyCommand_CopyMethod_CopyCommandSourceCompression_Error,
                            datasetLabel.toLocaleLowerCase(),
                            formatListWithConjunction(supportedCodec)
                        ),
                        stringResources.ModelName_CompressionType,
                        stringResources.Snowflake_DisplayText
                    ),
                redirectTo: {
                    entity: dataset,
                    attribute: DelimitedTextDataset.COMPRESSION_CODEC
                }
            });
        }
        // check format here
        const rowDelimiterIsCRLF =
            dataset.rowDelimiter === rowDelimiters.carriageReturnAndLineFeed || dataset.rowDelimiter === '\\r\\n';
        if (
            !DelimitedTextDataset.ROW_DELIMITER.templateValue(dataset) &&
            !/^(\\u([0-9a-f]){4}|[^])$/.test(dataset.rowDelimiter) &&
            !rowDelimiterIsCRLF
        ) {
            violations.push({
                messageType: 'invalid',
                message: () =>
                    getDirectCopyErrorMessage(
                        directionLabel,
                        format(
                            stringResources.Snowflake_DirectCopyRowDelimiter_Error,
                            datasetLabel.toLocaleLowerCase()
                        ),
                        stringResources.Dataset_FileFormat_RowDelimiterFieldLabel,
                        stringResources.Snowflake_DisplayText
                    ),
                redirectTo: {
                    entity: dataset,
                    attribute: DelimitedTextDataset.ROW_DELIMITER
                }
            });
        }
        if (
            !DelimitedTextDataset.QUOTE_CHAR.templateValue(dataset) &&
            ![charValueConst.EmptyChar, charValueConst.DoubleQuoteChar, charValueConst.SingleChar].includes(
                dataset.quoteChar
            )
        ) {
            violations.push({
                messageType: 'invalid',
                message: () =>
                    getDirectCopyErrorMessage(
                        directionLabel,
                        format(
                            stringResources.Snowflake_DirectCopy_QuoteChar_Error,
                            datasetLabel.toLocaleLowerCase(),
                            formatListWithConjunction([
                                stringResources.Dataset_FileFormat_QuoteCharDouble,
                                stringResources.Dataset_FileFormat_QuoteCharSingle,
                                stringResources.Dataset_FileFormat_QuoteCharNone
                            ])
                        ),
                        stringResources.Dataset_FileFormat_QuoteCharFieldLabel,
                        stringResources.Snowflake_DisplayText
                    ),
                redirectTo: {
                    entity: dataset,
                    attribute: DelimitedTextDataset.QUOTE_CHAR
                }
            });
        }
        return violations;
    }

    private static validateDelimitedTextDatasetForAzureDatabricksDeltaLake(
        dataset: DelimitedTextDataset,
        directionLabel: string,
        datasetLabel: string,
        connectorName: string
    ): IViolation[] {
        const violations: IViolation[] = [];

        const supportedCodec = [compressionCodecType.none, compressionCodecType.gzip, compressionCodecType.bzip2];
        // Only supports compression type as none, BZip2, GZip
        if (
            !stringIsNullOrEmpty(dataset.compressionCodec) &&
            !supportedCodec.map((c) => c.toLowerCase()).includes(dataset.compressionCodec.toLowerCase())
        ) {
            violations.push({
                messageType: 'invalid',
                message: () =>
                    getDirectCopyErrorMessage(
                        directionLabel,
                        format(
                            stringResources.CopyCommand_CopyMethod_CopyCommandSourceCompression_Error,
                            datasetLabel.toLocaleLowerCase(),
                            formatListWithConjunction(supportedCodec)
                        ),
                        stringResources.ModelName_CompressionType,
                        connectorName
                    ),
                redirectTo: {
                    entity: dataset,
                    attribute: DelimitedTextDataset.COMPRESSION_CODEC
                }
            });
        }

        // only support default row delimiter or single char when read from csv, only support single char when writing to csv
        if (
            directionLabel === stringResources.To &&
            dataset.rowDelimiter != null &&
            dataset.rowDelimiter.length !== 1
        ) {
            violations.push({
                messageType: 'invalid',
                message: () =>
                    getDirectCopyErrorMessage(
                        directionLabel,
                        format(
                            stringResources.AzureDatabricksDeltaLake_DirectCopy_To_RowDelimiter_Error,
                            datasetLabel.toLocaleLowerCase()
                        ),
                        stringResources.Dataset_FileFormat_RowDelimiterFieldLabel,
                        connectorName
                    ),
                redirectTo: {
                    entity: dataset,
                    attribute: DelimitedTextDataset.ROW_DELIMITER
                }
            });
        }
        if (
            directionLabel === stringResources.From &&
            (dataset.rowDelimiter == null || dataset.rowDelimiter.length !== 1)
        ) {
            violations.push({
                messageType: 'invalid',
                message: () =>
                    getDirectCopyErrorMessage(
                        directionLabel,
                        format(
                            stringResources.AzureDatabricksDeltaLake_DirectCopy_From_RowDelimiter_Error,
                            datasetLabel.toLocaleLowerCase()
                        ),
                        stringResources.Dataset_FileFormat_RowDelimiterFieldLabel,
                        connectorName
                    ),
                redirectTo: {
                    entity: dataset,
                    attribute: DelimitedTextDataset.ROW_DELIMITER
                }
            });
        }

        // not support UTF-7 encoding
        if (!stringIsNullOrEmpty(dataset.encodingName) && dataset.encodingName === 'UTF-7') {
            violations.push({
                messageType: 'invalid',
                message: () =>
                    getDirectCopyErrorMessage(
                        directionLabel,
                        format(
                            stringResources.CopyCommand_CopyMethod_CopyCommandEncodingName_Error,
                            datasetLabel.toLocaleLowerCase(),
                            'UTF-7'
                        ),
                        stringResources.ModelName_Encoding,
                        connectorName,
                        'notSupport'
                    ),
                redirectTo: {
                    entity: dataset,
                    attribute: DelimitedTextDataset.ENCODING_NAME
                }
            });
        }
        return violations;
    }

    private static _getRuntimeSelfhostedIR(activity: CopyActivity): SelfHostedIntegrationRuntime {
        const stagingLS =
            activity.enableStaging && activity.stagingSettings
                ? activity.stagingSettings.storageLinkedService
                : undefined;
        return getRuntimeSelfHostedIR(activity.sourceDataset, activity.sinkDataset, undefined, undefined, stagingLS);
    }

    private static async validateSourceForDirectCopyWithSnowflakeSink(
        activity: CopyActivity,
        context?: IValidationContext
    ): Promise<IViolation[]> {
        const dataset = activity.sourceDataset;
        const violations: IViolation[] = [];
        // validate copy source
        // validate additional columns
        if (activity.source && !arrayIsNullOrEmpty(activity.source.additionalColumns)) {
            violations.push({
                messageType: 'invalid',
                message: () =>
                    getConnectionAsSinkDirectCopyErrorMessage(
                        activity,
                        stringResources.DirectCopy_AdditionalColumns_Error,
                        stringResources.CopySource_AdditionalColumns,
                        stringResources.Snowflake_DisplayText,
                        'notSupport'
                    ),
                redirectTo: {
                    attribute: CopyActivity.ENABLE_STAGING
                }
            });
        }
        if (
            activity.source &&
            (activity.source as FormatTypeCopySource).storeSettings instanceof BlobTypeStoreReadSettings
        ) {
            const storeSettings = (activity.source as FormatTypeCopySource).storeSettings as BlobTypeStoreReadSettings;
            // check copy source source modified time start and end
            if (!modifiedTimeIsNull(storeSettings)) {
                violations.push({
                    messageType: 'unsupported',
                    message: () =>
                        getConnectionAsSinkDirectCopyErrorMessage(
                            activity,
                            stringResources.CopyCommand_CopyMethod_CopyCommandModifiedTime_Error,
                            stringResources.CopyCommand_CopyMethod_ModifiedTime,
                            stringResources.Snowflake_DisplayText
                        ),
                    redirectTo: {
                        attribute: BlobTypeStoreReadSettings.MODIFID_DATETIME_START
                    }
                });
            }
            // recursive can only be true
            if (
                storeSettings.filePathMode !== FilePathMode.LIST &&
                !storeSettings.recursive &&
                !BlobTypeStoreReadSettings.RECURSIVE_SETTING.templateValue(storeSettings)
            ) {
                violations.push({
                    messageType: 'invalid',
                    message: () =>
                        getConnectionAsSinkDirectCopyErrorMessage(
                            activity,
                            stringResources.CopyCommand_CopyMethod_CopyCommandRecursive_Error,
                            stringResources.Recursive,
                            stringResources.Snowflake_DisplayText
                        ),
                    redirectTo: {
                        attribute: BlobTypeStoreReadSettings.RECURSIVE_SETTING
                    }
                });
            }
            // not support blob prefix
            if (Metamodel.modelOf(storeSettings)?.hasAttribute('prefix') && !prefixPathIsNull(storeSettings)) {
                violations.push({
                    messageType: 'unsupported',
                    message: () =>
                        getConnectionAsSinkDirectCopyErrorMessage(
                            activity,
                            stringResources.DirectCoppy_Prefix_Error,
                            stringResources.Prefix,
                            stringResources.Snowflake_DisplayText
                        ),
                    redirectTo: {
                        attribute: Metamodel.modelOf(storeSettings).attribute('prefix')
                    }
                });
            }
        }
        // validate source dataset
        if (dataset instanceof DelimitedTextDataset) {
            const delimitedResult = CopyActivity.validateDelimitedTextDatasetForSnowflake(
                dataset,
                stringResources.To,
                CopyActivity._sourceDatasetLabel
            );
            violations.push(...delimitedResult);
            if (
                !stringIsNullOrEmpty(dataset.encodingName) &&
                !snowflakeSupportedDelimitedSourceEncodingName.includes(dataset.encodingName.toUpperCase())
            ) {
                violations.push({
                    messageType: 'invalid',
                    message: () =>
                        getConnectionAsSinkDirectCopyErrorMessage(
                            activity,
                            format(
                                stringResources.CopyCommand_CopyMethod_CopyCommandEncodingName_Error,
                                CopyActivity._sourceDatasetLabel,
                                formatListWithConjunction(snowflakeSupportedDelimitedSourceEncodingName)
                            ),
                            stringResources.ModelName_Encoding,
                            stringResources.Snowflake_DisplayText
                        ),
                    redirectTo: {
                        entity: dataset,
                        attribute: DelimitedTextDataset.ENCODING_NAME
                    }
                });
            }
            const rowDelimiterIsCRLFOrParameterized =
                DelimitedTextDataset.ROW_DELIMITER.templateValue(dataset) ||
                dataset.rowDelimiter === rowDelimiters.carriageReturnAndLineFeed ||
                dataset.rowDelimiter === '\\r\\n';
            if (
                ((activity.source as DelimitedTextCopySource).formatSettings as DelimitedTextFormatReadSettings)
                    ?.skipLineCount > 0 &&
                !rowDelimiterIsCRLFOrParameterized
            ) {
                violations.push({
                    messageType: 'invalid',
                    message: () =>
                        getConnectionAsSinkDirectCopyErrorMessage(
                            activity,
                            stringResources.CopyCommand_CopyMethod_CopyCommandSkipLineCount_Error +
                            stringResources.Snowflake_DirectCopy_RowDelimiterisCRLF,
                            stringResources.SkipLineCountLabel,
                            stringResources.Snowflake_DisplayText
                        ),
                    redirectTo: {
                        attribute: DelimitedTextFormatReadSettings.SKIP_LINE_COUNT
                    }
                });
            }
            if (dataset.firstRowAsHeader && !rowDelimiterIsCRLFOrParameterized) {
                violations.push({
                    messageType: 'invalid',
                    message: () =>
                        getConnectionAsSinkDirectCopyErrorMessage(
                            activity,
                            stringResources.Snowflake_DirectCopy_CopyCommandFirstRowAsHeader_Error +
                            stringResources.Snowflake_DirectCopy_RowDelimiterisCRLF,
                            stringResources.ModelName_FirstRowAsHeader,
                            stringResources.Snowflake_DisplayText
                        ),
                    redirectTo: {
                        entity: activity.sourceDataset,
                        attribute: DelimitedTextDataset.FIRSTROW_ASHEADER
                    }
                });
            }
        } else if (dataset instanceof ParquetDataset || dataset instanceof JsonDataset) {
            const supportedCodec =
                dataset instanceof JsonDataset
                    ? [
                        compressionCodecType.none,
                        compressionCodecType.gzip,
                        compressionCodecType.deflate,
                        compressionCodecType.bzip2
                    ]
                    : [compressionCodecType.none, compressionCodecType.snappy];
            if (
                !stringIsNullOrEmpty(dataset.compressionCodec) &&
                !supportedCodec.map((c) => c.toLowerCase()).includes(dataset.compressionCodec.toLowerCase())
            ) {
                violations.push({
                    messageType: 'invalid',
                    message: () =>
                        getConnectionAsSinkDirectCopyErrorMessage(
                            activity,
                            format(
                                stringResources.CopyCommand_CopyMethod_CopyCommandSourceCompression_Error,
                                CopyActivity._sourceDatasetLabel,
                                formatListWithConjunction(supportedCodec)
                            ),
                            stringResources.ModelName_CompressionType,
                            stringResources.Snowflake_DisplayText
                        ),
                    redirectTo: {
                        entity: dataset,
                        attribute: Metamodel.modelOf(dataset).attribute('compressionCodec')
                    }
                });
            }

            if (dataset instanceof JsonDataset) {
                // encodingName UTF-8
                if (
                    !stringIsNullOrEmpty(dataset.encodingName) &&
                    !snowflakeSupportedJSONSourceEncodingName.includes(dataset.encodingName.toUpperCase())
                ) {
                    violations.push({
                        messageType: 'invalid',
                        message: () =>
                            getConnectionAsSinkDirectCopyErrorMessage(
                                activity,
                                format(
                                    stringResources.CopyCommand_CopyMethod_CopyCommandEncodingName_Error,
                                    CopyActivity._sourceDatasetLabel,
                                    formatListWithConjunction(snowflakeSupportedJSONSourceEncodingName)
                                ),
                                stringResources.ModelName_Encoding,
                                stringResources.Snowflake_DisplayText
                            ),
                        redirectTo: {
                            entity: dataset,
                            attribute: JsonDataset.ENCODING_NAME
                        }
                    });
                }
                // not support mapping
                if (!arrayIsNullOrEmpty(activity.mappingV2)) {
                    violations.push({
                        messageType: 'invalid',
                        message: () =>
                            getConnectionAsSinkDirectCopyErrorMessage(
                                activity,
                                stringResources.Snowflake_DirectCopy_CopyMapping_Error,
                                stringResources.CopyWizard_Dataset_ColumnMapping_PageHeader,
                                stringResources.Snowflake_DisplayText
                            ),
                        redirectTo: {
                            attribute: CopyActivity.ENABLE_STAGING
                        }
                    });
                }
                // early throw static violations
                if (!arrayIsNullOrEmpty(violations)) {
                    return violations;
                }
                if (context && !context.isRetryStage) {
                    // validate schema in snowflake dataset
                    const schemaViolations = await CopyActivity.validateSnowflakeSchema(
                        activity.sinkDataset,
                        undefined,
                        context
                    );
                    if (!arrayIsNullOrEmpty(schemaViolations)) {
                        return schemaViolations;
                    }
                }
            }
        }
        return violations;
    }

    private static async _validateSourceForDirectCopyWithTeradate(activity: CopyActivity): Promise<IViolation[]> {
        const dataset = activity.sourceDataset;
        const violations: IViolation[] = [];
        // validate copy source
        const sourceResource = validateSourceSettingsForTeradata(activity);
        violations.push(...sourceResource);
        // validate source dataset
        if (dataset instanceof DelimitedTextDataset) {
            const delimitedResult = validateDelimitedTextDatasetForTeradata(
                activity,
                dataset,
                stringResources.To,
                CopyActivity._sourceDatasetLabel
            );
            violations.push(...delimitedResult);
        } else if (dataset instanceof ParquetDataset) {
            const parquetResult = validateParquetDatasetForTeradata(
                activity,
                dataset,
                CopyActivity._sourceDatasetLabel
            );
            violations.push(...parquetResult);
        }
        return violations;
    }

    private static async validateSourceForDirectCopyWithAzureDatabricksDeltaSink(
        activity: CopyActivity
    ): Promise<IViolation[]> {
        const dataset = activity.sourceDataset;
        const connectorDisplayName = getDatabricksFamilyDisplayName(activity.sinkDataset);
        const violations: IViolation[] = [];
        // validate copy source
        // validate additional columns
        if (activity.source && !arrayIsNullOrEmpty(activity.source.additionalColumns)) {
            violations.push({
                messageType: 'invalid',
                message: () =>
                    getConnectionAsSinkDirectCopyErrorMessage(
                        activity,
                        stringResources.DirectCopy_AdditionalColumns_Error,
                        stringResources.CopySource_AdditionalColumns,
                        connectorDisplayName,
                        'notSupport'
                    ),
                redirectTo: {
                    attribute: CopyActivity.ENABLE_STAGING
                }
            });
        }
        if (
            activity.source &&
            (activity.source as FormatTypeCopySource).storeSettings instanceof BlobTypeStoreReadSettings
        ) {
            const storeSettings = (activity.source as FormatTypeCopySource).storeSettings as BlobTypeStoreReadSettings;
            // check copy source source modified time start and end
            if (!modifiedTimeIsNull(storeSettings)) {
                violations.push({
                    messageType: 'unsupported',
                    message: () =>
                        getConnectionAsSinkDirectCopyErrorMessage(
                            activity,
                            stringResources.CopyCommand_CopyMethod_CopyCommandModifiedTime_Error,
                            stringResources.CopyCommand_CopyMethod_ModifiedTime,
                            connectorDisplayName
                        ),
                    redirectTo: {
                        attribute: BlobTypeStoreReadSettings.MODIFID_DATETIME_START
                    }
                });
            }
            // wildcard folder path must be empty
            if (
                storeSettings.filePathMode === FilePathMode.WILDCARD &&
                !BlobTypeStoreReadSettings.WILDCARD_FOLDERPATH.templateValue(storeSettings) &&
                !!storeSettings.wildcardFolderPath
            ) {
                violations.push({
                    messageType: 'unsupported',
                    message: () =>
                        getConnectionAsSinkDirectCopyErrorMessage(
                            activity,
                            stringResources.AzureDatabricksDeltaLake_WildcardFolderPath_Error,
                            stringResources.ModelName_WildcardFolderPath,
                            connectorDisplayName
                        ),
                    redirectTo: {
                        attribute: BlobTypeStoreReadSettings.WILDCARD_FOLDERPATH
                    }
                });
            }
            // wildcard file name can only contains *
            if (
                storeSettings.filePathMode === FilePathMode.WILDCARD &&
                !BlobTypeStoreReadSettings.WILDCARD_FILENAME.templateValue(storeSettings) &&
                !!storeSettings.wildcardFileName &&
                (storeSettings.wildcardFileName.indexOf('?') >= 0 || storeSettings.wildcardFileName.indexOf('^') >= 0)
            ) {
                violations.push({
                    messageType: 'unsupported',
                    message: () =>
                        getConnectionAsSinkDirectCopyErrorMessage(
                            activity,
                            stringResources.AzureDatabricksDeltaLake_WildcardFileName_Error,
                            stringResources.ModelName_WildcardFileName,
                            connectorDisplayName
                        ),
                    redirectTo: {
                        attribute: BlobTypeStoreReadSettings.WILDCARD_FILENAME
                    }
                });
            }
            // recursive can be true only when wildcard file name is * or file mode is dataset
            if (
                storeSettings.filePathMode !== FilePathMode.LIST &&
                storeSettings.filePathMode !== FilePathMode.DATASET &&
                !BlobTypeStoreReadSettings.RECURSIVE_SETTING.templateValue(storeSettings) &&
                storeSettings.recursive &&
                (storeSettings.filePathMode !== FilePathMode.WILDCARD || storeSettings.wildcardFileName !== '*')
            ) {
                violations.push({
                    messageType: 'invalid',
                    message: () =>
                        getConnectionAsSinkDirectCopyErrorMessage(
                            activity,
                            stringResources.AzureDatabricksDeltaLake_Recursive_Error,
                            stringResources.Recursive,
                            connectorDisplayName
                        ),
                    redirectTo: {
                        attribute: BlobTypeStoreReadSettings.RECURSIVE_SETTING
                    }
                });
            }
            // not support blob prefix
            if (Metamodel.modelOf(storeSettings)?.hasAttribute('prefix') && !prefixPathIsNull(storeSettings)) {
                violations.push({
                    messageType: 'unsupported',
                    message: () =>
                        getConnectionAsSinkDirectCopyErrorMessage(
                            activity,
                            stringResources.DirectCoppy_Prefix_Error,
                            stringResources.Prefix,
                            connectorDisplayName
                        ),
                    redirectTo: {
                        attribute: Metamodel.modelOf(storeSettings).attribute('prefix')
                    }
                });
            }
        }
        // not support skip line count
        if (
            activity.source &&
            (activity.source as FormatTypeCopySource).formatSettings instanceof DelimitedTextFormatReadSettings
        ) {
            const formatSettings = (activity.source as FormatTypeCopySource)
                .formatSettings as DelimitedTextFormatReadSettings;
            if (
                !DelimitedTextFormatReadSettings.SKIP_LINE_COUNT.templateValue(formatSettings) &&
                formatSettings.skipLineCount != null &&
                formatSettings.skipLineCount !== 0
            ) {
                violations.push({
                    messageType: 'invalid',
                    message: () =>
                        getConnectionAsSinkDirectCopyErrorMessage(
                            activity,
                            stringResources.AzureDatabricksDeltaLake_DirectCoppy_SkipLineCount_Error,
                            stringResources.SkipLineCountLabel,
                            connectorDisplayName,
                            'notSupport'
                        ),
                    redirectTo: {
                        attribute: DelimitedTextFormatReadSettings.SKIP_LINE_COUNT
                    }
                });
            }
        }
        // validate source dataset
        if (dataset instanceof DelimitedTextDataset) {
            const delimitedResult = CopyActivity.validateDelimitedTextDatasetForAzureDatabricksDeltaLake(
                dataset,
                stringResources.To,
                CopyActivity._sourceDatasetLabel,
                connectorDisplayName
            );
            violations.push(...delimitedResult);
        } else if (dataset instanceof ParquetDataset) {
            // the supported compression codec is “None”, “Snappy” and “GZip”.
            const supportedCodec = [compressionCodecType.none, compressionCodecType.gzip, compressionCodecType.snappy];
            if (
                !stringIsNullOrEmpty(dataset.compressionCodec) &&
                !supportedCodec.map((c) => c.toLowerCase()).includes(dataset.compressionCodec.toLowerCase())
            ) {
                violations.push({
                    messageType: 'invalid',
                    message: () =>
                        getConnectionAsSinkDirectCopyErrorMessage(
                            activity,
                            format(
                                stringResources.CopyCommand_CopyMethod_CopyCommandSourceCompression_Error,
                                CopyActivity._sourceDatasetLabel,
                                formatListWithConjunction(supportedCodec)
                            ),
                            stringResources.ModelName_CompressionType,
                            connectorDisplayName
                        ),
                    redirectTo: {
                        entity: dataset,
                        attribute: ParquetDataset.COMPRESSION_CODEC
                    }
                });
            }
        }
        return violations;
    }

    public async addUserProperties(property: string, contextData: IResourceContext): Promise<void> {
        let userProperty: UserProperty;

        try {
            const copyActivity = (await ModelUtilties.toResource(
                AdapterContext.defaultContextOf(contextData),
                this
            )) as Model.CopyActivity;

            if (property === 'source' && copyActivity.inputs && copyActivity.inputs[0]) {
                const sourceLsType =
                    this.sourceDataset != null && this.sourceDataset.linkedService != null
                        ? Metamodel.modelOf(this.sourceDataset.linkedService).name
                        : undefined;
                userProperty = await this.getUserProperty(
                    (await ModelUtilties.toResource(
                        AdapterContext.defaultContextOf(contextData),
                        this.sourceDataset
                    )) as Model.DatasetResource,
                    copyActivity.inputs[0].parameters,
                    'source',
                    sourceLsType,
                    contextData
                );
            }

            if (property === 'sink' && copyActivity.outputs && copyActivity.outputs[0]) {
                const sinkLsType =
                    this.sinkDataset != null && this.sinkDataset.linkedService != null
                        ? Metamodel.modelOf(this.sinkDataset.linkedService).name
                        : undefined;
                userProperty = await this.getUserProperty(
                    (await ModelUtilties.toResource(
                        AdapterContext.defaultContextOf(contextData),
                        this.sinkDataset
                    )) as Model.DatasetResource,
                    copyActivity.outputs[0].parameters,
                    'sink',
                    sinkLsType,
                    contextData
                );
            }
        } catch {
            userProperty = undefined;
        }

        let userPropertyName: string;
        if (property === 'source') {
            userPropertyName = 'Source';
        }
        if (property === 'sink') {
            userPropertyName = 'Destination';
        }

        if (userPropertyName) {
            const item = this.userProperties.find((element) => element.name === userPropertyName);
            if (item) {
                this.userProperties.delete(item);
            }
        }

        if (userProperty) {
            this.userProperties.add(userProperty);
        }
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    // public static formatSQLDWMessage(sink: CopySink, resourceTemplate: string, ...formatArgs: string[]): string {
    //     const finalLabel =
    //         sink instanceof SqlPoolSink
    //             ? stringResources.SQLPool
    //             : Metamodel.modelOf(sink).name === CopyActivity.getWarehouseModelType().copySinkType
    //             ? stringResources.DataWarehouse_DisplayText
    //             : stringResources.AzureSynapseAnalytics;
    //     return format(resourceTemplate, finalLabel, ...formatArgs);
    // }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static getWarehouseModelType() {
        return __IS_FABRIC_DPE__ ? adfModelTypeMap.DataWarehouse : adfModelTypeMap.Warehouse;
    }

    public onActivityCloned(clonedActivity: CopyActivity, context: { inlineDataset?: boolean }): void {
        if (this.sourceDataset != null) {
            this.sourceDataset.onDatasetCloned(clonedActivity.sourceDataset, context);
        }

        if (this.sinkDataset != null) {
            this.sinkDataset.onDatasetCloned(clonedActivity.sinkDataset, context);
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private async getUserProperty(
        dataset: Model.DatasetResource,
        parameters: { [name: string]: any },
        role: ConnectionRoleType,
        lsType: string,
        contextData: IResourceContext
    ): Promise<UserProperty | undefined> {
        parameters = parameters || {};

        const userPropertiesService = await getServiceInstance<UserPropertiesService>(
            contextData,
            'UserPropertiesService'
        );

        const keys = userPropertiesService.getKeysByDatasetAndLsType(dataset.properties.type, lsType);
        // for v2 format dataset, we need to fetch value from location
        let locationProperties = {};
        if (dataset.properties != null && (dataset.properties as any).typeProperties != null) {
            locationProperties =
                (dataset.properties as any).typeProperties.location || (dataset.properties as any).typeProperties;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const values = keys
            .map((key) => (locationProperties as any)[key])
            .map((value) => (value != null && value.type === 'Expression' ? value.value : value))
            .map((value) => (value == null ? '' : '' + value))
            .map((value) => {
                /*
                    TODO: some special cases are not correctly handled
                    1. dataset expression in plain string shouldn't be replaced (this case is rare, need to parse and rebuild expression to handle correctly)
                    2. dataset expression in pipeline parameter shouldn't be evaluated (this case is user error)
                */

                let maxEvaluationCount = 1000;

                const regExp = /dataset\(\)\.([A-Za-z0-9_]+)/;
                while (maxEvaluationCount > 0) {
                    maxEvaluationCount -= 1;

                    const regExpExecArray = regExp.exec(value);
                    if (regExpExecArray == null) {
                        break;
                    }

                    const paramKey = regExpExecArray[1];
                    let paramValue = parameters[paramKey];
                    if (paramValue != null && paramValue.type === 'Expression') {
                        paramValue = paramValue.value;
                    }
                    paramValue = concatStyleExpression(paramValue);
                    if (paramValue === 'null') {
                        paramValue = `'<${paramKey}>'`;
                    }

                    value = value.replace(regExp, paramValue);
                }

                return maxEvaluationCount > 0 ? value : '<error>';
            });

        const dsConfig = (
            await getServiceInstance<DatasetRegistryService>(contextData, 'DatasetRegistryService')
        ).getDatasetConfiguration(dataset.properties.type);
        const userProperty = userPropertiesService.generateUserProperty(
            values,
            keys,
            role,
            dsConfig.splitTablePath ? '.' : undefined,
            dsConfig
        );
        return userProperty != null ? new UserProperty(userProperty.name, userProperty.value) : undefined;
    }
}

/**
 * @param copy
 * @param datasetOnly True to ignore the copy command/poylbase check, just apply dataset configuration check
 * @param datasetRegSvc
 */
export function supportTypeConversion(
    copy: CopyActivity,
    datasetOnly: boolean = false,
    datasetRegSvc: DatasetRegistryService
): boolean {
    const sourceDataset = copy.sourceDataset;
    const sinkDataset = copy.sinkDataset;
    const usePolybaseOrCopyCommand =
        CopyActivity.checkIfEnabledCopyCommand(copy) || CopyActivity.checkIfEnabledPolybase(copy);
    datasetOnly = datasetOnly || __IS_FABRIC_DPE__;

    if ((!usePolybaseOrCopyCommand || datasetOnly) && sourceDataset?.isV2 && sinkDataset?.isV2) {
        const sourceDatasetConfig = datasetRegSvc.getDatasetConfiguration(Metamodel.modelOf(sourceDataset).name);
        const sinkDatasetConfig = datasetRegSvc.getDatasetConfiguration(Metamodel.modelOf(sinkDataset).name);

        // Type conversion is not applied when both the source and sink transfer data via external commands
        // (e.g. source: Snowflake/Databricks Delta Lake COPY; sink: Snowflake COPY, SQL DW copy command/polybase,
        // Teradata TPT), because the data is moved directly between the stores without passing through the type
        // conversion engine.
        const sourceUsesExternalCommand = !!sourceDatasetConfig.useExternalCommandWhenSource;
        const sinkUsesExternalCommand = !!sinkDatasetConfig.useExternalCommandWhenSink || usePolybaseOrCopyCommand;
        if (sourceUsesExternalCommand && sinkUsesExternalCommand) {
            return false;
        }

        // special handling for SQL DW: SQL DW sink can always support type conversion if copy method is not polybase or copy command
        const sqlDWSinkSupportTypeConversion =
            sinkDatasetConfig.type === adfModelTypeMap.azureSqlDW.datasetType && !usePolybaseOrCopyCommand;

        const sinkSupportTypeConversion =
            (!sinkDatasetConfig.notSupportTypeConversion && !sinkDatasetConfig.notSupportTypeConversionWhenSink) ||
            sqlDWSinkSupportTypeConversion;
        const sourceSupportTypeConversion =
            !sourceDatasetConfig.notSupportTypeConversion && !sourceDatasetConfig.notSupportTypeConversionWhenSource;
        const stagingSupportTypeConversion =
            (copy.enableStaging || ValueAdapter.isTemplated(copy, CopyActivity.ENABLE_STAGING)) &&
            (sourceDatasetConfig.supportTypeConversionWhenStaging ||
                sinkDatasetConfig.supportTypeConversionWhenStaging);

        return (
            (sinkSupportTypeConversion && sourceSupportTypeConversion) ||
            (stagingSupportTypeConversion && (sinkSupportTypeConversion || sourceSupportTypeConversion)) ||
            (__IS_FABRIC_DPE__ &&
                (((sourceDatasetConfig.datasetKind === 'hierarchical' ||
                    sinkDatasetConfig.datasetKind === 'hierarchical') &&
                    !(
                        sourceDatasetConfig.datasetKind === 'hierarchical' &&
                        sinkDatasetConfig.datasetKind === 'hierarchical'
                    )) ||
                    sourceDatasetConfig.sourceSupportFlattenColumns))
        );
    }

    return false;
}

export function supportDataConsistency(
    copyActivity: CopyActivity,
    isCopyWizard: boolean = false,
    services: {
        linkedServiceRegSvc: LinkedServiceRegistryService;
        datasetRegSvc: DatasetRegistryService;
    }
): boolean {
    if (
        !copyActivity.sourceDataset ||
        !copyActivity.sourceDataset.isV2 ||
        !copyActivity.sinkDataset ||
        !copyActivity.sinkDataset.isV2 ||
        !copyActivity.sourceDataset.linkedService ||
        !copyActivity.sinkDataset.linkedService
    ) {
        return false;
    }
    if (
        copyActivity.sourceDataset instanceof SnowflakeTableDataset ||
        isDatabricksFamilyDataset(copyActivity.sourceDataset) ||
        copyActivity.sourceDataset instanceof Office365Dataset ||
        copyActivity.sinkDataset instanceof SnowflakeTableDataset ||
        isDatabricksFamilyDataset(copyActivity.sinkDataset)
    ) {
        return false;
    }
    if (
        !isCopyWizard &&
        (CopyActivity.checkIfEnabledPolybase(copyActivity) ||
            CopyActivity.checkIfEnabledCopyCommand(copyActivity) ||
            CopyActivity.checkIfEnabledStaging(copyActivity, {
                dsSvc: services.datasetRegSvc
            }) ||
            CopyActivity.checkIfEnabledUnload(copyActivity) ||
            CopyActivity.checkIfEnabledDistCp(copyActivity))
    ) {
        return false;
    }
    if (
        copyActivity.sourceDataset instanceof BinaryDataset &&
        (!!BinaryDataset.COMPRESSION_CODEC.templateValue(copyActivity.sourceDataset) ||
            !!copyActivity.sourceDataset.compressionCodec)
    ) {
        return false;
    }
    if (
        copyActivity.sinkDataset instanceof BinaryDataset &&
        (!!BinaryDataset.COMPRESSION_CODEC.templateValue(copyActivity.sinkDataset) ||
            !!copyActivity.sinkDataset.compressionCodec)
    ) {
        return false;
    }
    const sourceDataset = copyActivity.sourceDataset;
    const sinkDataset = copyActivity.sinkDataset;
    const sourceLinkedService = sourceDataset.linkedService;
    const sinkLinkedService = sinkDataset.linkedService;
    const sourceDatasetType = Metamodel.modelOf(sourceDataset).name;
    const sourceLinkedServiceType = Metamodel.modelOf(sourceLinkedService).name;
    const sinkLinkedServiceType = Metamodel.modelOf(sinkLinkedService).name;
    const sourceDatasetConfig = services.datasetRegSvc.getDatasetConfiguration(sourceDatasetType);
    const sourceLinkedServiceConfig =
        services.linkedServiceRegSvc.getLinkedServiceConfiguration(sourceLinkedServiceType);
    const sinkLinkedServiceConfig = services.linkedServiceRegSvc.getLinkedServiceConfiguration(sinkLinkedServiceType);

    if (
        sourceLinkedServiceConfig.linkedServiceKind === 'file' &&
        dataConsistencySourceLinkedServiceTypes.indexOf(sourceLinkedServiceType) < 0
    ) {
        return false;
    }

    // Lakehouse shares a 'file' kind linked service for both Lakehouse Files and Lakehouse Table.
    // A Lakehouse Table is a tabular sink with no file storeSettings; the backend validates it via
    // row count, so it must bypass the file-store (storeSettings/copyBehavior) checks below.
    if (sinkLinkedServiceConfig.linkedServiceKind === 'file' && !(sinkDataset instanceof LakehouseTableDataset)) {
        if (
            dataConsistencySinkLinkedServiceTypes.indexOf(sinkLinkedServiceType) < 0 ||
            !copyActivity.copySink ||
            !(copyActivity.copySink as any).storeSettings ||
            ((copyActivity.copySink as any).storeSettings.copyBehavior != null &&
                (copyActivity.copySink as any).storeSettings.copyBehavior !==
                copyBehaviorOptionValues.preserveHierarchy &&
                (sinkDataset instanceof BinaryDataset ||
                    (copyActivity.copySink as any).storeSettings.copyBehavior !== copyBehaviorOptionValues.mergeFiles))
        ) {
            return false;
        }
    }

    if (
        sourceDatasetConfig.datasetKind === 'hierarchical' &&
        (!!copyActivity.collectionReference || !!CopyActivity.COLLECTION_REFERENCE.templateValue(copyActivity))
    ) {
        return false;
    }

    return true;
}

export async function getDataConsistencyErrorMessage(
    copyActivity: CopyActivity,
    context: IValidationContext
): Promise<string> {
    if (
        !copyActivity.sourceDataset ||
        !copyActivity.sinkDataset ||
        !copyActivity.sourceDataset.linkedService ||
        !copyActivity.sinkDataset.linkedService
    ) {
        // These errors will be catched by other validations
        return '';
    }
    if (
        copyActivity.sourceDataset instanceof SnowflakeTableDataset ||
        isDatabricksFamilyDataset(copyActivity.sourceDataset) ||
        copyActivity.sourceDataset instanceof Office365Dataset ||
        copyActivity.sinkDataset instanceof SnowflakeTableDataset ||
        isDatabricksFamilyDataset(copyActivity.sinkDataset)
    ) {
        return (
            stringResources.DataConsistency_NotSupport_Datasets +
            stringResources.DataConsistency_NotSupport_Datasets_Delta
        );
    }
    if (
        (copyActivity.sourceDataset instanceof BinaryDataset &&
            (!!BinaryDataset.COMPRESSION_CODEC.templateValue(copyActivity.sourceDataset) ||
                !!copyActivity.sourceDataset.compressionCodec)) ||
        (copyActivity.sinkDataset instanceof BinaryDataset &&
            (!!BinaryDataset.COMPRESSION_CODEC.templateValue(copyActivity.sinkDataset) ||
                !!copyActivity.sinkDataset.compressionCodec))
    ) {
        return stringResources.DataConsistency_NotSupport_BinaryCompression;
    }
    if (!copyActivity.sourceDataset.isV2) {
        return format(stringResources.DataConsistency_Not_Support_SourceV1, copyActivity.sourceDataset.name);
    }
    if (!copyActivity.sinkDataset.isV2) {
        return format(stringResources.DataConsistency_Not_Support_SinkV1, copyActivity.sinkDataset.name);
    }
    if (CopyActivity.checkIfEnabledPolybase(copyActivity)) {
        return format(
            stringResources.DataConsistency_NotSupport_ExternalCopy,
            stringResources.PolybaseSetting_Polybase_Label
        );
    }
    if (CopyActivity.checkIfEnabledCopyCommand(copyActivity)) {
        return format(stringResources.DataConsistency_NotSupport_ExternalCopy, stringResources.CopyCommand);
    }
    const datasetRegSvc = await getServiceInstance<DatasetRegistryService>(
        context.contextData,
        'DatasetRegistryService'
    );
    if (
        CopyActivity.checkIfEnabledStaging(copyActivity, {
            dsSvc: datasetRegSvc
        })
    ) {
        return format(stringResources.DataConsistency_NotSupport_ExternalCopy, stringResources.Staging);
    }
    if (CopyActivity.checkIfEnabledUnload(copyActivity)) {
        return format(
            stringResources.DataConsistency_NotSupport_ExternalCopy,
            stringResources.Monitoring_CopyActivity_RedshiftUnlaod
        );
    }
    if (CopyActivity.checkIfEnabledDistCp(copyActivity)) {
        return format(
            stringResources.DataConsistency_NotSupport_ExternalCopy,
            stringResources.Monitoring_CopyActivity_HDFSDistcp
        );
    }
    const linkedServiceRegSvc = await getServiceInstance<LinkedServiceRegistryService>(
        context.contextData,
        'LinkedServiceRegistryService'
    );
    const sourceDataset = copyActivity.sourceDataset;
    const sinkDataset = copyActivity.sinkDataset;
    const sourceLinkedService = sourceDataset.linkedService;
    const sinkLinkedService = sinkDataset.linkedService;
    const sourceDatasetType = Metamodel.modelOf(sourceDataset).name;
    const sourceLinkedServiceType = Metamodel.modelOf(sourceLinkedService).name;
    const sinkLinkedServiceType = Metamodel.modelOf(sinkLinkedService).name;
    const sourceDatasetConfig = datasetRegSvc.getDatasetConfiguration(sourceDatasetType);
    const sourceLinkedServiceConfig = linkedServiceRegSvc.getLinkedServiceConfiguration(sourceLinkedServiceType);
    const sinkLinkedServiceConfig = linkedServiceRegSvc.getLinkedServiceConfiguration(sinkLinkedServiceType);

    if (
        sourceLinkedServiceConfig.linkedServiceKind === 'file' &&
        dataConsistencySourceLinkedServiceTypes.indexOf(sourceLinkedServiceType) < 0
    ) {
        const ecSvc = await getServiceInstance<ExposureControlService>(context.contextData, 'ExposureControlService');
        return ecSvc.enableSharePointOnlineFile
            ? stringResources.DataConsistency_OnlySupport_TheseSourceFileTypeLs_1
            : stringResources.DataConsistency_OnlySupport_TheseSourceFileTypeLs;
    }

    // Lakehouse Table is a tabular sink validated via row count on the backend; skip the file-store checks.
    if (sinkLinkedServiceConfig.linkedServiceKind === 'file' && !(sinkDataset instanceof LakehouseTableDataset)) {
        if (dataConsistencySinkLinkedServiceTypes.indexOf(sinkLinkedServiceType) < 0) {
            return stringResources.DataConsistency_OnlySupport_TheseSinkFileTypeLs;
        }
        if (
            sinkDataset instanceof BinaryDataset &&
            (!copyActivity.copySink ||
                !(copyActivity.copySink as any).storeSettings ||
                ((copyActivity.copySink as any).storeSettings.copyBehavior != null &&
                    (copyActivity.copySink as any).storeSettings.copyBehavior !==
                    copyBehaviorOptionValues.preserveHierarchy))
        ) {
            return stringResources.DataConsistency_OnlySupport_Binary_PreserveHierarchy;
        }
        if (
            !(sinkDataset instanceof BinaryDataset) &&
            (!copyActivity.copySink ||
                !(copyActivity.copySink as any).storeSettings ||
                ((copyActivity.copySink as any).storeSettings.copyBehavior != null &&
                    (copyActivity.copySink as any).storeSettings.copyBehavior !==
                    copyBehaviorOptionValues.preserveHierarchy &&
                    (copyActivity.copySink as any).storeSettings.copyBehavior !== copyBehaviorOptionValues.mergeFiles))
        ) {
            return stringResources.DataConsistency_OnlySupport_File_PreserveHierarchy_And_MergeFiles;
        }
    }

    if (
        sourceDatasetConfig.datasetKind === 'hierarchical' &&
        (!!copyActivity.collectionReference || !!CopyActivity.COLLECTION_REFERENCE.templateValue(copyActivity))
    ) {
        return stringResources.DataConsistency_NotSupport_CollectionReference;
    }

    return '';
}

export function supportSkipMissingFile(sourceDataset: Dataset, sinkDataset: Dataset, copySource: CopySource): boolean {
    return (
        sourceDataset != null &&
        sinkDataset != null &&
        copySource != null &&
        sourceDataset instanceof BinaryDataset &&
        sinkDataset instanceof BinaryDataset &&
        !BinaryDataset.COMPRESSION_CODEC.templateValue(sourceDataset) &&
        !BinaryDataset.COMPRESSION_CODEC.templateValue(sinkDataset) &&
        !sourceDataset.compressionCodec &&
        !sinkDataset.compressionCodec &&
        copySource instanceof BinaryCopySource &&
        !(sourceDataset.linkedService instanceof HttpServerLinkedService) &&
        isFolderSource(sourceDataset, copySource)
    );
}

export function supportSkipForbiddenFile(
    sourceDataset: Dataset,
    sinkDataset: Dataset,
    copySource: CopySource
): boolean {
    return (
        sourceDataset != null &&
        sinkDataset != null &&
        copySource != null &&
        sourceDataset instanceof BinaryDataset &&
        sinkDataset instanceof BinaryDataset &&
        !BinaryDataset.COMPRESSION_CODEC.templateValue(sourceDataset) &&
        !BinaryDataset.COMPRESSION_CODEC.templateValue(sinkDataset) &&
        !sourceDataset.compressionCodec &&
        !sinkDataset.compressionCodec &&
        copySource instanceof BinaryCopySource &&
        isFolderSource(sourceDataset, copySource) &&
        sourceDataset.linkedService != null &&
        skipForbiddenFilesSourceLinkedServiceTypes.indexOf(Metamodel.modelOf(sourceDataset.linkedService).name) >= 0
    );
}

export function supportSkipFilesWithInvalidNames(
    sourceDataset: Dataset,
    sinkDataset: Dataset,
    copySource: CopySource
): boolean {
    return (
        sourceDataset != null &&
        sinkDataset != null &&
        copySource != null &&
        sourceDataset instanceof BinaryDataset &&
        sinkDataset instanceof BinaryDataset &&
        !BinaryDataset.COMPRESSION_CODEC.templateValue(sourceDataset) &&
        !BinaryDataset.COMPRESSION_CODEC.templateValue(sinkDataset) &&
        !sourceDataset.compressionCodec &&
        !sinkDataset.compressionCodec &&
        copySource instanceof BinaryCopySource &&
        isFolderSource(sourceDataset, copySource) &&
        ((sourceDataset.linkedService != null &&
            skipFilesWithInvalidNamesSourceLinkedServiceTypes.indexOf(
                Metamodel.modelOf(sourceDataset.linkedService).name
            ) >= 0) ||
            (sinkDataset.linkedService != null &&
                skipFilesWithInvalidNamesSinkLinkedServiceTypes.indexOf(
                    Metamodel.modelOf(sinkDataset.linkedService).name
                ) >= 0))
    );
}

export function isFolderSource(sourceDataset: FormatDatasetV2, copySource: FormatTypeCopySource): boolean {
    if (!copySource.storeSettings) {
        return false;
    }

    if (copySource.storeSettings instanceof BlobTypeStoreReadSettings) {
        return copySource.storeSettings.filePathMode !== FilePathMode.DATASET || sourceDataset.location.isFolder();
    }
    return (
        (Metamodel.modelOf(copySource.storeSettings)?.hasAttribute('wildcardFileName') &&
            (!!Metamodel.modelOf(copySource.storeSettings)
                .attribute('wildcardFileName')
                .value(copySource.storeSettings) ||
                !!Metamodel.modelOf(copySource.storeSettings)
                    .attribute('wildcardFileName')
                    .templateValue(copySource.storeSettings))) ||
        (Metamodel.modelOf(copySource.storeSettings)?.hasAttribute('wildcardFolderPath') &&
            (!!Metamodel.modelOf(copySource.storeSettings)
                .attribute('wildcardFolderPath')
                .value(copySource.storeSettings) ||
                !!Metamodel.modelOf(copySource.storeSettings)
                    .attribute('wildcardFolderPath')
                    .templateValue(copySource.storeSettings))) ||
        sourceDataset.location.isFolder()
    );
}

export function isLakehouseTimestampNtzSupported(
    activity: CopyActivity
): boolean {
    if (activity == null) {
        return false;
    }

    if (
        activity.sinkDataset instanceof LakehouseTableDataset &&
        GlobalVariables.timestampNtz &&
        __IS_FABRIC_DPE__
    ) {
        return activity.sourceDataset &&
            supportedSourceDatasetsForTimestampNtz.indexOf(Metamodel.modelOf(activity.sourceDataset).name) >= 0 &&
            activity.copySink instanceof LakehouseTableCopySink &&
            (
                (activity.copySink as LakehouseTableCopySink).enableTimestampNtz ||
                Metamodel.modelOf(activity.copySink).attribute('enableTimestampNtz')?.templateValue(activity.copySink) != null
            );
    }

    return false;
}
